function A(i, t, e, n) {
  function s(r) {
    return r instanceof e ? r : new e(function(o) {
      o(r);
    });
  }
  return new (e || (e = Promise))(function(r, o) {
    function a(d) {
      try {
        u(n.next(d));
      } catch (h) {
        o(h);
      }
    }
    function c(d) {
      try {
        u(n.throw(d));
      } catch (h) {
        o(h);
      }
    }
    function u(d) {
      d.done ? r(d.value) : s(d.value).then(a, c);
    }
    u((n = n.apply(i, t || [])).next());
  });
}
function qn(i) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && i[t], n = 0;
  if (e) return e.call(i);
  if (i && typeof i.length == "number") return {
    next: function() {
      return i && n >= i.length && (i = void 0), { value: i && i[n++], done: !i };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function O(i) {
  return this instanceof O ? (this.v = i, this) : new O(i);
}
function St(i, t, e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = e.apply(i, t || []), s, r = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", o), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function o(M) {
    return function(W) {
      return Promise.resolve(W).then(M, h);
    };
  }
  function a(M, W) {
    n[M] && (s[M] = function(Xt) {
      return new Promise(function(Yi, jt) {
        r.push([M, Xt, Yi, jt]) > 1 || c(M, Xt);
      });
    }, W && (s[M] = W(s[M])));
  }
  function c(M, W) {
    try {
      u(n[M](W));
    } catch (Xt) {
      k(r[0][3], Xt);
    }
  }
  function u(M) {
    M.value instanceof O ? Promise.resolve(M.value.v).then(d, h) : k(r[0][2], M);
  }
  function d(M) {
    c("next", M);
  }
  function h(M) {
    c("throw", M);
  }
  function k(M, W) {
    M(W), r.shift(), r.length && c(r[0][0], r[0][1]);
  }
}
function si(i) {
  var t, e;
  return t = {}, n("next"), n("throw", function(s) {
    throw s;
  }), n("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function n(s, r) {
    t[s] = i[s] ? function(o) {
      return (e = !e) ? { value: O(i[s](o)), done: !1 } : r ? r(o) : o;
    } : r;
  }
}
function de(i) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = i[Symbol.asyncIterator], e;
  return t ? t.call(i) : (i = typeof qn == "function" ? qn(i) : i[Symbol.iterator](), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function() {
    return this;
  }, e);
  function n(r) {
    e[r] = i[r] && function(o) {
      return new Promise(function(a, c) {
        o = i[r](o), s(a, c, o.done, o.value);
      });
    };
  }
  function s(r, o, a, c) {
    Promise.resolve(c).then(function(u) {
      r({ value: u, done: a });
    }, o);
  }
}
const ta = new TextDecoder("utf-8"), Xi = (i) => ta.decode(i), ea = new TextEncoder(), Ke = (i) => ea.encode(i), ia = (i) => typeof i == "number", na = (i) => typeof i == "boolean", H = (i) => typeof i == "function", ft = (i) => i != null && Object(i) === i, ze = (i) => ft(i) && H(i.then), Ci = (i) => ft(i) && H(i[Symbol.iterator]), fn = (i) => ft(i) && H(i[Symbol.asyncIterator]), tn = (i) => ft(i) && ft(i.schema), As = (i) => ft(i) && "done" in i && "value" in i, Os = (i) => ft(i) && H(i.stat) && ia(i.fd), Fs = (i) => ft(i) && pn(i.body), Ts = (i) => "_getDOMStream" in i && "_getNodeStream" in i, pn = (i) => ft(i) && H(i.cancel) && H(i.getReader) && !Ts(i), Ms = (i) => ft(i) && H(i.read) && H(i.pipe) && na(i.readable) && !Ts(i), sa = (i) => ft(i) && H(i.clear) && H(i.bytes) && H(i.position) && H(i.setPosition) && H(i.capacity) && H(i.getBufferIdentifier) && H(i.createLong), yn = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : ArrayBuffer;
function ra(i) {
  const t = i[0] ? [i[0]] : [];
  let e, n, s, r;
  for (let o, a, c = 0, u = 0, d = i.length; ++c < d; ) {
    if (o = t[u], a = i[c], !o || !a || o.buffer !== a.buffer || a.byteOffset < o.byteOffset) {
      a && (t[++u] = a);
      continue;
    }
    if ({ byteOffset: e, byteLength: s } = o, { byteOffset: n, byteLength: r } = a, e + s < n || n + r < e) {
      a && (t[++u] = a);
      continue;
    }
    t[u] = new Uint8Array(o.buffer, e, n - e + r);
  }
  return t;
}
function en(i, t, e = 0, n = t.byteLength) {
  const s = i.byteLength, r = new Uint8Array(i.buffer, i.byteOffset, s), o = new Uint8Array(t.buffer, t.byteOffset, Math.min(n, s));
  return r.set(o, e), i;
}
function Bt(i, t) {
  const e = ra(i), n = e.reduce((d, h) => d + h.byteLength, 0);
  let s, r, o, a = 0, c = -1;
  const u = Math.min(t || Number.POSITIVE_INFINITY, n);
  for (const d = e.length; ++c < d; ) {
    if (s = e[c], r = s.subarray(0, Math.min(s.length, u - a)), u <= a + r.length) {
      r.length < s.length ? e[c] = s.subarray(r.length) : r.length === s.length && c++, o ? en(o, r, a) : o = r;
      break;
    }
    en(o || (o = new Uint8Array(u)), r, a), a += r.length;
  }
  return [o || new Uint8Array(0), e.slice(c), n - (o ? o.byteLength : 0)];
}
function C(i, t) {
  let e = As(t) ? t.value : t;
  return e instanceof i ? i === Uint8Array ? new i(e.buffer, e.byteOffset, e.byteLength) : e : e ? (typeof e == "string" && (e = Ke(e)), e instanceof ArrayBuffer ? new i(e) : e instanceof yn ? new i(e) : sa(e) ? C(i, e.bytes()) : ArrayBuffer.isView(e) ? e.byteLength <= 0 ? new i(0) : new i(e.buffer, e.byteOffset, e.byteLength / i.BYTES_PER_ELEMENT) : i.from(e)) : new i(0);
}
const Te = (i) => C(Int32Array, i), Qn = (i) => C(BigInt64Array, i), T = (i) => C(Uint8Array, i), nn = (i) => (i.next(), i);
function* oa(i, t) {
  const e = function* (s) {
    yield s;
  }, n = typeof t == "string" || ArrayBuffer.isView(t) || t instanceof ArrayBuffer || t instanceof yn ? e(t) : Ci(t) ? t : e(t);
  return yield* nn((function* (s) {
    let r = null;
    do
      r = s.next(yield C(i, r));
    while (!r.done);
  })(n[Symbol.iterator]())), new i();
}
const aa = (i) => oa(Uint8Array, i);
function Ls(i, t) {
  return St(this, arguments, function* () {
    if (ze(t))
      return yield O(yield O(yield* si(de(Ls(i, yield O(t))))));
    const n = function(o) {
      return St(this, arguments, function* () {
        yield yield O(yield O(o));
      });
    }, s = function(o) {
      return St(this, arguments, function* () {
        yield O(yield* si(de(nn((function* (a) {
          let c = null;
          do
            c = a.next(yield c?.value);
          while (!c.done);
        })(o[Symbol.iterator]())))));
      });
    }, r = typeof t == "string" || ArrayBuffer.isView(t) || t instanceof ArrayBuffer || t instanceof yn ? n(t) : Ci(t) ? s(t) : fn(t) ? t : n(t);
    return yield O(
      // otherwise if AsyncIterable, use it
      yield* si(de(nn((function(o) {
        return St(this, arguments, function* () {
          let a = null;
          do
            a = yield O(o.next(yield yield O(C(i, a))));
          while (!a.done);
        });
      })(r[Symbol.asyncIterator]()))))
    ), yield O(new i());
  });
}
const ca = (i) => Ls(Uint8Array, i);
function la(i, t) {
  let e = 0;
  const n = i.length;
  if (n !== t.length)
    return !1;
  if (n > 0)
    do
      if (i[e] !== t[e])
        return !1;
    while (++e < n);
  return !0;
}
const rt = {
  fromIterable(i) {
    return ei(ua(i));
  },
  fromAsyncIterable(i) {
    return ei(da(i));
  },
  fromDOMStream(i) {
    return ei(ha(i));
  },
  fromNodeStream(i) {
    return ei(pa(i));
  },
  // @ts-ignore
  toDOMStream(i, t) {
    throw new Error('"toDOMStream" not available in this environment');
  },
  // @ts-ignore
  toNodeStream(i, t) {
    throw new Error('"toNodeStream" not available in this environment');
  }
}, ei = (i) => (i.next(), i);
function* ua(i) {
  let t, e = !1, n = [], s, r, o, a = 0;
  function c() {
    return r === "peek" ? Bt(n, o)[0] : ([s, n, a] = Bt(n, o), s);
  }
  ({ cmd: r, size: o } = (yield null) || { cmd: "read", size: 0 });
  const u = aa(i)[Symbol.iterator]();
  try {
    do
      if ({ done: t, value: s } = Number.isNaN(o - a) ? u.next() : u.next(o - a), !t && s.byteLength > 0 && (n.push(s), a += s.byteLength), t || o <= a)
        do
          ({ cmd: r, size: o } = yield c());
        while (o < a);
    while (!t);
  } catch (d) {
    (e = !0) && typeof u.throw == "function" && u.throw(d);
  } finally {
    e === !1 && typeof u.return == "function" && u.return(null);
  }
  return null;
}
function da(i) {
  return St(this, arguments, function* () {
    let e, n = !1, s = [], r, o, a, c = 0;
    function u() {
      return o === "peek" ? Bt(s, a)[0] : ([r, s, c] = Bt(s, a), r);
    }
    ({ cmd: o, size: a } = (yield yield O(null)) || { cmd: "read", size: 0 });
    const d = ca(i)[Symbol.asyncIterator]();
    try {
      do
        if ({ done: e, value: r } = Number.isNaN(a - c) ? yield O(d.next()) : yield O(d.next(a - c)), !e && r.byteLength > 0 && (s.push(r), c += r.byteLength), e || a <= c)
          do
            ({ cmd: o, size: a } = yield yield O(u()));
          while (a < c);
      while (!e);
    } catch (h) {
      (n = !0) && typeof d.throw == "function" && (yield O(d.throw(h)));
    } finally {
      n === !1 && typeof d.return == "function" && (yield O(d.return(new Uint8Array(0))));
    }
    return yield O(null);
  });
}
function ha(i) {
  return St(this, arguments, function* () {
    let e = !1, n = !1, s = [], r, o, a, c = 0;
    function u() {
      return o === "peek" ? Bt(s, a)[0] : ([r, s, c] = Bt(s, a), r);
    }
    ({ cmd: o, size: a } = (yield yield O(null)) || { cmd: "read", size: 0 });
    const d = new fa(i);
    try {
      do
        if ({ done: e, value: r } = Number.isNaN(a - c) ? yield O(d.read()) : yield O(d.read(a - c)), !e && r.byteLength > 0 && (s.push(T(r)), c += r.byteLength), e || a <= c)
          do
            ({ cmd: o, size: a } = yield yield O(u()));
          while (a < c);
      while (!e);
    } catch (h) {
      (n = !0) && (yield O(d.cancel(h)));
    } finally {
      n === !1 ? yield O(d.cancel()) : i.locked && d.releaseLock();
    }
    return yield O(null);
  });
}
class fa {
  constructor(t) {
    this.source = t, this.reader = null, this.reader = this.source.getReader(), this.reader.closed.catch(() => {
    });
  }
  get closed() {
    return this.reader ? this.reader.closed.catch(() => {
    }) : Promise.resolve();
  }
  releaseLock() {
    this.reader && this.reader.releaseLock(), this.reader = null;
  }
  cancel(t) {
    return A(this, void 0, void 0, function* () {
      const { reader: e, source: n } = this;
      e && (yield e.cancel(t).catch(() => {
      })), n && n.locked && this.releaseLock();
    });
  }
  read(t) {
    return A(this, void 0, void 0, function* () {
      if (t === 0)
        return { done: this.reader == null, value: new Uint8Array(0) };
      const e = yield this.reader.read();
      return !e.done && (e.value = T(e)), e;
    });
  }
}
const Ji = (i, t) => {
  const e = (s) => n([t, s]);
  let n;
  return [t, e, new Promise((s) => (n = s) && i.once(t, e))];
};
function pa(i) {
  return St(this, arguments, function* () {
    const e = [];
    let n = "error", s = !1, r = null, o, a, c = 0, u = [], d;
    function h() {
      return o === "peek" ? Bt(u, a)[0] : ([d, u, c] = Bt(u, a), d);
    }
    if ({ cmd: o, size: a } = (yield yield O(null)) || { cmd: "read", size: 0 }, i.isTTY)
      return yield yield O(new Uint8Array(0)), yield O(null);
    try {
      e[0] = Ji(i, "end"), e[1] = Ji(i, "error");
      do {
        if (e[2] = Ji(i, "readable"), [n, r] = yield O(Promise.race(e.map((M) => M[2]))), n === "error")
          break;
        if ((s = n === "end") || (Number.isFinite(a - c) ? (d = T(i.read(a - c)), d.byteLength < a - c && (d = T(i.read()))) : d = T(i.read()), d.byteLength > 0 && (u.push(d), c += d.byteLength)), s || a <= c)
          do
            ({ cmd: o, size: a } = yield yield O(h()));
          while (a < c);
      } while (!s);
    } finally {
      yield O(k(e, n === "error" ? r : null));
    }
    return yield O(null);
    function k(M, W) {
      return d = u = null, new Promise((Xt, Yi) => {
        for (const [jt, Xo] of M)
          i.off(jt, Xo);
        try {
          const jt = i.destroy;
          jt && jt.call(i, W), W = void 0;
        } catch (jt) {
          W = jt || W;
        } finally {
          W != null ? Yi(W) : Xt();
        }
      });
    }
  });
}
var P;
(function(i) {
  i[i.V1 = 0] = "V1", i[i.V2 = 1] = "V2", i[i.V3 = 2] = "V3", i[i.V4 = 3] = "V4", i[i.V5 = 4] = "V5";
})(P || (P = {}));
var q;
(function(i) {
  i[i.Sparse = 0] = "Sparse", i[i.Dense = 1] = "Dense";
})(q || (q = {}));
var Y;
(function(i) {
  i[i.HALF = 0] = "HALF", i[i.SINGLE = 1] = "SINGLE", i[i.DOUBLE = 2] = "DOUBLE";
})(Y || (Y = {}));
var ct;
(function(i) {
  i[i.DAY = 0] = "DAY", i[i.MILLISECOND = 1] = "MILLISECOND";
})(ct || (ct = {}));
var p;
(function(i) {
  i[i.SECOND = 0] = "SECOND", i[i.MILLISECOND = 1] = "MILLISECOND", i[i.MICROSECOND = 2] = "MICROSECOND", i[i.NANOSECOND = 3] = "NANOSECOND";
})(p || (p = {}));
var Dt;
(function(i) {
  i[i.YEAR_MONTH = 0] = "YEAR_MONTH", i[i.DAY_TIME = 1] = "DAY_TIME", i[i.MONTH_DAY_NANO = 2] = "MONTH_DAY_NANO";
})(Dt || (Dt = {}));
const Hi = 2, vt = 4, Tt = 4, V = 4, $t = new Int32Array(2), Xn = new Float32Array($t.buffer), ts = new Float64Array($t.buffer), ii = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
var sn;
(function(i) {
  i[i.UTF8_BYTES = 1] = "UTF8_BYTES", i[i.UTF16_STRING = 2] = "UTF16_STRING";
})(sn || (sn = {}));
let ge = class Ns {
  /**
   * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
   */
  constructor(t) {
    this.bytes_ = t, this.position_ = 0, this.text_decoder_ = new TextDecoder();
  }
  /**
   * Create and allocate a new ByteBuffer with a given size.
   */
  static allocate(t) {
    return new Ns(new Uint8Array(t));
  }
  clear() {
    this.position_ = 0;
  }
  /**
   * Get the underlying `Uint8Array`.
   */
  bytes() {
    return this.bytes_;
  }
  /**
   * Get the buffer's position.
   */
  position() {
    return this.position_;
  }
  /**
   * Set the buffer's position.
   */
  setPosition(t) {
    this.position_ = t;
  }
  /**
   * Get the buffer's capacity.
   */
  capacity() {
    return this.bytes_.length;
  }
  readInt8(t) {
    return this.readUint8(t) << 24 >> 24;
  }
  readUint8(t) {
    return this.bytes_[t];
  }
  readInt16(t) {
    return this.readUint16(t) << 16 >> 16;
  }
  readUint16(t) {
    return this.bytes_[t] | this.bytes_[t + 1] << 8;
  }
  readInt32(t) {
    return this.bytes_[t] | this.bytes_[t + 1] << 8 | this.bytes_[t + 2] << 16 | this.bytes_[t + 3] << 24;
  }
  readUint32(t) {
    return this.readInt32(t) >>> 0;
  }
  readInt64(t) {
    return BigInt.asIntN(64, BigInt(this.readUint32(t)) + (BigInt(this.readUint32(t + 4)) << BigInt(32)));
  }
  readUint64(t) {
    return BigInt.asUintN(64, BigInt(this.readUint32(t)) + (BigInt(this.readUint32(t + 4)) << BigInt(32)));
  }
  readFloat32(t) {
    return $t[0] = this.readInt32(t), Xn[0];
  }
  readFloat64(t) {
    return $t[ii ? 0 : 1] = this.readInt32(t), $t[ii ? 1 : 0] = this.readInt32(t + 4), ts[0];
  }
  writeInt8(t, e) {
    this.bytes_[t] = e;
  }
  writeUint8(t, e) {
    this.bytes_[t] = e;
  }
  writeInt16(t, e) {
    this.bytes_[t] = e, this.bytes_[t + 1] = e >> 8;
  }
  writeUint16(t, e) {
    this.bytes_[t] = e, this.bytes_[t + 1] = e >> 8;
  }
  writeInt32(t, e) {
    this.bytes_[t] = e, this.bytes_[t + 1] = e >> 8, this.bytes_[t + 2] = e >> 16, this.bytes_[t + 3] = e >> 24;
  }
  writeUint32(t, e) {
    this.bytes_[t] = e, this.bytes_[t + 1] = e >> 8, this.bytes_[t + 2] = e >> 16, this.bytes_[t + 3] = e >> 24;
  }
  writeInt64(t, e) {
    this.writeInt32(t, Number(BigInt.asIntN(32, e))), this.writeInt32(t + 4, Number(BigInt.asIntN(32, e >> BigInt(32))));
  }
  writeUint64(t, e) {
    this.writeUint32(t, Number(BigInt.asUintN(32, e))), this.writeUint32(t + 4, Number(BigInt.asUintN(32, e >> BigInt(32))));
  }
  writeFloat32(t, e) {
    Xn[0] = e, this.writeInt32(t, $t[0]);
  }
  writeFloat64(t, e) {
    ts[0] = e, this.writeInt32(t, $t[ii ? 0 : 1]), this.writeInt32(t + 4, $t[ii ? 1 : 0]);
  }
  /**
   * Return the file identifier.   Behavior is undefined for FlatBuffers whose
   * schema does not include a file_identifier (likely points at padding or the
   * start of a the root vtable).
   */
  getBufferIdentifier() {
    if (this.bytes_.length < this.position_ + vt + Tt)
      throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
    let t = "";
    for (let e = 0; e < Tt; e++)
      t += String.fromCharCode(this.readInt8(this.position_ + vt + e));
    return t;
  }
  /**
   * Look up a field in the vtable, return an offset into the object, or 0 if the
   * field is not present.
   */
  __offset(t, e) {
    const n = t - this.readInt32(t);
    return e < this.readInt16(n) ? this.readInt16(n + e) : 0;
  }
  /**
   * Initialize any Table-derived type to point to the union at the given offset.
   */
  __union(t, e) {
    return t.bb_pos = e + this.readInt32(e), t.bb = this, t;
  }
  /**
   * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
   * This allocates a new string and converts to wide chars upon each access.
   *
   * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
   * "optionalEncoding" argument. This is useful for avoiding conversion when
   * the data will just be packaged back up in another FlatBuffer later on.
   *
   * @param offset
   * @param opt_encoding Defaults to UTF16_STRING
   */
  __string(t, e) {
    t += this.readInt32(t);
    const n = this.readInt32(t);
    t += vt;
    const s = this.bytes_.subarray(t, t + n);
    return e === sn.UTF8_BYTES ? s : this.text_decoder_.decode(s);
  }
  /**
   * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
   * if a string then return a new one
   *
   * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
   * makes the behaviour of __union_with_string different compared to __union
   */
  __union_with_string(t, e) {
    return typeof t == "string" ? this.__string(e) : this.__union(t, e);
  }
  /**
   * Retrieve the relative offset stored at "offset"
   */
  __indirect(t) {
    return t + this.readInt32(t);
  }
  /**
   * Get the start of data of a vector whose offset is stored at "offset" in this object.
   */
  __vector(t) {
    return t + this.readInt32(t) + vt;
  }
  /**
   * Get the length of a vector whose offset is stored at "offset" in this object.
   */
  __vector_len(t) {
    return this.readInt32(t + this.readInt32(t));
  }
  __has_identifier(t) {
    if (t.length != Tt)
      throw new Error("FlatBuffers: file identifier must be length " + Tt);
    for (let e = 0; e < Tt; e++)
      if (t.charCodeAt(e) != this.readInt8(this.position() + vt + e))
        return !1;
    return !0;
  }
  /**
   * A helper function for generating list for obj api
   */
  createScalarList(t, e) {
    const n = [];
    for (let s = 0; s < e; ++s) {
      const r = t(s);
      r !== null && n.push(r);
    }
    return n;
  }
  /**
   * A helper function for generating list for obj api
   * @param listAccessor function that accepts an index and return data at that index
   * @param listLength listLength
   * @param res result list
   */
  createObjList(t, e) {
    const n = [];
    for (let s = 0; s < e; ++s) {
      const r = t(s);
      r !== null && n.push(r.unpack());
    }
    return n;
  }
}, Us = class xs {
  /**
   * Create a FlatBufferBuilder.
   */
  constructor(t) {
    this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null, this.text_encoder = new TextEncoder();
    let e;
    t ? e = t : e = 1024, this.bb = ge.allocate(e), this.space = e;
  }
  clear() {
    this.bb.clear(), this.space = this.bb.capacity(), this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null;
  }
  /**
   * In order to save space, fields that are set to their default value
   * don't get serialized into the buffer. Forcing defaults provides a
   * way to manually disable this optimization.
   *
   * @param forceDefaults true always serializes default values
   */
  forceDefaults(t) {
    this.force_defaults = t;
  }
  /**
   * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
   * called finish(). The actual data starts at the ByteBuffer's current position,
   * not necessarily at 0.
   */
  dataBuffer() {
    return this.bb;
  }
  /**
   * Get the bytes representing the FlatBuffer. Only call this after you've
   * called finish().
   */
  asUint8Array() {
    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
  }
  /**
   * Prepare to write an element of `size` after `additional_bytes` have been
   * written, e.g. if you write a string, you need to align such the int length
   * field is aligned to 4 bytes, and the string data follows it directly. If all
   * you need to do is alignment, `additional_bytes` will be 0.
   *
   * @param size This is the of the new element to write
   * @param additional_bytes The padding size
   */
  prep(t, e) {
    t > this.minalign && (this.minalign = t);
    const n = ~(this.bb.capacity() - this.space + e) + 1 & t - 1;
    for (; this.space < n + t + e; ) {
      const s = this.bb.capacity();
      this.bb = xs.growByteBuffer(this.bb), this.space += this.bb.capacity() - s;
    }
    this.pad(n);
  }
  pad(t) {
    for (let e = 0; e < t; e++)
      this.bb.writeInt8(--this.space, 0);
  }
  writeInt8(t) {
    this.bb.writeInt8(this.space -= 1, t);
  }
  writeInt16(t) {
    this.bb.writeInt16(this.space -= 2, t);
  }
  writeInt32(t) {
    this.bb.writeInt32(this.space -= 4, t);
  }
  writeInt64(t) {
    this.bb.writeInt64(this.space -= 8, t);
  }
  writeFloat32(t) {
    this.bb.writeFloat32(this.space -= 4, t);
  }
  writeFloat64(t) {
    this.bb.writeFloat64(this.space -= 8, t);
  }
  /**
   * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int8` to add the buffer.
   */
  addInt8(t) {
    this.prep(1, 0), this.writeInt8(t);
  }
  /**
   * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int16` to add the buffer.
   */
  addInt16(t) {
    this.prep(2, 0), this.writeInt16(t);
  }
  /**
   * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int32` to add the buffer.
   */
  addInt32(t) {
    this.prep(4, 0), this.writeInt32(t);
  }
  /**
   * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int64` to add the buffer.
   */
  addInt64(t) {
    this.prep(8, 0), this.writeInt64(t);
  }
  /**
   * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float32` to add the buffer.
   */
  addFloat32(t) {
    this.prep(4, 0), this.writeFloat32(t);
  }
  /**
   * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float64` to add the buffer.
   */
  addFloat64(t) {
    this.prep(8, 0), this.writeFloat64(t);
  }
  addFieldInt8(t, e, n) {
    (this.force_defaults || e != n) && (this.addInt8(e), this.slot(t));
  }
  addFieldInt16(t, e, n) {
    (this.force_defaults || e != n) && (this.addInt16(e), this.slot(t));
  }
  addFieldInt32(t, e, n) {
    (this.force_defaults || e != n) && (this.addInt32(e), this.slot(t));
  }
  addFieldInt64(t, e, n) {
    (this.force_defaults || e !== n) && (this.addInt64(e), this.slot(t));
  }
  addFieldFloat32(t, e, n) {
    (this.force_defaults || e != n) && (this.addFloat32(e), this.slot(t));
  }
  addFieldFloat64(t, e, n) {
    (this.force_defaults || e != n) && (this.addFloat64(e), this.slot(t));
  }
  addFieldOffset(t, e, n) {
    (this.force_defaults || e != n) && (this.addOffset(e), this.slot(t));
  }
  /**
   * Structs are stored inline, so nothing additional is being added. `d` is always 0.
   */
  addFieldStruct(t, e, n) {
    e != n && (this.nested(e), this.slot(t));
  }
  /**
   * Structures are always stored inline, they need to be created right
   * where they're used.  You'll get this assertion failure if you
   * created it elsewhere.
   */
  nested(t) {
    if (t != this.offset())
      throw new TypeError("FlatBuffers: struct must be serialized inline.");
  }
  /**
   * Should not be creating any other object, string or vector
   * while an object is being constructed
   */
  notNested() {
    if (this.isNested)
      throw new TypeError("FlatBuffers: object serialization must not be nested.");
  }
  /**
   * Set the current vtable at `voffset` to the current location in the buffer.
   */
  slot(t) {
    this.vtable !== null && (this.vtable[t] = this.offset());
  }
  /**
   * @returns Offset relative to the end of the buffer.
   */
  offset() {
    return this.bb.capacity() - this.space;
  }
  /**
   * Doubles the size of the backing ByteBuffer and copies the old data towards
   * the end of the new buffer (since we build the buffer backwards).
   *
   * @param bb The current buffer with the existing data
   * @returns A new byte buffer with the old data copied
   * to it. The data is located at the end of the buffer.
   *
   * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
   * it a uint8Array we need to suppress the type check:
   * @suppress {checkTypes}
   */
  static growByteBuffer(t) {
    const e = t.capacity();
    if (e & 3221225472)
      throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
    const n = e << 1, s = ge.allocate(n);
    return s.setPosition(n - e), s.bytes().set(t.bytes(), n - e), s;
  }
  /**
   * Adds on offset, relative to where it will be written.
   *
   * @param offset The offset to add.
   */
  addOffset(t) {
    this.prep(vt, 0), this.writeInt32(this.offset() - t + vt);
  }
  /**
   * Start encoding a new object in the buffer.  Users will not usually need to
   * call this directly. The FlatBuffers compiler will generate helper methods
   * that call this method internally.
   */
  startObject(t) {
    this.notNested(), this.vtable == null && (this.vtable = []), this.vtable_in_use = t;
    for (let e = 0; e < t; e++)
      this.vtable[e] = 0;
    this.isNested = !0, this.object_start = this.offset();
  }
  /**
   * Finish off writing the object that is under construction.
   *
   * @returns The offset to the object inside `dataBuffer`
   */
  endObject() {
    if (this.vtable == null || !this.isNested)
      throw new Error("FlatBuffers: endObject called without startObject");
    this.addInt32(0);
    const t = this.offset();
    let e = this.vtable_in_use - 1;
    for (; e >= 0 && this.vtable[e] == 0; e--)
      ;
    const n = e + 1;
    for (; e >= 0; e--)
      this.addInt16(this.vtable[e] != 0 ? t - this.vtable[e] : 0);
    const s = 2;
    this.addInt16(t - this.object_start);
    const r = (n + s) * Hi;
    this.addInt16(r);
    let o = 0;
    const a = this.space;
    t: for (e = 0; e < this.vtables.length; e++) {
      const c = this.bb.capacity() - this.vtables[e];
      if (r == this.bb.readInt16(c)) {
        for (let u = Hi; u < r; u += Hi)
          if (this.bb.readInt16(a + u) != this.bb.readInt16(c + u))
            continue t;
        o = this.vtables[e];
        break;
      }
    }
    return o ? (this.space = this.bb.capacity() - t, this.bb.writeInt32(this.space, o - t)) : (this.vtables.push(this.offset()), this.bb.writeInt32(this.bb.capacity() - t, this.offset() - t)), this.isNested = !1, t;
  }
  /**
   * Finalize a buffer, poiting to the given `root_table`.
   */
  finish(t, e, n) {
    const s = n ? V : 0;
    if (e) {
      const r = e;
      if (this.prep(this.minalign, vt + Tt + s), r.length != Tt)
        throw new TypeError("FlatBuffers: file identifier must be length " + Tt);
      for (let o = Tt - 1; o >= 0; o--)
        this.writeInt8(r.charCodeAt(o));
    }
    this.prep(this.minalign, vt + s), this.addOffset(t), s && this.addInt32(this.bb.capacity() - this.space), this.bb.setPosition(this.space);
  }
  /**
   * Finalize a size prefixed buffer, pointing to the given `root_table`.
   */
  finishSizePrefixed(t, e) {
    this.finish(t, e, !0);
  }
  /**
   * This checks a required field has been set in a given table that has
   * just been constructed.
   */
  requiredField(t, e) {
    const n = this.bb.capacity() - t, s = n - this.bb.readInt32(n);
    if (!(e < this.bb.readInt16(s) && this.bb.readInt16(s + e) != 0))
      throw new TypeError("FlatBuffers: field " + e + " must be set");
  }
  /**
   * Start a new array/vector of objects.  Users usually will not call
   * this directly. The FlatBuffers compiler will create a start/end
   * method for vector types in generated code.
   *
   * @param elem_size The size of each element in the array
   * @param num_elems The number of elements in the array
   * @param alignment The alignment of the array
   */
  startVector(t, e, n) {
    this.notNested(), this.vector_num_elems = e, this.prep(vt, t * e), this.prep(n, t * e);
  }
  /**
   * Finish off the creation of an array and all its elements. The array must be
   * created with `startVector`.
   *
   * @returns The offset at which the newly created array
   * starts.
   */
  endVector() {
    return this.writeInt32(this.vector_num_elems), this.offset();
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If the string passed has
   * already been seen, we return the offset of the already written string
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createSharedString(t) {
    if (!t)
      return 0;
    if (this.string_maps || (this.string_maps = /* @__PURE__ */ new Map()), this.string_maps.has(t))
      return this.string_maps.get(t);
    const e = this.createString(t);
    return this.string_maps.set(t, e), e;
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
   * instead of a string, it is assumed to contain valid UTF-8 encoded data.
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createString(t) {
    if (t == null)
      return 0;
    let e;
    return t instanceof Uint8Array ? e = t : e = this.text_encoder.encode(t), this.addInt8(0), this.startVector(1, e.length, 1), this.bb.setPosition(this.space -= e.length), this.bb.bytes().set(e, this.space), this.endVector();
  }
  /**
   * Create a byte vector.
   *
   * @param v The bytes to add
   * @returns The offset in the buffer where the byte vector starts
   */
  createByteVector(t) {
    return t == null ? 0 : (this.startVector(1, t.length, 1), this.bb.setPosition(this.space -= t.length), this.bb.bytes().set(t, this.space), this.endVector());
  }
  /**
   * A helper function to pack an object
   *
   * @returns offset of obj
   */
  createObjectOffset(t) {
    return t === null ? 0 : typeof t == "string" ? this.createString(t) : t.pack(this);
  }
  /**
   * A helper function to pack a list of object
   *
   * @returns list of offsets of each non null object
   */
  createObjectOffsetList(t) {
    const e = [];
    for (let n = 0; n < t.length; ++n) {
      const s = t[n];
      if (s !== null)
        e.push(this.createObjectOffset(s));
      else
        throw new TypeError("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
    }
    return e;
  }
  createStructOffsetList(t, e) {
    return e(this, t.length), this.createObjectOffsetList(t.slice().reverse()), this.endVector();
  }
};
var pi;
(function(i) {
  i[i.BUFFER = 0] = "BUFFER";
})(pi || (pi = {}));
var yi;
(function(i) {
  i[i.LZ4_FRAME = 0] = "LZ4_FRAME", i[i.ZSTD = 1] = "ZSTD";
})(yi || (yi = {}));
class Wt {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsBodyCompression(t, e) {
    return (e || new Wt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBodyCompression(t, e) {
    return t.setPosition(t.position() + V), (e || new Wt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Compressor library.
   * For LZ4_FRAME, each compressed buffer must consist of a single frame.
   */
  codec() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt8(this.bb_pos + t) : yi.LZ4_FRAME;
  }
  /**
   * Indicates the way the record batch body was compressed
   */
  method() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readInt8(this.bb_pos + t) : pi.BUFFER;
  }
  static startBodyCompression(t) {
    t.startObject(2);
  }
  static addCodec(t, e) {
    t.addFieldInt8(0, e, yi.LZ4_FRAME);
  }
  static addMethod(t, e) {
    t.addFieldInt8(1, e, pi.BUFFER);
  }
  static endBodyCompression(t) {
    return t.endObject();
  }
  static createBodyCompression(t, e, n) {
    return Wt.startBodyCompression(t), Wt.addCodec(t, e), Wt.addMethod(t, n), Wt.endBodyCompression(t);
  }
}
class Vs {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  /**
   * The relative offset into the shared memory page where the bytes for this
   * buffer starts
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The absolute length (in bytes) of the memory buffer. The memory is found
   * from offset (inclusive) to offset + length (non-inclusive). When building
   * messages using the encapsulated IPC message, padding bytes may be written
   * after a buffer, but such padding bytes do not need to be accounted for in
   * the size here.
   */
  length() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createBuffer(t, e, n) {
    return t.prep(8, 16), t.writeInt64(BigInt(n ?? 0)), t.writeInt64(BigInt(e ?? 0)), t.offset();
  }
}
let Rs = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  /**
   * The number of value slots in the Arrow array at this level of a nested
   * tree
   */
  length() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The number of observed nulls. Fields with null_count == 0 may choose not
   * to write their physical validity bitmap out as a materialized buffer,
   * instead setting the length of the bitmap buffer to 0.
   */
  nullCount() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createFieldNode(t, e, n) {
    return t.prep(8, 16), t.writeInt64(BigInt(n ?? 0)), t.writeInt64(BigInt(e ?? 0)), t.offset();
  }
}, Ot = class rn {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsRecordBatch(t, e) {
    return (e || new rn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsRecordBatch(t, e) {
    return t.setPosition(t.position() + V), (e || new rn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * number of records / rows. The arrays in the batch should all have this
   * length
   */
  length() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  /**
   * Nodes correspond to the pre-ordered flattened logical schema
   */
  nodes(t, e) {
    const n = this.bb.__offset(this.bb_pos, 6);
    return n ? (e || new Rs()).__init(this.bb.__vector(this.bb_pos + n) + t * 16, this.bb) : null;
  }
  nodesLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * Buffers correspond to the pre-ordered flattened buffer tree
   *
   * The number of buffers appended to this list depends on the schema. For
   * example, most primitive arrays will have 2 buffers, 1 for the validity
   * bitmap and 1 for the values. For struct arrays, there will only be a
   * single buffer for the validity (nulls) bitmap
   */
  buffers(t, e) {
    const n = this.bb.__offset(this.bb_pos, 8);
    return n ? (e || new Vs()).__init(this.bb.__vector(this.bb_pos + n) + t * 16, this.bb) : null;
  }
  buffersLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * Optional compression of the message body
   */
  compression(t) {
    const e = this.bb.__offset(this.bb_pos, 10);
    return e ? (t || new Wt()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  static startRecordBatch(t) {
    t.startObject(4);
  }
  static addLength(t, e) {
    t.addFieldInt64(0, e, BigInt("0"));
  }
  static addNodes(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static startNodesVector(t, e) {
    t.startVector(16, e, 8);
  }
  static addBuffers(t, e) {
    t.addFieldOffset(2, e, 0);
  }
  static startBuffersVector(t, e) {
    t.startVector(16, e, 8);
  }
  static addCompression(t, e) {
    t.addFieldOffset(3, e, 0);
  }
  static endRecordBatch(t) {
    return t.endObject();
  }
}, ee = class on {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDictionaryBatch(t, e) {
    return (e || new on()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDictionaryBatch(t, e) {
    return t.setPosition(t.position() + V), (e || new on()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  id() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  data(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? (t || new Ot()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  /**
   * If isDelta is true the values in the dictionary are to be appended to a
   * dictionary with the indicated id. If isDelta is false this dictionary
   * should replace the existing dictionary.
   */
  isDelta() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  static startDictionaryBatch(t) {
    t.startObject(3);
  }
  static addId(t, e) {
    t.addFieldInt64(0, e, BigInt("0"));
  }
  static addData(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static addIsDelta(t, e) {
    t.addFieldInt8(2, +e, 0);
  }
  static endDictionaryBatch(t) {
    return t.endObject();
  }
};
var me;
(function(i) {
  i[i.Little = 0] = "Little", i[i.Big = 1] = "Big";
})(me || (me = {}));
var gi;
(function(i) {
  i[i.DenseArray = 0] = "DenseArray";
})(gi || (gi = {}));
class it {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsInt(t, e) {
    return (e || new it()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsInt(t, e) {
    return t.setPosition(t.position() + V), (e || new it()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  bitWidth() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  isSigned() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  static startInt(t) {
    t.startObject(2);
  }
  static addBitWidth(t, e) {
    t.addFieldInt32(0, e, 0);
  }
  static addIsSigned(t, e) {
    t.addFieldInt8(1, +e, 0);
  }
  static endInt(t) {
    return t.endObject();
  }
  static createInt(t, e, n) {
    return it.startInt(t), it.addBitWidth(t, e), it.addIsSigned(t, n), it.endInt(t);
  }
}
class Mt {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDictionaryEncoding(t, e) {
    return (e || new Mt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDictionaryEncoding(t, e) {
    return t.setPosition(t.position() + V), (e || new Mt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * The known dictionary id in the application where this data is used. In
   * the file or streaming formats, the dictionary ids are found in the
   * DictionaryBatch messages
   */
  id() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  /**
   * The dictionary indices are constrained to be non-negative integers. If
   * this field is null, the indices must be signed int32. To maximize
   * cross-language compatibility and performance, implementations are
   * recommended to prefer signed integer types over unsigned integer types
   * and to avoid uint64 indices unless they are required by an application.
   */
  indexType(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? (t || new it()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  /**
   * By default, dictionaries are not ordered, or the order does not have
   * semantic meaning. In some statistical, applications, dictionary-encoding
   * is used to represent ordered categorical data, and we provide a way to
   * preserve that metadata here
   */
  isOrdered() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  dictionaryKind() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.readInt16(this.bb_pos + t) : gi.DenseArray;
  }
  static startDictionaryEncoding(t) {
    t.startObject(4);
  }
  static addId(t, e) {
    t.addFieldInt64(0, e, BigInt("0"));
  }
  static addIndexType(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static addIsOrdered(t, e) {
    t.addFieldInt8(2, +e, 0);
  }
  static addDictionaryKind(t, e) {
    t.addFieldInt16(3, e, gi.DenseArray);
  }
  static endDictionaryEncoding(t) {
    return t.endObject();
  }
}
class $ {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsKeyValue(t, e) {
    return (e || new $()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsKeyValue(t, e) {
    return t.setPosition(t.position() + V), (e || new $()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  key(t) {
    const e = this.bb.__offset(this.bb_pos, 4);
    return e ? this.bb.__string(this.bb_pos + e, t) : null;
  }
  value(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? this.bb.__string(this.bb_pos + e, t) : null;
  }
  static startKeyValue(t) {
    t.startObject(2);
  }
  static addKey(t, e) {
    t.addFieldOffset(0, e, 0);
  }
  static addValue(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static endKeyValue(t) {
    return t.endObject();
  }
  static createKeyValue(t, e, n) {
    return $.startKeyValue(t), $.addKey(t, e), $.addValue(t, n), $.endKeyValue(t);
  }
}
let es = class Me {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsBinary(t, e) {
    return (e || new Me()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBinary(t, e) {
    return t.setPosition(t.position() + V), (e || new Me()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startBinary(t) {
    t.startObject(0);
  }
  static endBinary(t) {
    return t.endObject();
  }
  static createBinary(t) {
    return Me.startBinary(t), Me.endBinary(t);
  }
}, is = class Le {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsBool(t, e) {
    return (e || new Le()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBool(t, e) {
    return t.setPosition(t.position() + V), (e || new Le()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startBool(t) {
    t.startObject(0);
  }
  static endBool(t) {
    return t.endObject();
  }
  static createBool(t) {
    return Le.startBool(t), Le.endBool(t);
  }
}, ri = class ie {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDate(t, e) {
    return (e || new ie()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDate(t, e) {
    return t.setPosition(t.position() + V), (e || new ie()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : ct.MILLISECOND;
  }
  static startDate(t) {
    t.startObject(1);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, ct.MILLISECOND);
  }
  static endDate(t) {
    return t.endObject();
  }
  static createDate(t, e) {
    return ie.startDate(t), ie.addUnit(t, e), ie.endDate(t);
  }
}, ne = class Pt {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDecimal(t, e) {
    return (e || new Pt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDecimal(t, e) {
    return t.setPosition(t.position() + V), (e || new Pt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Total number of decimal digits
   */
  precision() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  /**
   * Number of digits after the decimal point "."
   */
  scale() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  /**
   * Number of bits per value. The only accepted widths are 128 and 256.
   * We use bitWidth for consistency with Int::bitWidth.
   */
  bitWidth() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.readInt32(this.bb_pos + t) : 128;
  }
  static startDecimal(t) {
    t.startObject(3);
  }
  static addPrecision(t, e) {
    t.addFieldInt32(0, e, 0);
  }
  static addScale(t, e) {
    t.addFieldInt32(1, e, 0);
  }
  static addBitWidth(t, e) {
    t.addFieldInt32(2, e, 128);
  }
  static endDecimal(t) {
    return t.endObject();
  }
  static createDecimal(t, e, n, s) {
    return Pt.startDecimal(t), Pt.addPrecision(t, e), Pt.addScale(t, n), Pt.addBitWidth(t, s), Pt.endDecimal(t);
  }
}, oi = class se {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsDuration(t, e) {
    return (e || new se()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDuration(t, e) {
    return t.setPosition(t.position() + V), (e || new se()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : p.MILLISECOND;
  }
  static startDuration(t) {
    t.startObject(1);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, p.MILLISECOND);
  }
  static endDuration(t) {
    return t.endObject();
  }
  static createDuration(t, e) {
    return se.startDuration(t), se.addUnit(t, e), se.endDuration(t);
  }
}, ai = class re {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsFixedSizeBinary(t, e) {
    return (e || new re()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFixedSizeBinary(t, e) {
    return t.setPosition(t.position() + V), (e || new re()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Number of bytes per value
   */
  byteWidth() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  static startFixedSizeBinary(t) {
    t.startObject(1);
  }
  static addByteWidth(t, e) {
    t.addFieldInt32(0, e, 0);
  }
  static endFixedSizeBinary(t) {
    return t.endObject();
  }
  static createFixedSizeBinary(t, e) {
    return re.startFixedSizeBinary(t), re.addByteWidth(t, e), re.endFixedSizeBinary(t);
  }
}, ci = class oe {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsFixedSizeList(t, e) {
    return (e || new oe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFixedSizeList(t, e) {
    return t.setPosition(t.position() + V), (e || new oe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Number of list items per value
   */
  listSize() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  static startFixedSizeList(t) {
    t.startObject(1);
  }
  static addListSize(t, e) {
    t.addFieldInt32(0, e, 0);
  }
  static endFixedSizeList(t) {
    return t.endObject();
  }
  static createFixedSizeList(t, e) {
    return oe.startFixedSizeList(t), oe.addListSize(t, e), oe.endFixedSizeList(t);
  }
};
class wt {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsFloatingPoint(t, e) {
    return (e || new wt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFloatingPoint(t, e) {
    return t.setPosition(t.position() + V), (e || new wt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  precision() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : Y.HALF;
  }
  static startFloatingPoint(t) {
    t.startObject(1);
  }
  static addPrecision(t, e) {
    t.addFieldInt16(0, e, Y.HALF);
  }
  static endFloatingPoint(t) {
    return t.endObject();
  }
  static createFloatingPoint(t, e) {
    return wt.startFloatingPoint(t), wt.addPrecision(t, e), wt.endFloatingPoint(t);
  }
}
class It {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsInterval(t, e) {
    return (e || new It()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsInterval(t, e) {
    return t.setPosition(t.position() + V), (e || new It()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : Dt.YEAR_MONTH;
  }
  static startInterval(t) {
    t.startObject(1);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, Dt.YEAR_MONTH);
  }
  static endInterval(t) {
    return t.endObject();
  }
  static createInterval(t, e) {
    return It.startInterval(t), It.addUnit(t, e), It.endInterval(t);
  }
}
let ns = class Ne {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsLargeBinary(t, e) {
    return (e || new Ne()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsLargeBinary(t, e) {
    return t.setPosition(t.position() + V), (e || new Ne()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startLargeBinary(t) {
    t.startObject(0);
  }
  static endLargeBinary(t) {
    return t.endObject();
  }
  static createLargeBinary(t) {
    return Ne.startLargeBinary(t), Ne.endLargeBinary(t);
  }
}, ss = class Ue {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsLargeUtf8(t, e) {
    return (e || new Ue()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsLargeUtf8(t, e) {
    return t.setPosition(t.position() + V), (e || new Ue()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startLargeUtf8(t) {
    t.startObject(0);
  }
  static endLargeUtf8(t) {
    return t.endObject();
  }
  static createLargeUtf8(t) {
    return Ue.startLargeUtf8(t), Ue.endLargeUtf8(t);
  }
}, rs = class xe {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsList(t, e) {
    return (e || new xe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsList(t, e) {
    return t.setPosition(t.position() + V), (e || new xe()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startList(t) {
    t.startObject(0);
  }
  static endList(t) {
    return t.endObject();
  }
  static createList(t) {
    return xe.startList(t), xe.endList(t);
  }
}, li = class ae {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsMap(t, e) {
    return (e || new ae()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsMap(t, e) {
    return t.setPosition(t.position() + V), (e || new ae()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Set to true if the keys within each value are sorted
   */
  keysSorted() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  static startMap(t) {
    t.startObject(1);
  }
  static addKeysSorted(t, e) {
    t.addFieldInt8(0, +e, 0);
  }
  static endMap(t) {
    return t.endObject();
  }
  static createMap(t, e) {
    return ae.startMap(t), ae.addKeysSorted(t, e), ae.endMap(t);
  }
}, os = class Ve {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsNull(t, e) {
    return (e || new Ve()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsNull(t, e) {
    return t.setPosition(t.position() + V), (e || new Ve()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startNull(t) {
    t.startObject(0);
  }
  static endNull(t) {
    return t.endObject();
  }
  static createNull(t) {
    return Ve.startNull(t), Ve.endNull(t);
  }
};
class Gt {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsStruct_(t, e) {
    return (e || new Gt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsStruct_(t, e) {
    return t.setPosition(t.position() + V), (e || new Gt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startStruct_(t) {
    t.startObject(0);
  }
  static endStruct_(t) {
    return t.endObject();
  }
  static createStruct_(t) {
    return Gt.startStruct_(t), Gt.endStruct_(t);
  }
}
class ot {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsTime(t, e) {
    return (e || new ot()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsTime(t, e) {
    return t.setPosition(t.position() + V), (e || new ot()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : p.MILLISECOND;
  }
  bitWidth() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readInt32(this.bb_pos + t) : 32;
  }
  static startTime(t) {
    t.startObject(2);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, p.MILLISECOND);
  }
  static addBitWidth(t, e) {
    t.addFieldInt32(1, e, 32);
  }
  static endTime(t) {
    return t.endObject();
  }
  static createTime(t, e, n) {
    return ot.startTime(t), ot.addUnit(t, e), ot.addBitWidth(t, n), ot.endTime(t);
  }
}
class at {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsTimestamp(t, e) {
    return (e || new at()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsTimestamp(t, e) {
    return t.setPosition(t.position() + V), (e || new at()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : p.SECOND;
  }
  timezone(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? this.bb.__string(this.bb_pos + e, t) : null;
  }
  static startTimestamp(t) {
    t.startObject(2);
  }
  static addUnit(t, e) {
    t.addFieldInt16(0, e, p.SECOND);
  }
  static addTimezone(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static endTimestamp(t) {
    return t.endObject();
  }
  static createTimestamp(t, e, n) {
    return at.startTimestamp(t), at.addUnit(t, e), at.addTimezone(t, n), at.endTimestamp(t);
  }
}
class Z {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsUnion(t, e) {
    return (e || new Z()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsUnion(t, e) {
    return t.setPosition(t.position() + V), (e || new Z()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  mode() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : q.Sparse;
  }
  typeIds(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? this.bb.readInt32(this.bb.__vector(this.bb_pos + e) + t * 4) : 0;
  }
  typeIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  typeIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? new Int32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  static startUnion(t) {
    t.startObject(2);
  }
  static addMode(t, e) {
    t.addFieldInt16(0, e, q.Sparse);
  }
  static addTypeIds(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static createTypeIdsVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addInt32(e[n]);
    return t.endVector();
  }
  static startTypeIdsVector(t, e) {
    t.startVector(4, e, 4);
  }
  static endUnion(t) {
    return t.endObject();
  }
  static createUnion(t, e, n) {
    return Z.startUnion(t), Z.addMode(t, e), Z.addTypeIds(t, n), Z.endUnion(t);
  }
}
let as = class Re {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsUtf8(t, e) {
    return (e || new Re()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsUtf8(t, e) {
    return t.setPosition(t.position() + V), (e || new Re()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startUtf8(t) {
    t.startObject(0);
  }
  static endUtf8(t) {
    return t.endObject();
  }
  static createUtf8(t) {
    return Re.startUtf8(t), Re.endUtf8(t);
  }
};
var E;
(function(i) {
  i[i.NONE = 0] = "NONE", i[i.Null = 1] = "Null", i[i.Int = 2] = "Int", i[i.FloatingPoint = 3] = "FloatingPoint", i[i.Binary = 4] = "Binary", i[i.Utf8 = 5] = "Utf8", i[i.Bool = 6] = "Bool", i[i.Decimal = 7] = "Decimal", i[i.Date = 8] = "Date", i[i.Time = 9] = "Time", i[i.Timestamp = 10] = "Timestamp", i[i.Interval = 11] = "Interval", i[i.List = 12] = "List", i[i.Struct_ = 13] = "Struct_", i[i.Union = 14] = "Union", i[i.FixedSizeBinary = 15] = "FixedSizeBinary", i[i.FixedSizeList = 16] = "FixedSizeList", i[i.Map = 17] = "Map", i[i.Duration = 18] = "Duration", i[i.LargeBinary = 19] = "LargeBinary", i[i.LargeUtf8 = 20] = "LargeUtf8", i[i.LargeList = 21] = "LargeList", i[i.RunEndEncoded = 22] = "RunEndEncoded";
})(E || (E = {}));
let st = class ui {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsField(t, e) {
    return (e || new ui()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsField(t, e) {
    return t.setPosition(t.position() + V), (e || new ui()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  name(t) {
    const e = this.bb.__offset(this.bb_pos, 4);
    return e ? this.bb.__string(this.bb_pos + e, t) : null;
  }
  /**
   * Whether or not this field can contain nulls. Should be true in general.
   */
  nullable() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  typeType() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.readUint8(this.bb_pos + t) : E.NONE;
  }
  /**
   * This is the type of the decoded value if the field is dictionary encoded.
   */
  type(t) {
    const e = this.bb.__offset(this.bb_pos, 10);
    return e ? this.bb.__union(t, this.bb_pos + e) : null;
  }
  /**
   * Present only if the field is dictionary encoded.
   */
  dictionary(t) {
    const e = this.bb.__offset(this.bb_pos, 12);
    return e ? (t || new Mt()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  /**
   * children apply only to nested data types like Struct, List and Union. For
   * primitive types children will have length 0.
   */
  children(t, e) {
    const n = this.bb.__offset(this.bb_pos, 14);
    return n ? (e || new ui()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  childrenLength() {
    const t = this.bb.__offset(this.bb_pos, 14);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(t, e) {
    const n = this.bb.__offset(this.bb_pos, 16);
    return n ? (e || new $()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 16);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startField(t) {
    t.startObject(7);
  }
  static addName(t, e) {
    t.addFieldOffset(0, e, 0);
  }
  static addNullable(t, e) {
    t.addFieldInt8(1, +e, 0);
  }
  static addTypeType(t, e) {
    t.addFieldInt8(2, e, E.NONE);
  }
  static addType(t, e) {
    t.addFieldOffset(3, e, 0);
  }
  static addDictionary(t, e) {
    t.addFieldOffset(4, e, 0);
  }
  static addChildren(t, e) {
    t.addFieldOffset(5, e, 0);
  }
  static createChildrenVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startChildrenVector(t, e) {
    t.startVector(4, e, 4);
  }
  static addCustomMetadata(t, e) {
    t.addFieldOffset(6, e, 0);
  }
  static createCustomMetadataVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, e) {
    t.startVector(4, e, 4);
  }
  static endField(t) {
    return t.endObject();
  }
}, mt = class At {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsSchema(t, e) {
    return (e || new At()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsSchema(t, e) {
    return t.setPosition(t.position() + V), (e || new At()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * endianness of the buffer
   * it is Little Endian by default
   * if endianness doesn't match the underlying system then the vectors need to be converted
   */
  endianness() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : me.Little;
  }
  fields(t, e) {
    const n = this.bb.__offset(this.bb_pos, 6);
    return n ? (e || new st()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  fieldsLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  customMetadata(t, e) {
    const n = this.bb.__offset(this.bb_pos, 8);
    return n ? (e || new $()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * Features used in the stream/file.
   */
  features(t) {
    const e = this.bb.__offset(this.bb_pos, 10);
    return e ? this.bb.readInt64(this.bb.__vector(this.bb_pos + e) + t * 8) : BigInt(0);
  }
  featuresLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startSchema(t) {
    t.startObject(4);
  }
  static addEndianness(t, e) {
    t.addFieldInt16(0, e, me.Little);
  }
  static addFields(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static createFieldsVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startFieldsVector(t, e) {
    t.startVector(4, e, 4);
  }
  static addCustomMetadata(t, e) {
    t.addFieldOffset(2, e, 0);
  }
  static createCustomMetadataVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, e) {
    t.startVector(4, e, 4);
  }
  static addFeatures(t, e) {
    t.addFieldOffset(3, e, 0);
  }
  static createFeaturesVector(t, e) {
    t.startVector(8, e.length, 8);
    for (let n = e.length - 1; n >= 0; n--)
      t.addInt64(e[n]);
    return t.endVector();
  }
  static startFeaturesVector(t, e) {
    t.startVector(8, e, 8);
  }
  static endSchema(t) {
    return t.endObject();
  }
  static finishSchemaBuffer(t, e) {
    t.finish(e);
  }
  static finishSizePrefixedSchemaBuffer(t, e) {
    t.finish(e, void 0, !0);
  }
  static createSchema(t, e, n, s, r) {
    return At.startSchema(t), At.addEndianness(t, e), At.addFields(t, n), At.addCustomMetadata(t, s), At.addFeatures(t, r), At.endSchema(t);
  }
};
var U;
(function(i) {
  i[i.NONE = 0] = "NONE", i[i.Schema = 1] = "Schema", i[i.DictionaryBatch = 2] = "DictionaryBatch", i[i.RecordBatch = 3] = "RecordBatch", i[i.Tensor = 4] = "Tensor", i[i.SparseTensor = 5] = "SparseTensor";
})(U || (U = {}));
var l;
(function(i) {
  i[i.NONE = 0] = "NONE", i[i.Null = 1] = "Null", i[i.Int = 2] = "Int", i[i.Float = 3] = "Float", i[i.Binary = 4] = "Binary", i[i.Utf8 = 5] = "Utf8", i[i.Bool = 6] = "Bool", i[i.Decimal = 7] = "Decimal", i[i.Date = 8] = "Date", i[i.Time = 9] = "Time", i[i.Timestamp = 10] = "Timestamp", i[i.Interval = 11] = "Interval", i[i.List = 12] = "List", i[i.Struct = 13] = "Struct", i[i.Union = 14] = "Union", i[i.FixedSizeBinary = 15] = "FixedSizeBinary", i[i.FixedSizeList = 16] = "FixedSizeList", i[i.Map = 17] = "Map", i[i.Duration = 18] = "Duration", i[i.LargeBinary = 19] = "LargeBinary", i[i.LargeUtf8 = 20] = "LargeUtf8", i[i.Dictionary = -1] = "Dictionary", i[i.Int8 = -2] = "Int8", i[i.Int16 = -3] = "Int16", i[i.Int32 = -4] = "Int32", i[i.Int64 = -5] = "Int64", i[i.Uint8 = -6] = "Uint8", i[i.Uint16 = -7] = "Uint16", i[i.Uint32 = -8] = "Uint32", i[i.Uint64 = -9] = "Uint64", i[i.Float16 = -10] = "Float16", i[i.Float32 = -11] = "Float32", i[i.Float64 = -12] = "Float64", i[i.DateDay = -13] = "DateDay", i[i.DateMillisecond = -14] = "DateMillisecond", i[i.TimestampSecond = -15] = "TimestampSecond", i[i.TimestampMillisecond = -16] = "TimestampMillisecond", i[i.TimestampMicrosecond = -17] = "TimestampMicrosecond", i[i.TimestampNanosecond = -18] = "TimestampNanosecond", i[i.TimeSecond = -19] = "TimeSecond", i[i.TimeMillisecond = -20] = "TimeMillisecond", i[i.TimeMicrosecond = -21] = "TimeMicrosecond", i[i.TimeNanosecond = -22] = "TimeNanosecond", i[i.DenseUnion = -23] = "DenseUnion", i[i.SparseUnion = -24] = "SparseUnion", i[i.IntervalDayTime = -25] = "IntervalDayTime", i[i.IntervalYearMonth = -26] = "IntervalYearMonth", i[i.DurationSecond = -27] = "DurationSecond", i[i.DurationMillisecond = -28] = "DurationMillisecond", i[i.DurationMicrosecond = -29] = "DurationMicrosecond", i[i.DurationNanosecond = -30] = "DurationNanosecond";
})(l || (l = {}));
var Ft;
(function(i) {
  i[i.OFFSET = 0] = "OFFSET", i[i.DATA = 1] = "DATA", i[i.VALIDITY = 2] = "VALIDITY", i[i.TYPE = 3] = "TYPE";
})(Ft || (Ft = {}));
const ya = void 0;
function Zt(i) {
  if (i === null)
    return "null";
  if (i === ya)
    return "undefined";
  switch (typeof i) {
    case "number":
      return `${i}`;
    case "bigint":
      return `${i}`;
    case "string":
      return `"${i}"`;
  }
  return typeof i[Symbol.toPrimitive] == "function" ? i[Symbol.toPrimitive]("string") : ArrayBuffer.isView(i) ? i instanceof BigInt64Array || i instanceof BigUint64Array ? `[${[...i].map((t) => Zt(t))}]` : `[${i}]` : ArrayBuffer.isView(i) ? `[${i}]` : JSON.stringify(i, (t, e) => typeof e == "bigint" ? `${e}` : e);
}
function z(i) {
  if (typeof i == "bigint" && (i < Number.MIN_SAFE_INTEGER || i > Number.MAX_SAFE_INTEGER))
    throw new TypeError(`${i} is not safe to convert to a number.`);
  return Number(i);
}
function Cs(i, t) {
  return z(i / t) + z(i % t) / z(t);
}
const ga = /* @__PURE__ */ Symbol.for("isArrowBigNum");
function yt(i, ...t) {
  return t.length === 0 ? Object.setPrototypeOf(C(this.TypedArray, i), this.constructor.prototype) : Object.setPrototypeOf(new this.TypedArray(i, ...t), this.constructor.prototype);
}
yt.prototype[ga] = !0;
yt.prototype.toJSON = function() {
  return `"${ke(this)}"`;
};
yt.prototype.valueOf = function(i) {
  return Es(this, i);
};
yt.prototype.toString = function() {
  return ke(this);
};
yt.prototype[Symbol.toPrimitive] = function(i = "default") {
  switch (i) {
    case "number":
      return Es(this);
    case "string":
      return ke(this);
    case "default":
      return _a(this);
  }
  return ke(this);
};
function he(...i) {
  return yt.apply(this, i);
}
function fe(...i) {
  return yt.apply(this, i);
}
function je(...i) {
  return yt.apply(this, i);
}
Object.setPrototypeOf(he.prototype, Object.create(Int32Array.prototype));
Object.setPrototypeOf(fe.prototype, Object.create(Uint32Array.prototype));
Object.setPrototypeOf(je.prototype, Object.create(Uint32Array.prototype));
Object.assign(he.prototype, yt.prototype, { constructor: he, signed: !0, TypedArray: Int32Array, BigIntArray: BigInt64Array });
Object.assign(fe.prototype, yt.prototype, { constructor: fe, signed: !1, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
Object.assign(je.prototype, yt.prototype, { constructor: je, signed: !0, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
const ma = BigInt(4294967296) * BigInt(4294967296), ba = ma - BigInt(1);
function Es(i, t) {
  const { buffer: e, byteOffset: n, byteLength: s, signed: r } = i, o = new BigUint64Array(e, n, s / 8), a = r && o.at(-1) & BigInt(1) << BigInt(63);
  let c = BigInt(0), u = 0;
  if (a) {
    for (const d of o)
      c |= (d ^ ba) * (BigInt(1) << BigInt(64 * u++));
    c *= BigInt(-1), c -= BigInt(1);
  } else
    for (const d of o)
      c |= d * (BigInt(1) << BigInt(64 * u++));
  if (typeof t == "number") {
    const d = BigInt(Math.pow(10, t)), h = c / d, k = c % d;
    return z(h) + z(k) / z(d);
  }
  return z(c);
}
function ke(i) {
  if (i.byteLength === 8)
    return `${new i.BigIntArray(i.buffer, i.byteOffset, 1)[0]}`;
  if (!i.signed)
    return Ki(i);
  let t = new Uint16Array(i.buffer, i.byteOffset, i.byteLength / 2);
  if (new Int16Array([t.at(-1)])[0] >= 0)
    return Ki(i);
  t = t.slice();
  let n = 1;
  for (let r = 0; r < t.length; r++) {
    const o = t[r], a = ~o + n;
    t[r] = a, n &= o === 0 ? 1 : 0;
  }
  return `-${Ki(t)}`;
}
function _a(i) {
  return i.byteLength === 8 ? new i.BigIntArray(i.buffer, i.byteOffset, 1)[0] : ke(i);
}
function Ki(i) {
  let t = "";
  const e = new Uint32Array(2);
  let n = new Uint16Array(i.buffer, i.byteOffset, i.byteLength / 2);
  const s = new Uint32Array((n = new Uint16Array(n).reverse()).buffer);
  let r = -1;
  const o = n.length - 1;
  do {
    for (e[0] = n[r = 0]; r < o; )
      n[r++] = e[1] = e[0] / 10, e[0] = (e[0] - e[1] * 10 << 16) + n[r];
    n[r] = e[1] = e[0] / 10, e[0] = e[0] - e[1] * 10, t = `${e[0]}${t}`;
  } while (s[0] || s[1] || s[2] || s[3]);
  return t ?? "0";
}
class gn {
  /** @nocollapse */
  static new(t, e) {
    switch (e) {
      case !0:
        return new he(t);
      case !1:
        return new fe(t);
    }
    switch (t.constructor) {
      case Int8Array:
      case Int16Array:
      case Int32Array:
      case BigInt64Array:
        return new he(t);
    }
    return t.byteLength === 16 ? new je(t) : new fe(t);
  }
  /** @nocollapse */
  static signed(t) {
    return new he(t);
  }
  /** @nocollapse */
  static unsigned(t) {
    return new fe(t);
  }
  /** @nocollapse */
  static decimal(t) {
    return new je(t);
  }
  constructor(t, e) {
    return gn.new(t, e);
  }
}
var zs, js, ks, Ps, $s, Ws, Ys, Js, Hs, Ks, Gs, Zs, qs, Qs, Xs, tr, er, ir, nr, sr, rr, or;
class f {
  /** @nocollapse */
  static isNull(t) {
    return t?.typeId === l.Null;
  }
  /** @nocollapse */
  static isInt(t) {
    return t?.typeId === l.Int;
  }
  /** @nocollapse */
  static isFloat(t) {
    return t?.typeId === l.Float;
  }
  /** @nocollapse */
  static isBinary(t) {
    return t?.typeId === l.Binary;
  }
  /** @nocollapse */
  static isLargeBinary(t) {
    return t?.typeId === l.LargeBinary;
  }
  /** @nocollapse */
  static isUtf8(t) {
    return t?.typeId === l.Utf8;
  }
  /** @nocollapse */
  static isLargeUtf8(t) {
    return t?.typeId === l.LargeUtf8;
  }
  /** @nocollapse */
  static isBool(t) {
    return t?.typeId === l.Bool;
  }
  /** @nocollapse */
  static isDecimal(t) {
    return t?.typeId === l.Decimal;
  }
  /** @nocollapse */
  static isDate(t) {
    return t?.typeId === l.Date;
  }
  /** @nocollapse */
  static isTime(t) {
    return t?.typeId === l.Time;
  }
  /** @nocollapse */
  static isTimestamp(t) {
    return t?.typeId === l.Timestamp;
  }
  /** @nocollapse */
  static isInterval(t) {
    return t?.typeId === l.Interval;
  }
  /** @nocollapse */
  static isDuration(t) {
    return t?.typeId === l.Duration;
  }
  /** @nocollapse */
  static isList(t) {
    return t?.typeId === l.List;
  }
  /** @nocollapse */
  static isStruct(t) {
    return t?.typeId === l.Struct;
  }
  /** @nocollapse */
  static isUnion(t) {
    return t?.typeId === l.Union;
  }
  /** @nocollapse */
  static isFixedSizeBinary(t) {
    return t?.typeId === l.FixedSizeBinary;
  }
  /** @nocollapse */
  static isFixedSizeList(t) {
    return t?.typeId === l.FixedSizeList;
  }
  /** @nocollapse */
  static isMap(t) {
    return t?.typeId === l.Map;
  }
  /** @nocollapse */
  static isDictionary(t) {
    return t?.typeId === l.Dictionary;
  }
  /** @nocollapse */
  static isDenseUnion(t) {
    return f.isUnion(t) && t.mode === q.Dense;
  }
  /** @nocollapse */
  static isSparseUnion(t) {
    return f.isUnion(t) && t.mode === q.Sparse;
  }
  constructor(t) {
    this.typeId = t;
  }
}
zs = Symbol.toStringTag;
f[zs] = ((i) => (i.children = null, i.ArrayType = Array, i.OffsetArrayType = Int32Array, i[Symbol.toStringTag] = "DataType"))(f.prototype);
class Ut extends f {
  constructor() {
    super(l.Null);
  }
  toString() {
    return "Null";
  }
}
js = Symbol.toStringTag;
Ut[js] = ((i) => i[Symbol.toStringTag] = "Null")(Ut.prototype);
class Q extends f {
  constructor(t, e) {
    super(l.Int), this.isSigned = t, this.bitWidth = e;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 8:
        return this.isSigned ? Int8Array : Uint8Array;
      case 16:
        return this.isSigned ? Int16Array : Uint16Array;
      case 32:
        return this.isSigned ? Int32Array : Uint32Array;
      case 64:
        return this.isSigned ? BigInt64Array : BigUint64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `${this.isSigned ? "I" : "Ui"}nt${this.bitWidth}`;
  }
}
ks = Symbol.toStringTag;
Q[ks] = ((i) => (i.isSigned = null, i.bitWidth = null, i[Symbol.toStringTag] = "Int"))(Q.prototype);
class ar extends Q {
  constructor() {
    super(!0, 8);
  }
  get ArrayType() {
    return Int8Array;
  }
}
class cr extends Q {
  constructor() {
    super(!0, 16);
  }
  get ArrayType() {
    return Int16Array;
  }
}
class qt extends Q {
  constructor() {
    super(!0, 32);
  }
  get ArrayType() {
    return Int32Array;
  }
}
let mn = class extends Q {
  constructor() {
    super(!0, 64);
  }
  get ArrayType() {
    return BigInt64Array;
  }
};
class lr extends Q {
  constructor() {
    super(!1, 8);
  }
  get ArrayType() {
    return Uint8Array;
  }
}
class ur extends Q {
  constructor() {
    super(!1, 16);
  }
  get ArrayType() {
    return Uint16Array;
  }
}
class dr extends Q {
  constructor() {
    super(!1, 32);
  }
  get ArrayType() {
    return Uint32Array;
  }
}
let hr = class extends Q {
  constructor() {
    super(!1, 64);
  }
  get ArrayType() {
    return BigUint64Array;
  }
};
Object.defineProperty(ar.prototype, "ArrayType", { value: Int8Array });
Object.defineProperty(cr.prototype, "ArrayType", { value: Int16Array });
Object.defineProperty(qt.prototype, "ArrayType", { value: Int32Array });
Object.defineProperty(mn.prototype, "ArrayType", { value: BigInt64Array });
Object.defineProperty(lr.prototype, "ArrayType", { value: Uint8Array });
Object.defineProperty(ur.prototype, "ArrayType", { value: Uint16Array });
Object.defineProperty(dr.prototype, "ArrayType", { value: Uint32Array });
Object.defineProperty(hr.prototype, "ArrayType", { value: BigUint64Array });
class be extends f {
  constructor(t) {
    super(l.Float), this.precision = t;
  }
  get ArrayType() {
    switch (this.precision) {
      case Y.HALF:
        return Uint16Array;
      case Y.SINGLE:
        return Float32Array;
      case Y.DOUBLE:
        return Float64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `Float${this.precision << 5 || 16}`;
  }
}
Ps = Symbol.toStringTag;
be[Ps] = ((i) => (i.precision = null, i[Symbol.toStringTag] = "Float"))(be.prototype);
class fr extends be {
  constructor() {
    super(Y.SINGLE);
  }
}
class bn extends be {
  constructor() {
    super(Y.DOUBLE);
  }
}
Object.defineProperty(fr.prototype, "ArrayType", { value: Float32Array });
Object.defineProperty(bn.prototype, "ArrayType", { value: Float64Array });
class mi extends f {
  constructor() {
    super(l.Binary);
  }
  toString() {
    return "Binary";
  }
}
$s = Symbol.toStringTag;
mi[$s] = ((i) => (i.ArrayType = Uint8Array, i[Symbol.toStringTag] = "Binary"))(mi.prototype);
class bi extends f {
  constructor() {
    super(l.LargeBinary);
  }
  toString() {
    return "LargeBinary";
  }
}
Ws = Symbol.toStringTag;
bi[Ws] = ((i) => (i.ArrayType = Uint8Array, i.OffsetArrayType = BigInt64Array, i[Symbol.toStringTag] = "LargeBinary"))(bi.prototype);
class Pe extends f {
  constructor() {
    super(l.Utf8);
  }
  toString() {
    return "Utf8";
  }
}
Ys = Symbol.toStringTag;
Pe[Ys] = ((i) => (i.ArrayType = Uint8Array, i[Symbol.toStringTag] = "Utf8"))(Pe.prototype);
class _i extends f {
  constructor() {
    super(l.LargeUtf8);
  }
  toString() {
    return "LargeUtf8";
  }
}
Js = Symbol.toStringTag;
_i[Js] = ((i) => (i.ArrayType = Uint8Array, i.OffsetArrayType = BigInt64Array, i[Symbol.toStringTag] = "LargeUtf8"))(_i.prototype);
class $e extends f {
  constructor() {
    super(l.Bool);
  }
  toString() {
    return "Bool";
  }
}
Hs = Symbol.toStringTag;
$e[Hs] = ((i) => (i.ArrayType = Uint8Array, i[Symbol.toStringTag] = "Bool"))($e.prototype);
class vi extends f {
  constructor(t, e, n = 128) {
    super(l.Decimal), this.scale = t, this.precision = e, this.bitWidth = n;
  }
  toString() {
    return `Decimal[${this.precision}e${this.scale > 0 ? "+" : ""}${this.scale}]`;
  }
}
Ks = Symbol.toStringTag;
vi[Ks] = ((i) => (i.scale = null, i.precision = null, i.ArrayType = Uint32Array, i[Symbol.toStringTag] = "Decimal"))(vi.prototype);
class wi extends f {
  constructor(t) {
    super(l.Date), this.unit = t;
  }
  toString() {
    return `Date${(this.unit + 1) * 32}<${ct[this.unit]}>`;
  }
  get ArrayType() {
    return this.unit === ct.DAY ? Int32Array : BigInt64Array;
  }
}
Gs = Symbol.toStringTag;
wi[Gs] = ((i) => (i.unit = null, i[Symbol.toStringTag] = "Date"))(wi.prototype);
class Ii extends f {
  constructor(t, e) {
    super(l.Time), this.unit = t, this.bitWidth = e;
  }
  toString() {
    return `Time${this.bitWidth}<${p[this.unit]}>`;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 32:
        return Int32Array;
      case 64:
        return BigInt64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
}
Zs = Symbol.toStringTag;
Ii[Zs] = ((i) => (i.unit = null, i.bitWidth = null, i[Symbol.toStringTag] = "Time"))(Ii.prototype);
class We extends f {
  constructor(t, e) {
    super(l.Timestamp), this.unit = t, this.timezone = e;
  }
  toString() {
    return `Timestamp<${p[this.unit]}${this.timezone ? `, ${this.timezone}` : ""}>`;
  }
}
qs = Symbol.toStringTag;
We[qs] = ((i) => (i.unit = null, i.timezone = null, i.ArrayType = BigInt64Array, i[Symbol.toStringTag] = "Timestamp"))(We.prototype);
class va extends We {
  constructor(t) {
    super(p.MILLISECOND, t);
  }
}
class Si extends f {
  constructor(t) {
    super(l.Interval), this.unit = t;
  }
  toString() {
    return `Interval<${Dt[this.unit]}>`;
  }
}
Qs = Symbol.toStringTag;
Si[Qs] = ((i) => (i.unit = null, i.ArrayType = Int32Array, i[Symbol.toStringTag] = "Interval"))(Si.prototype);
class Bi extends f {
  constructor(t) {
    super(l.Duration), this.unit = t;
  }
  toString() {
    return `Duration<${p[this.unit]}>`;
  }
}
Xs = Symbol.toStringTag;
Bi[Xs] = ((i) => (i.unit = null, i.ArrayType = BigInt64Array, i[Symbol.toStringTag] = "Duration"))(Bi.prototype);
class _e extends f {
  constructor(t) {
    super(l.List), this.children = [t];
  }
  toString() {
    return `List<${this.valueType}>`;
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
}
tr = Symbol.toStringTag;
_e[tr] = ((i) => (i.children = null, i[Symbol.toStringTag] = "List"))(_e.prototype);
class J extends f {
  constructor(t) {
    super(l.Struct), this.children = t;
  }
  toString() {
    return `Struct<{${this.children.map((t) => `${t.name}:${t.type}`).join(", ")}}>`;
  }
}
er = Symbol.toStringTag;
J[er] = ((i) => (i.children = null, i[Symbol.toStringTag] = "Struct"))(J.prototype);
class Ye extends f {
  constructor(t, e, n) {
    super(l.Union), this.mode = t, this.children = n, this.typeIds = e = Int32Array.from(e), this.typeIdToChildIndex = e.reduce((s, r, o) => (s[r] = o) && s || s, /* @__PURE__ */ Object.create(null));
  }
  toString() {
    return `${this[Symbol.toStringTag]}<${this.children.map((t) => `${t.type}`).join(" | ")}>`;
  }
}
ir = Symbol.toStringTag;
Ye[ir] = ((i) => (i.mode = null, i.typeIds = null, i.children = null, i.typeIdToChildIndex = null, i.ArrayType = Int8Array, i[Symbol.toStringTag] = "Union"))(Ye.prototype);
class Di extends f {
  constructor(t) {
    super(l.FixedSizeBinary), this.byteWidth = t;
  }
  toString() {
    return `FixedSizeBinary[${this.byteWidth}]`;
  }
}
nr = Symbol.toStringTag;
Di[nr] = ((i) => (i.byteWidth = null, i.ArrayType = Uint8Array, i[Symbol.toStringTag] = "FixedSizeBinary"))(Di.prototype);
class Je extends f {
  constructor(t, e) {
    super(l.FixedSizeList), this.listSize = t, this.children = [e];
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
  toString() {
    return `FixedSizeList[${this.listSize}]<${this.valueType}>`;
  }
}
sr = Symbol.toStringTag;
Je[sr] = ((i) => (i.children = null, i.listSize = null, i[Symbol.toStringTag] = "FixedSizeList"))(Je.prototype);
class He extends f {
  constructor(t, e = !1) {
    var n, s, r;
    if (super(l.Map), this.children = [t], this.keysSorted = e, t && (t.name = "entries", !((n = t?.type) === null || n === void 0) && n.children)) {
      const o = (s = t?.type) === null || s === void 0 ? void 0 : s.children[0];
      o && (o.name = "key");
      const a = (r = t?.type) === null || r === void 0 ? void 0 : r.children[1];
      a && (a.name = "value");
    }
  }
  get keyType() {
    return this.children[0].type.children[0].type;
  }
  get valueType() {
    return this.children[0].type.children[1].type;
  }
  get childType() {
    return this.children[0].type;
  }
  toString() {
    return `Map<{${this.children[0].type.children.map((t) => `${t.name}:${t.type}`).join(", ")}}>`;
  }
}
rr = Symbol.toStringTag;
He[rr] = ((i) => (i.children = null, i.keysSorted = null, i[Symbol.toStringTag] = "Map_"))(He.prototype);
const wa = /* @__PURE__ */ ((i) => () => ++i)(-1);
class Yt extends f {
  constructor(t, e, n, s) {
    super(l.Dictionary), this.indices = e, this.dictionary = t, this.isOrdered = s || !1, this.id = n == null ? wa() : z(n);
  }
  get children() {
    return this.dictionary.children;
  }
  get valueType() {
    return this.dictionary;
  }
  get ArrayType() {
    return this.dictionary.ArrayType;
  }
  toString() {
    return `Dictionary<${this.indices}, ${this.dictionary}>`;
  }
}
or = Symbol.toStringTag;
Yt[or] = ((i) => (i.id = null, i.indices = null, i.isOrdered = null, i.dictionary = null, i[Symbol.toStringTag] = "Dictionary"))(Yt.prototype);
function _t(i) {
  const t = i;
  switch (i.typeId) {
    case l.Decimal:
      return i.bitWidth / 32;
    case l.Interval:
      return 1 + t.unit;
    // case Type.Int: return 1 + +((t as Int_).bitWidth > 32);
    // case Type.Time: return 1 + +((t as Time_).bitWidth > 32);
    case l.FixedSizeList:
      return t.listSize;
    case l.FixedSizeBinary:
      return t.byteWidth;
    default:
      return 1;
  }
}
class F {
  visitMany(t, ...e) {
    return t.map((n, s) => this.visit(n, ...e.map((r) => r[s])));
  }
  visit(...t) {
    return this.getVisitFn(t[0], !1).apply(this, t);
  }
  getVisitFn(t, e = !0) {
    return Ia(this, t, e);
  }
  getVisitFnByTypeId(t, e = !0) {
    return ce(this, t, e);
  }
  visitNull(t, ...e) {
    return null;
  }
  visitBool(t, ...e) {
    return null;
  }
  visitInt(t, ...e) {
    return null;
  }
  visitFloat(t, ...e) {
    return null;
  }
  visitUtf8(t, ...e) {
    return null;
  }
  visitLargeUtf8(t, ...e) {
    return null;
  }
  visitBinary(t, ...e) {
    return null;
  }
  visitLargeBinary(t, ...e) {
    return null;
  }
  visitFixedSizeBinary(t, ...e) {
    return null;
  }
  visitDate(t, ...e) {
    return null;
  }
  visitTimestamp(t, ...e) {
    return null;
  }
  visitTime(t, ...e) {
    return null;
  }
  visitDecimal(t, ...e) {
    return null;
  }
  visitList(t, ...e) {
    return null;
  }
  visitStruct(t, ...e) {
    return null;
  }
  visitUnion(t, ...e) {
    return null;
  }
  visitDictionary(t, ...e) {
    return null;
  }
  visitInterval(t, ...e) {
    return null;
  }
  visitDuration(t, ...e) {
    return null;
  }
  visitFixedSizeList(t, ...e) {
    return null;
  }
  visitMap(t, ...e) {
    return null;
  }
}
function Ia(i, t, e = !0) {
  return typeof t == "number" ? ce(i, t, e) : typeof t == "string" && t in l ? ce(i, l[t], e) : t && t instanceof f ? ce(i, cs(t), e) : t?.type && t.type instanceof f ? ce(i, cs(t.type), e) : ce(i, l.NONE, e);
}
function ce(i, t, e = !0) {
  let n = null;
  switch (t) {
    case l.Null:
      n = i.visitNull;
      break;
    case l.Bool:
      n = i.visitBool;
      break;
    case l.Int:
      n = i.visitInt;
      break;
    case l.Int8:
      n = i.visitInt8 || i.visitInt;
      break;
    case l.Int16:
      n = i.visitInt16 || i.visitInt;
      break;
    case l.Int32:
      n = i.visitInt32 || i.visitInt;
      break;
    case l.Int64:
      n = i.visitInt64 || i.visitInt;
      break;
    case l.Uint8:
      n = i.visitUint8 || i.visitInt;
      break;
    case l.Uint16:
      n = i.visitUint16 || i.visitInt;
      break;
    case l.Uint32:
      n = i.visitUint32 || i.visitInt;
      break;
    case l.Uint64:
      n = i.visitUint64 || i.visitInt;
      break;
    case l.Float:
      n = i.visitFloat;
      break;
    case l.Float16:
      n = i.visitFloat16 || i.visitFloat;
      break;
    case l.Float32:
      n = i.visitFloat32 || i.visitFloat;
      break;
    case l.Float64:
      n = i.visitFloat64 || i.visitFloat;
      break;
    case l.Utf8:
      n = i.visitUtf8;
      break;
    case l.LargeUtf8:
      n = i.visitLargeUtf8;
      break;
    case l.Binary:
      n = i.visitBinary;
      break;
    case l.LargeBinary:
      n = i.visitLargeBinary;
      break;
    case l.FixedSizeBinary:
      n = i.visitFixedSizeBinary;
      break;
    case l.Date:
      n = i.visitDate;
      break;
    case l.DateDay:
      n = i.visitDateDay || i.visitDate;
      break;
    case l.DateMillisecond:
      n = i.visitDateMillisecond || i.visitDate;
      break;
    case l.Timestamp:
      n = i.visitTimestamp;
      break;
    case l.TimestampSecond:
      n = i.visitTimestampSecond || i.visitTimestamp;
      break;
    case l.TimestampMillisecond:
      n = i.visitTimestampMillisecond || i.visitTimestamp;
      break;
    case l.TimestampMicrosecond:
      n = i.visitTimestampMicrosecond || i.visitTimestamp;
      break;
    case l.TimestampNanosecond:
      n = i.visitTimestampNanosecond || i.visitTimestamp;
      break;
    case l.Time:
      n = i.visitTime;
      break;
    case l.TimeSecond:
      n = i.visitTimeSecond || i.visitTime;
      break;
    case l.TimeMillisecond:
      n = i.visitTimeMillisecond || i.visitTime;
      break;
    case l.TimeMicrosecond:
      n = i.visitTimeMicrosecond || i.visitTime;
      break;
    case l.TimeNanosecond:
      n = i.visitTimeNanosecond || i.visitTime;
      break;
    case l.Decimal:
      n = i.visitDecimal;
      break;
    case l.List:
      n = i.visitList;
      break;
    case l.Struct:
      n = i.visitStruct;
      break;
    case l.Union:
      n = i.visitUnion;
      break;
    case l.DenseUnion:
      n = i.visitDenseUnion || i.visitUnion;
      break;
    case l.SparseUnion:
      n = i.visitSparseUnion || i.visitUnion;
      break;
    case l.Dictionary:
      n = i.visitDictionary;
      break;
    case l.Interval:
      n = i.visitInterval;
      break;
    case l.IntervalDayTime:
      n = i.visitIntervalDayTime || i.visitInterval;
      break;
    case l.IntervalYearMonth:
      n = i.visitIntervalYearMonth || i.visitInterval;
      break;
    case l.Duration:
      n = i.visitDuration;
      break;
    case l.DurationSecond:
      n = i.visitDurationSecond || i.visitDuration;
      break;
    case l.DurationMillisecond:
      n = i.visitDurationMillisecond || i.visitDuration;
      break;
    case l.DurationMicrosecond:
      n = i.visitDurationMicrosecond || i.visitDuration;
      break;
    case l.DurationNanosecond:
      n = i.visitDurationNanosecond || i.visitDuration;
      break;
    case l.FixedSizeList:
      n = i.visitFixedSizeList;
      break;
    case l.Map:
      n = i.visitMap;
      break;
  }
  if (typeof n == "function")
    return n;
  if (!e)
    return () => null;
  throw new Error(`Unrecognized type '${l[t]}'`);
}
function cs(i) {
  switch (i.typeId) {
    case l.Null:
      return l.Null;
    case l.Int: {
      const { bitWidth: t, isSigned: e } = i;
      switch (t) {
        case 8:
          return e ? l.Int8 : l.Uint8;
        case 16:
          return e ? l.Int16 : l.Uint16;
        case 32:
          return e ? l.Int32 : l.Uint32;
        case 64:
          return e ? l.Int64 : l.Uint64;
      }
      return l.Int;
    }
    case l.Float:
      switch (i.precision) {
        case Y.HALF:
          return l.Float16;
        case Y.SINGLE:
          return l.Float32;
        case Y.DOUBLE:
          return l.Float64;
      }
      return l.Float;
    case l.Binary:
      return l.Binary;
    case l.LargeBinary:
      return l.LargeBinary;
    case l.Utf8:
      return l.Utf8;
    case l.LargeUtf8:
      return l.LargeUtf8;
    case l.Bool:
      return l.Bool;
    case l.Decimal:
      return l.Decimal;
    case l.Time:
      switch (i.unit) {
        case p.SECOND:
          return l.TimeSecond;
        case p.MILLISECOND:
          return l.TimeMillisecond;
        case p.MICROSECOND:
          return l.TimeMicrosecond;
        case p.NANOSECOND:
          return l.TimeNanosecond;
      }
      return l.Time;
    case l.Timestamp:
      switch (i.unit) {
        case p.SECOND:
          return l.TimestampSecond;
        case p.MILLISECOND:
          return l.TimestampMillisecond;
        case p.MICROSECOND:
          return l.TimestampMicrosecond;
        case p.NANOSECOND:
          return l.TimestampNanosecond;
      }
      return l.Timestamp;
    case l.Date:
      switch (i.unit) {
        case ct.DAY:
          return l.DateDay;
        case ct.MILLISECOND:
          return l.DateMillisecond;
      }
      return l.Date;
    case l.Interval:
      switch (i.unit) {
        case Dt.DAY_TIME:
          return l.IntervalDayTime;
        case Dt.YEAR_MONTH:
          return l.IntervalYearMonth;
      }
      return l.Interval;
    case l.Duration:
      switch (i.unit) {
        case p.SECOND:
          return l.DurationSecond;
        case p.MILLISECOND:
          return l.DurationMillisecond;
        case p.MICROSECOND:
          return l.DurationMicrosecond;
        case p.NANOSECOND:
          return l.DurationNanosecond;
      }
      return l.Duration;
    case l.Map:
      return l.Map;
    case l.List:
      return l.List;
    case l.Struct:
      return l.Struct;
    case l.Union:
      switch (i.mode) {
        case q.Dense:
          return l.DenseUnion;
        case q.Sparse:
          return l.SparseUnion;
      }
      return l.Union;
    case l.FixedSizeBinary:
      return l.FixedSizeBinary;
    case l.FixedSizeList:
      return l.FixedSizeList;
    case l.Dictionary:
      return l.Dictionary;
  }
  throw new Error(`Unrecognized type '${l[i.typeId]}'`);
}
F.prototype.visitInt8 = null;
F.prototype.visitInt16 = null;
F.prototype.visitInt32 = null;
F.prototype.visitInt64 = null;
F.prototype.visitUint8 = null;
F.prototype.visitUint16 = null;
F.prototype.visitUint32 = null;
F.prototype.visitUint64 = null;
F.prototype.visitFloat16 = null;
F.prototype.visitFloat32 = null;
F.prototype.visitFloat64 = null;
F.prototype.visitDateDay = null;
F.prototype.visitDateMillisecond = null;
F.prototype.visitTimestampSecond = null;
F.prototype.visitTimestampMillisecond = null;
F.prototype.visitTimestampMicrosecond = null;
F.prototype.visitTimestampNanosecond = null;
F.prototype.visitTimeSecond = null;
F.prototype.visitTimeMillisecond = null;
F.prototype.visitTimeMicrosecond = null;
F.prototype.visitTimeNanosecond = null;
F.prototype.visitDenseUnion = null;
F.prototype.visitSparseUnion = null;
F.prototype.visitIntervalDayTime = null;
F.prototype.visitIntervalYearMonth = null;
F.prototype.visitDuration = null;
F.prototype.visitDurationSecond = null;
F.prototype.visitDurationMillisecond = null;
F.prototype.visitDurationMicrosecond = null;
F.prototype.visitDurationNanosecond = null;
const pr = new Float64Array(1), te = new Uint32Array(pr.buffer);
function yr(i) {
  const t = (i & 31744) >> 10, e = (i & 1023) / 1024, n = Math.pow(-1, (i & 32768) >> 15);
  switch (t) {
    case 31:
      return n * (e ? Number.NaN : 1 / 0);
    case 0:
      return n * (e ? 6103515625e-14 * e : 0);
  }
  return n * Math.pow(2, t - 15) * (1 + e);
}
function gr(i) {
  if (i !== i)
    return 32256;
  pr[0] = i;
  const t = (te[1] & 2147483648) >> 16 & 65535;
  let e = te[1] & 2146435072, n = 0;
  return e >= 1089470464 ? te[0] > 0 ? e = 31744 : (e = (e & 2080374784) >> 16, n = (te[1] & 1048575) >> 10) : e <= 1056964608 ? (n = 1048576 + (te[1] & 1048575), n = 1048576 + (n << (e >> 20) - 998) >> 21, e = 0) : (e = e - 1056964608 >> 10, n = (te[1] & 1048575) + 512 >> 10), t | e | n & 65535;
}
class v extends F {
}
function S(i) {
  return (t, e, n) => {
    if (t.setValid(e, n != null))
      return i(t, e, n);
  };
}
const Sa = (i, t, e) => {
  i[t] = Math.floor(e / 864e5);
}, mr = (i, t, e, n) => {
  if (e + 1 < t.length) {
    const s = z(t[e]), r = z(t[e + 1]);
    i.set(n.subarray(0, r - s), s);
  }
}, Ba = ({ offset: i, values: t }, e, n) => {
  const s = i + e;
  n ? t[s >> 3] |= 1 << s % 8 : t[s >> 3] &= ~(1 << s % 8);
}, Rt = ({ values: i }, t, e) => {
  i[t] = e;
}, _n = ({ values: i }, t, e) => {
  i[t] = e;
}, br = ({ values: i }, t, e) => {
  i[t] = gr(e);
}, Da = (i, t, e) => {
  switch (i.type.precision) {
    case Y.HALF:
      return br(i, t, e);
    case Y.SINGLE:
    case Y.DOUBLE:
      return _n(i, t, e);
  }
}, vn = ({ values: i }, t, e) => {
  Sa(i, t, e.valueOf());
}, wn = ({ values: i }, t, e) => {
  i[t] = BigInt(e);
}, _r = ({ stride: i, values: t }, e, n) => {
  t.set(n.subarray(0, i), i * e);
}, vr = ({ values: i, valueOffsets: t }, e, n) => mr(i, t, e, n), wr = ({ values: i, valueOffsets: t }, e, n) => mr(i, t, e, Ke(n)), Ir = (i, t, e) => {
  i.type.unit === ct.DAY ? vn(i, t, e) : wn(i, t, e);
}, In = ({ values: i }, t, e) => {
  i[t] = BigInt(e / 1e3);
}, Sn = ({ values: i }, t, e) => {
  i[t] = BigInt(e);
}, Bn = ({ values: i }, t, e) => {
  i[t] = BigInt(e * 1e3);
}, Dn = ({ values: i }, t, e) => {
  i[t] = BigInt(e * 1e6);
}, Sr = (i, t, e) => {
  switch (i.type.unit) {
    case p.SECOND:
      return In(i, t, e);
    case p.MILLISECOND:
      return Sn(i, t, e);
    case p.MICROSECOND:
      return Bn(i, t, e);
    case p.NANOSECOND:
      return Dn(i, t, e);
  }
}, An = ({ values: i }, t, e) => {
  i[t] = e;
}, On = ({ values: i }, t, e) => {
  i[t] = e;
}, Fn = ({ values: i }, t, e) => {
  i[t] = e;
}, Tn = ({ values: i }, t, e) => {
  i[t] = e;
}, Br = (i, t, e) => {
  switch (i.type.unit) {
    case p.SECOND:
      return An(i, t, e);
    case p.MILLISECOND:
      return On(i, t, e);
    case p.MICROSECOND:
      return Fn(i, t, e);
    case p.NANOSECOND:
      return Tn(i, t, e);
  }
}, Dr = ({ values: i, stride: t }, e, n) => {
  i.set(n.subarray(0, t), t * e);
}, Aa = (i, t, e) => {
  const n = i.children[0], s = i.valueOffsets, r = lt.getVisitFn(n);
  if (Array.isArray(e))
    for (let o = -1, a = s[t], c = s[t + 1]; a < c; )
      r(n, a++, e[++o]);
  else
    for (let o = -1, a = s[t], c = s[t + 1]; a < c; )
      r(n, a++, e.get(++o));
}, Oa = (i, t, e) => {
  const n = i.children[0], { valueOffsets: s } = i, r = lt.getVisitFn(n);
  let { [t]: o, [t + 1]: a } = s;
  const c = e instanceof Map ? e.entries() : Object.entries(e);
  for (const u of c)
    if (r(n, o, u), ++o >= a)
      break;
}, Fa = (i, t) => (e, n, s, r) => n && e(n, i, t[r]), Ta = (i, t) => (e, n, s, r) => n && e(n, i, t.get(r)), Ma = (i, t) => (e, n, s, r) => n && e(n, i, t.get(s.name)), La = (i, t) => (e, n, s, r) => n && e(n, i, t[s.name]), Na = (i, t, e) => {
  const n = i.type.children.map((r) => lt.getVisitFn(r.type)), s = e instanceof Map ? Ma(t, e) : e instanceof D ? Ta(t, e) : Array.isArray(e) ? Fa(t, e) : La(t, e);
  i.type.children.forEach((r, o) => s(n[o], i.children[o], r, o));
}, Ua = (i, t, e) => {
  i.type.mode === q.Dense ? Ar(i, t, e) : Or(i, t, e);
}, Ar = (i, t, e) => {
  const n = i.type.typeIdToChildIndex[i.typeIds[t]], s = i.children[n];
  lt.visit(s, i.valueOffsets[t], e);
}, Or = (i, t, e) => {
  const n = i.type.typeIdToChildIndex[i.typeIds[t]], s = i.children[n];
  lt.visit(s, t, e);
}, xa = (i, t, e) => {
  var n;
  (n = i.dictionary) === null || n === void 0 || n.set(i.values[t], e);
}, Fr = (i, t, e) => {
  i.type.unit === Dt.DAY_TIME ? Mn(i, t, e) : Ln(i, t, e);
}, Mn = ({ values: i }, t, e) => {
  i.set(e.subarray(0, 2), 2 * t);
}, Ln = ({ values: i }, t, e) => {
  i[t] = e[0] * 12 + e[1] % 12;
}, Nn = ({ values: i }, t, e) => {
  i[t] = e;
}, Un = ({ values: i }, t, e) => {
  i[t] = e;
}, xn = ({ values: i }, t, e) => {
  i[t] = e;
}, Vn = ({ values: i }, t, e) => {
  i[t] = e;
}, Tr = (i, t, e) => {
  switch (i.type.unit) {
    case p.SECOND:
      return Nn(i, t, e);
    case p.MILLISECOND:
      return Un(i, t, e);
    case p.MICROSECOND:
      return xn(i, t, e);
    case p.NANOSECOND:
      return Vn(i, t, e);
  }
}, Va = (i, t, e) => {
  const { stride: n } = i, s = i.children[0], r = lt.getVisitFn(s);
  if (Array.isArray(e))
    for (let o = -1, a = t * n; ++o < n; )
      r(s, a + o, e[o]);
  else
    for (let o = -1, a = t * n; ++o < n; )
      r(s, a + o, e.get(o));
};
v.prototype.visitBool = S(Ba);
v.prototype.visitInt = S(Rt);
v.prototype.visitInt8 = S(Rt);
v.prototype.visitInt16 = S(Rt);
v.prototype.visitInt32 = S(Rt);
v.prototype.visitInt64 = S(Rt);
v.prototype.visitUint8 = S(Rt);
v.prototype.visitUint16 = S(Rt);
v.prototype.visitUint32 = S(Rt);
v.prototype.visitUint64 = S(Rt);
v.prototype.visitFloat = S(Da);
v.prototype.visitFloat16 = S(br);
v.prototype.visitFloat32 = S(_n);
v.prototype.visitFloat64 = S(_n);
v.prototype.visitUtf8 = S(wr);
v.prototype.visitLargeUtf8 = S(wr);
v.prototype.visitBinary = S(vr);
v.prototype.visitLargeBinary = S(vr);
v.prototype.visitFixedSizeBinary = S(_r);
v.prototype.visitDate = S(Ir);
v.prototype.visitDateDay = S(vn);
v.prototype.visitDateMillisecond = S(wn);
v.prototype.visitTimestamp = S(Sr);
v.prototype.visitTimestampSecond = S(In);
v.prototype.visitTimestampMillisecond = S(Sn);
v.prototype.visitTimestampMicrosecond = S(Bn);
v.prototype.visitTimestampNanosecond = S(Dn);
v.prototype.visitTime = S(Br);
v.prototype.visitTimeSecond = S(An);
v.prototype.visitTimeMillisecond = S(On);
v.prototype.visitTimeMicrosecond = S(Fn);
v.prototype.visitTimeNanosecond = S(Tn);
v.prototype.visitDecimal = S(Dr);
v.prototype.visitList = S(Aa);
v.prototype.visitStruct = S(Na);
v.prototype.visitUnion = S(Ua);
v.prototype.visitDenseUnion = S(Ar);
v.prototype.visitSparseUnion = S(Or);
v.prototype.visitDictionary = S(xa);
v.prototype.visitInterval = S(Fr);
v.prototype.visitIntervalDayTime = S(Mn);
v.prototype.visitIntervalYearMonth = S(Ln);
v.prototype.visitDuration = S(Tr);
v.prototype.visitDurationSecond = S(Nn);
v.prototype.visitDurationMillisecond = S(Un);
v.prototype.visitDurationMicrosecond = S(xn);
v.prototype.visitDurationNanosecond = S(Vn);
v.prototype.visitFixedSizeList = S(Va);
v.prototype.visitMap = S(Oa);
const lt = new v(), ut = /* @__PURE__ */ Symbol.for("parent"), pe = /* @__PURE__ */ Symbol.for("rowIndex");
class Rn {
  constructor(t, e) {
    return this[ut] = t, this[pe] = e, new Proxy(this, new Ca());
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const t = this[pe], e = this[ut], n = e.type.children, s = {};
    for (let r = -1, o = n.length; ++r < o; )
      s[n[r].name] = X.visit(e.children[r], t);
    return s;
  }
  toString() {
    return `{${[...this].map(([t, e]) => `${Zt(t)}: ${Zt(e)}`).join(", ")}}`;
  }
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
  [Symbol.iterator]() {
    return new Ra(this[ut], this[pe]);
  }
}
class Ra {
  constructor(t, e) {
    this.childIndex = 0, this.children = t.children, this.rowIndex = e, this.childFields = t.type.children, this.numChildren = this.childFields.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const t = this.childIndex;
    return t < this.numChildren ? (this.childIndex = t + 1, {
      done: !1,
      value: [
        this.childFields[t].name,
        X.visit(this.children[t], this.rowIndex)
      ]
    }) : { done: !0, value: null };
  }
}
Object.defineProperties(Rn.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [ut]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [pe]: { writable: !0, enumerable: !1, configurable: !1, value: -1 }
});
class Ca {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(t) {
    return t[ut].type.children.map((e) => e.name);
  }
  has(t, e) {
    return t[ut].type.children.findIndex((n) => n.name === e) !== -1;
  }
  getOwnPropertyDescriptor(t, e) {
    if (t[ut].type.children.findIndex((n) => n.name === e) !== -1)
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(t, e) {
    if (Reflect.has(t, e))
      return t[e];
    const n = t[ut].type.children.findIndex((s) => s.name === e);
    if (n !== -1) {
      const s = X.visit(t[ut].children[n], t[pe]);
      return Reflect.set(t, e, s), s;
    }
  }
  set(t, e, n) {
    const s = t[ut].type.children.findIndex((r) => r.name === e);
    return s !== -1 ? (lt.visit(t[ut].children[s], t[pe], n), Reflect.set(t, e, n)) : Reflect.has(t, e) || typeof e == "symbol" ? Reflect.set(t, e, n) : !1;
  }
}
class y extends F {
}
function w(i) {
  return (t, e) => t.getValid(e) ? i(t, e) : null;
}
const Ea = (i, t) => 864e5 * i[t], za = (i, t) => null, Mr = (i, t, e) => {
  if (e + 1 >= t.length)
    return null;
  const n = z(t[e]), s = z(t[e + 1]);
  return i.subarray(n, s);
}, ja = ({ offset: i, values: t }, e) => {
  const n = i + e;
  return (t[n >> 3] & 1 << n % 8) !== 0;
}, Lr = ({ values: i }, t) => Ea(i, t), Nr = ({ values: i }, t) => z(i[t]), Jt = ({ stride: i, values: t }, e) => t[i * e], ka = ({ stride: i, values: t }, e) => yr(t[i * e]), Ur = ({ values: i }, t) => i[t], Pa = ({ stride: i, values: t }, e) => t.subarray(i * e, i * (e + 1)), xr = ({ values: i, valueOffsets: t }, e) => Mr(i, t, e), Vr = ({ values: i, valueOffsets: t }, e) => {
  const n = Mr(i, t, e);
  return n !== null ? Xi(n) : null;
}, $a = ({ values: i }, t) => i[t], Wa = ({ type: i, values: t }, e) => i.precision !== Y.HALF ? t[e] : yr(t[e]), Ya = (i, t) => i.type.unit === ct.DAY ? Lr(i, t) : Nr(i, t), Rr = ({ values: i }, t) => 1e3 * z(i[t]), Cr = ({ values: i }, t) => z(i[t]), Er = ({ values: i }, t) => Cs(i[t], BigInt(1e3)), zr = ({ values: i }, t) => Cs(i[t], BigInt(1e6)), Ja = (i, t) => {
  switch (i.type.unit) {
    case p.SECOND:
      return Rr(i, t);
    case p.MILLISECOND:
      return Cr(i, t);
    case p.MICROSECOND:
      return Er(i, t);
    case p.NANOSECOND:
      return zr(i, t);
  }
}, jr = ({ values: i }, t) => i[t], kr = ({ values: i }, t) => i[t], Pr = ({ values: i }, t) => i[t], $r = ({ values: i }, t) => i[t], Ha = (i, t) => {
  switch (i.type.unit) {
    case p.SECOND:
      return jr(i, t);
    case p.MILLISECOND:
      return kr(i, t);
    case p.MICROSECOND:
      return Pr(i, t);
    case p.NANOSECOND:
      return $r(i, t);
  }
}, Ka = ({ values: i, stride: t }, e) => gn.decimal(i.subarray(t * e, t * (e + 1))), Ga = (i, t) => {
  const { valueOffsets: e, stride: n, children: s } = i, { [t * n]: r, [t * n + 1]: o } = e, c = s[0].slice(r, o - r);
  return new D([c]);
}, Za = (i, t) => {
  const { valueOffsets: e, children: n } = i, { [t]: s, [t + 1]: r } = e, o = n[0];
  return new Ei(o.slice(s, r - s));
}, qa = (i, t) => new Rn(i, t), Qa = (i, t) => i.type.mode === q.Dense ? Wr(i, t) : Yr(i, t), Wr = (i, t) => {
  const e = i.type.typeIdToChildIndex[i.typeIds[t]], n = i.children[e];
  return X.visit(n, i.valueOffsets[t]);
}, Yr = (i, t) => {
  const e = i.type.typeIdToChildIndex[i.typeIds[t]], n = i.children[e];
  return X.visit(n, t);
}, Xa = (i, t) => {
  var e;
  return (e = i.dictionary) === null || e === void 0 ? void 0 : e.get(i.values[t]);
}, tc = (i, t) => i.type.unit === Dt.DAY_TIME ? Jr(i, t) : Hr(i, t), Jr = ({ values: i }, t) => i.subarray(2 * t, 2 * (t + 1)), Hr = ({ values: i }, t) => {
  const e = i[t], n = new Int32Array(2);
  return n[0] = Math.trunc(e / 12), n[1] = Math.trunc(e % 12), n;
}, Kr = ({ values: i }, t) => i[t], Gr = ({ values: i }, t) => i[t], Zr = ({ values: i }, t) => i[t], qr = ({ values: i }, t) => i[t], ec = (i, t) => {
  switch (i.type.unit) {
    case p.SECOND:
      return Kr(i, t);
    case p.MILLISECOND:
      return Gr(i, t);
    case p.MICROSECOND:
      return Zr(i, t);
    case p.NANOSECOND:
      return qr(i, t);
  }
}, ic = (i, t) => {
  const { stride: e, children: n } = i, r = n[0].slice(t * e, e);
  return new D([r]);
};
y.prototype.visitNull = w(za);
y.prototype.visitBool = w(ja);
y.prototype.visitInt = w($a);
y.prototype.visitInt8 = w(Jt);
y.prototype.visitInt16 = w(Jt);
y.prototype.visitInt32 = w(Jt);
y.prototype.visitInt64 = w(Ur);
y.prototype.visitUint8 = w(Jt);
y.prototype.visitUint16 = w(Jt);
y.prototype.visitUint32 = w(Jt);
y.prototype.visitUint64 = w(Ur);
y.prototype.visitFloat = w(Wa);
y.prototype.visitFloat16 = w(ka);
y.prototype.visitFloat32 = w(Jt);
y.prototype.visitFloat64 = w(Jt);
y.prototype.visitUtf8 = w(Vr);
y.prototype.visitLargeUtf8 = w(Vr);
y.prototype.visitBinary = w(xr);
y.prototype.visitLargeBinary = w(xr);
y.prototype.visitFixedSizeBinary = w(Pa);
y.prototype.visitDate = w(Ya);
y.prototype.visitDateDay = w(Lr);
y.prototype.visitDateMillisecond = w(Nr);
y.prototype.visitTimestamp = w(Ja);
y.prototype.visitTimestampSecond = w(Rr);
y.prototype.visitTimestampMillisecond = w(Cr);
y.prototype.visitTimestampMicrosecond = w(Er);
y.prototype.visitTimestampNanosecond = w(zr);
y.prototype.visitTime = w(Ha);
y.prototype.visitTimeSecond = w(jr);
y.prototype.visitTimeMillisecond = w(kr);
y.prototype.visitTimeMicrosecond = w(Pr);
y.prototype.visitTimeNanosecond = w($r);
y.prototype.visitDecimal = w(Ka);
y.prototype.visitList = w(Ga);
y.prototype.visitStruct = w(qa);
y.prototype.visitUnion = w(Qa);
y.prototype.visitDenseUnion = w(Wr);
y.prototype.visitSparseUnion = w(Yr);
y.prototype.visitDictionary = w(Xa);
y.prototype.visitInterval = w(tc);
y.prototype.visitIntervalDayTime = w(Jr);
y.prototype.visitIntervalYearMonth = w(Hr);
y.prototype.visitDuration = w(ec);
y.prototype.visitDurationSecond = w(Kr);
y.prototype.visitDurationMillisecond = w(Gr);
y.prototype.visitDurationMicrosecond = w(Zr);
y.prototype.visitDurationNanosecond = w(qr);
y.prototype.visitFixedSizeList = w(ic);
y.prototype.visitMap = w(Za);
const X = new y(), Kt = /* @__PURE__ */ Symbol.for("keys"), ye = /* @__PURE__ */ Symbol.for("vals"), le = /* @__PURE__ */ Symbol.for("kKeysAsStrings"), an = /* @__PURE__ */ Symbol.for("_kKeysAsStrings");
class Ei {
  constructor(t) {
    return this[Kt] = new D([t.children[0]]).memoize(), this[ye] = t.children[1], new Proxy(this, new sc());
  }
  /** @ignore */
  get [le]() {
    return this[an] || (this[an] = Array.from(this[Kt].toArray(), String));
  }
  [Symbol.iterator]() {
    return new nc(this[Kt], this[ye]);
  }
  get size() {
    return this[Kt].length;
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const t = this[Kt], e = this[ye], n = {};
    for (let s = -1, r = t.length; ++s < r; )
      n[t.get(s)] = X.visit(e, s);
    return n;
  }
  toString() {
    return `{${[...this].map(([t, e]) => `${Zt(t)}: ${Zt(e)}`).join(", ")}}`;
  }
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
}
class nc {
  constructor(t, e) {
    this.keys = t, this.vals = e, this.keyIndex = 0, this.numKeys = t.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const t = this.keyIndex;
    return t === this.numKeys ? { done: !0, value: null } : (this.keyIndex++, {
      done: !1,
      value: [
        this.keys.get(t),
        X.visit(this.vals, t)
      ]
    });
  }
}
class sc {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(t) {
    return t[le];
  }
  has(t, e) {
    return t[le].includes(e);
  }
  getOwnPropertyDescriptor(t, e) {
    if (t[le].indexOf(e) !== -1)
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(t, e) {
    if (Reflect.has(t, e))
      return t[e];
    const n = t[le].indexOf(e);
    if (n !== -1) {
      const s = X.visit(Reflect.get(t, ye), n);
      return Reflect.set(t, e, s), s;
    }
  }
  set(t, e, n) {
    const s = t[le].indexOf(e);
    return s !== -1 ? (lt.visit(Reflect.get(t, ye), s, n), Reflect.set(t, e, n)) : Reflect.has(t, e) ? Reflect.set(t, e, n) : !1;
  }
}
Object.defineProperties(Ei.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [Kt]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [ye]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [an]: { writable: !0, enumerable: !1, configurable: !1, value: null }
});
let ls;
function Qr(i, t, e, n) {
  const { length: s = 0 } = i;
  let r = typeof t != "number" ? 0 : t, o = typeof e != "number" ? s : e;
  return r < 0 && (r = (r % s + s) % s), o < 0 && (o = (o % s + s) % s), o < r && (ls = r, r = o, o = ls), o > s && (o = s), n ? n(i, r, o) : [r, o];
}
const Cn = (i, t) => i < 0 ? t + i : i, us = (i) => i !== i;
function Se(i) {
  if (typeof i !== "object" || i === null)
    return us(i) ? us : (e) => e === i;
  if (i instanceof Date) {
    const e = i.valueOf();
    return (n) => n instanceof Date ? n.valueOf() === e : !1;
  }
  return ArrayBuffer.isView(i) ? (e) => e ? la(i, e) : !1 : i instanceof Map ? oc(i) : Array.isArray(i) ? rc(i) : i instanceof D ? ac(i) : cc(i, !0);
}
function rc(i) {
  const t = [];
  for (let e = -1, n = i.length; ++e < n; )
    t[e] = Se(i[e]);
  return zi(t);
}
function oc(i) {
  let t = -1;
  const e = [];
  for (const n of i.values())
    e[++t] = Se(n);
  return zi(e);
}
function ac(i) {
  const t = [];
  for (let e = -1, n = i.length; ++e < n; )
    t[e] = Se(i.get(e));
  return zi(t);
}
function cc(i, t = !1) {
  const e = Object.keys(i);
  if (!t && e.length === 0)
    return () => !1;
  const n = [];
  for (let s = -1, r = e.length; ++s < r; )
    n[s] = Se(i[e[s]]);
  return zi(n, e);
}
function zi(i, t) {
  return (e) => {
    if (!e || typeof e != "object")
      return !1;
    switch (e.constructor) {
      case Array:
        return lc(i, e);
      case Map:
        return ds(i, e, e.keys());
      case Ei:
      case Rn:
      case Object:
      case void 0:
        return ds(i, e, t || Object.keys(e));
    }
    return e instanceof D ? uc(i, e) : !1;
  };
}
function lc(i, t) {
  const e = i.length;
  if (t.length !== e)
    return !1;
  for (let n = -1; ++n < e; )
    if (!i[n](t[n]))
      return !1;
  return !0;
}
function uc(i, t) {
  const e = i.length;
  if (t.length !== e)
    return !1;
  for (let n = -1; ++n < e; )
    if (!i[n](t.get(n)))
      return !1;
  return !0;
}
function ds(i, t, e) {
  const n = e[Symbol.iterator](), s = t instanceof Map ? t.keys() : Object.keys(t)[Symbol.iterator](), r = t instanceof Map ? t.values() : Object.values(t)[Symbol.iterator]();
  let o = 0;
  const a = i.length;
  let c = r.next(), u = n.next(), d = s.next();
  for (; o < a && !u.done && !d.done && !c.done && !(u.value !== d.value || !i[o](c.value)); ++o, u = n.next(), d = s.next(), c = r.next())
    ;
  return o === a && u.done && d.done && c.done ? !0 : (n.return && n.return(), s.return && s.return(), r.return && r.return(), !1);
}
function Xr(i, t, e, n) {
  return (e & 1 << n) !== 0;
}
function dc(i, t, e, n) {
  return (e & 1 << n) >> n;
}
function hs(i, t, e) {
  const n = e.byteLength + 7 & -8;
  if (i > 0 || e.byteLength < n) {
    const s = new Uint8Array(n);
    return s.set(i % 8 === 0 ? e.subarray(i >> 3) : (
      // Otherwise iterate each bit from the offset and return a new one
      cn(new En(e, i, t, null, Xr)).subarray(0, n)
    )), s;
  }
  return e;
}
function cn(i) {
  const t = [];
  let e = 0, n = 0, s = 0;
  for (const o of i)
    o && (s |= 1 << n), ++n === 8 && (t[e++] = s, s = n = 0);
  (e === 0 || n > 0) && (t[e++] = s);
  const r = new Uint8Array(t.length + 7 & -8);
  return r.set(t), r;
}
class En {
  constructor(t, e, n, s, r) {
    this.bytes = t, this.length = n, this.context = s, this.get = r, this.bit = e % 8, this.byteIndex = e >> 3, this.byte = t[this.byteIndex++], this.index = 0;
  }
  next() {
    return this.index < this.length ? (this.bit === 8 && (this.bit = 0, this.byte = this.bytes[this.byteIndex++]), {
      value: this.get(this.context, this.index++, this.byte, this.bit++)
    }) : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function ln(i, t, e) {
  if (e - t <= 0)
    return 0;
  if (e - t < 8) {
    let r = 0;
    for (const o of new En(i, t, e - t, i, dc))
      r += o;
    return r;
  }
  const n = e >> 3 << 3, s = t + (t % 8 === 0 ? 0 : 8 - t % 8);
  return (
    // Get the popcnt of bits between the left hand side, and the next highest multiple of 8
    ln(i, t, s) + // Get the popcnt of bits between the right hand side, and the next lowest multiple of 8
    ln(i, n, e) + // Get the popcnt of all bits between the left and right hand sides' multiples of 8
    hc(i, s >> 3, n - s >> 3)
  );
}
function hc(i, t, e) {
  let n = 0, s = Math.trunc(t);
  const r = new DataView(i.buffer, i.byteOffset, i.byteLength), o = e === void 0 ? i.byteLength : s + e;
  for (; o - s >= 4; )
    n += Gi(r.getUint32(s)), s += 4;
  for (; o - s >= 2; )
    n += Gi(r.getUint16(s)), s += 2;
  for (; o - s >= 1; )
    n += Gi(r.getUint8(s)), s += 1;
  return n;
}
function Gi(i) {
  let t = Math.trunc(i);
  return t = t - (t >>> 1 & 1431655765), t = (t & 858993459) + (t >>> 2 & 858993459), (t + (t >>> 4) & 252645135) * 16843009 >>> 24;
}
const fc = -1;
class L {
  get typeId() {
    return this.type.typeId;
  }
  get ArrayType() {
    return this.type.ArrayType;
  }
  get buffers() {
    return [this.valueOffsets, this.values, this.nullBitmap, this.typeIds];
  }
  get nullable() {
    if (this._nullCount !== 0) {
      const { type: t } = this;
      return f.isSparseUnion(t) ? this.children.some((e) => e.nullable) : f.isDenseUnion(t) ? this.children.some((e) => e.nullable) : this.nullBitmap && this.nullBitmap.byteLength > 0;
    }
    return !0;
  }
  get byteLength() {
    let t = 0;
    const { valueOffsets: e, values: n, nullBitmap: s, typeIds: r } = this;
    return e && (t += e.byteLength), n && (t += n.byteLength), s && (t += s.byteLength), r && (t += r.byteLength), this.children.reduce((o, a) => o + a.byteLength, t);
  }
  get nullCount() {
    if (f.isUnion(this.type))
      return this.children.reduce((n, s) => n + s.nullCount, 0);
    let t = this._nullCount, e;
    return t <= fc && (e = this.nullBitmap) && (this._nullCount = t = e.length === 0 ? (
      // no null bitmap, so all values are valid
      0
    ) : this.length - ln(e, this.offset, this.offset + this.length)), t;
  }
  constructor(t, e, n, s, r, o = [], a) {
    this.type = t, this.children = o, this.dictionary = a, this.offset = Math.floor(Math.max(e || 0, 0)), this.length = Math.floor(Math.max(n || 0, 0)), this._nullCount = Math.floor(Math.max(s || 0, -1));
    let c;
    r instanceof L ? (this.stride = r.stride, this.values = r.values, this.typeIds = r.typeIds, this.nullBitmap = r.nullBitmap, this.valueOffsets = r.valueOffsets) : (this.stride = _t(t), r && ((c = r[0]) && (this.valueOffsets = c), (c = r[1]) && (this.values = c), (c = r[2]) && (this.nullBitmap = c), (c = r[3]) && (this.typeIds = c)));
  }
  getValid(t) {
    const { type: e } = this;
    if (f.isUnion(e)) {
      const n = e, s = this.children[n.typeIdToChildIndex[this.typeIds[t]]], r = n.mode === q.Dense ? this.valueOffsets[t] : t;
      return s.getValid(r);
    }
    if (this.nullable && this.nullCount > 0) {
      const n = this.offset + t;
      return (this.nullBitmap[n >> 3] & 1 << n % 8) !== 0;
    }
    return !0;
  }
  setValid(t, e) {
    let n;
    const { type: s } = this;
    if (f.isUnion(s)) {
      const r = s, o = this.children[r.typeIdToChildIndex[this.typeIds[t]]], a = r.mode === q.Dense ? this.valueOffsets[t] : t;
      n = o.getValid(a), o.setValid(a, e);
    } else {
      let { nullBitmap: r } = this;
      const { offset: o, length: a } = this, c = o + t, u = 1 << c % 8, d = c >> 3;
      (!r || r.byteLength <= d) && (r = new Uint8Array((o + a + 63 & -64) >> 3).fill(255), this.nullCount > 0 ? (r.set(hs(o, a, this.nullBitmap), 0), Object.assign(this, { nullBitmap: r })) : Object.assign(this, { nullBitmap: r, _nullCount: 0 }));
      const h = r[d];
      n = (h & u) !== 0, r[d] = e ? h | u : h & ~u;
    }
    return n !== !!e && (this._nullCount = this.nullCount + (e ? -1 : 1)), e;
  }
  clone(t = this.type, e = this.offset, n = this.length, s = this._nullCount, r = this, o = this.children) {
    return new L(t, e, n, s, r, o, this.dictionary);
  }
  slice(t, e) {
    const { stride: n, typeId: s, children: r } = this, o = +(this._nullCount === 0) - 1, a = s === 16 ? n : 1, c = this._sliceBuffers(t, e, n, s);
    return this.clone(
      this.type,
      this.offset + t,
      e,
      o,
      c,
      // Don't slice children if we have value offsets (the variable-width types)
      r.length === 0 || this.valueOffsets ? r : this._sliceChildren(r, a * t, a * e)
    );
  }
  _changeLengthAndBackfillNullBitmap(t) {
    if (this.typeId === l.Null)
      return this.clone(this.type, 0, t, 0);
    const { length: e, nullCount: n } = this, s = new Uint8Array((t + 63 & -64) >> 3).fill(255, 0, e >> 3);
    s[e >> 3] = (1 << e - (e & -8)) - 1, n > 0 && s.set(hs(this.offset, e, this.nullBitmap), 0);
    const r = this.buffers;
    return r[Ft.VALIDITY] = s, this.clone(this.type, 0, t, n + (t - e), r);
  }
  _sliceBuffers(t, e, n, s) {
    let r;
    const { buffers: o } = this;
    return (r = o[Ft.TYPE]) && (o[Ft.TYPE] = r.subarray(t, t + e)), (r = o[Ft.OFFSET]) && (o[Ft.OFFSET] = r.subarray(t, t + e + 1)) || // Otherwise if no offsets, slice the data buffer. Don't slice the data vector for Booleans, since the offset goes by bits not bytes
    (r = o[Ft.DATA]) && (o[Ft.DATA] = s === 6 ? r : r.subarray(n * t, n * (t + e))), o;
  }
  _sliceChildren(t, e, n) {
    return t.map((s) => s.slice(e, n));
  }
}
L.prototype.children = Object.freeze([]);
class Ee extends F {
  visit(t) {
    return this.getVisitFn(t.type).call(this, t);
  }
  visitNull(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["length"]: s = 0 } = t;
    return new L(e, n, s, s);
  }
  visitBool(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length >> 3, ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitInt(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length, ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitFloat(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length, ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitUtf8(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.data), r = T(t.nullBitmap), o = Te(t.valueOffsets), { ["length"]: a = o.length - 1, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, a, c, [o, s, r]);
  }
  visitLargeUtf8(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.data), r = T(t.nullBitmap), o = Qn(t.valueOffsets), { ["length"]: a = o.length - 1, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, a, c, [o, s, r]);
  }
  visitBinary(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.data), r = T(t.nullBitmap), o = Te(t.valueOffsets), { ["length"]: a = o.length - 1, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, a, c, [o, s, r]);
  }
  visitLargeBinary(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.data), r = T(t.nullBitmap), o = Qn(t.valueOffsets), { ["length"]: a = o.length - 1, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, a, c, [o, s, r]);
  }
  visitFixedSizeBinary(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length / _t(e), ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitDate(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length / _t(e), ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitTimestamp(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length / _t(e), ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitTime(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length / _t(e), ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitDecimal(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length / _t(e), ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitList(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["child"]: s } = t, r = T(t.nullBitmap), o = Te(t.valueOffsets), { ["length"]: a = o.length - 1, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, a, c, [o, void 0, r], [s]);
  }
  visitStruct(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["children"]: s = [] } = t, r = T(t.nullBitmap), { length: o = s.reduce((c, { length: u }) => Math.max(c, u), 0), nullCount: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, void 0, r], s);
  }
  visitUnion(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["children"]: s = [] } = t, r = C(e.ArrayType, t.typeIds), { ["length"]: o = r.length, ["nullCount"]: a = -1 } = t;
    if (f.isSparseUnion(e))
      return new L(e, n, o, a, [void 0, void 0, void 0, r], s);
    const c = Te(t.valueOffsets);
    return new L(e, n, o, a, [c, void 0, void 0, r], s);
  }
  visitDictionary(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.indices.ArrayType, t.data), { ["dictionary"]: o = new D([new Ee().visit({ type: e.dictionary })]) } = t, { ["length"]: a = r.length, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, a, c, [void 0, r, s], [], o);
  }
  visitInterval(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length / _t(e), ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitDuration(t) {
    const { ["type"]: e, ["offset"]: n = 0 } = t, s = T(t.nullBitmap), r = C(e.ArrayType, t.data), { ["length"]: o = r.length, ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, r, s]);
  }
  visitFixedSizeList(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["child"]: s = new Ee().visit({ type: e.valueType }) } = t, r = T(t.nullBitmap), { ["length"]: o = s.length / _t(e), ["nullCount"]: a = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, o, a, [void 0, void 0, r], [s]);
  }
  visitMap(t) {
    const { ["type"]: e, ["offset"]: n = 0, ["child"]: s = new Ee().visit({ type: e.childType }) } = t, r = T(t.nullBitmap), o = Te(t.valueOffsets), { ["length"]: a = o.length - 1, ["nullCount"]: c = t.nullBitmap ? -1 : 0 } = t;
    return new L(e, n, a, c, [o, void 0, r], [s]);
  }
}
const pc = new Ee();
function _(i) {
  return pc.visit(i);
}
class fs {
  constructor(t = 0, e) {
    this.numChunks = t, this.getChunkIterator = e, this.chunkIndex = 0, this.chunkIterator = this.getChunkIterator(0);
  }
  next() {
    for (; this.chunkIndex < this.numChunks; ) {
      const t = this.chunkIterator.next();
      if (!t.done)
        return t;
      ++this.chunkIndex < this.numChunks && (this.chunkIterator = this.getChunkIterator(this.chunkIndex));
    }
    return { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function yc(i) {
  return i.some((t) => t.nullable);
}
function to(i) {
  return i.reduce((t, e) => t + e.nullCount, 0);
}
function eo(i) {
  return i.reduce((t, e, n) => (t[n + 1] = t[n] + e.length, t), new Uint32Array(i.length + 1));
}
function io(i, t, e, n) {
  const s = [];
  for (let r = -1, o = i.length; ++r < o; ) {
    const a = i[r], c = t[r], { length: u } = a;
    if (c >= n)
      break;
    if (e >= c + u)
      continue;
    if (c >= e && c + u <= n) {
      s.push(a);
      continue;
    }
    const d = Math.max(0, e - c), h = Math.min(n - c, u);
    s.push(a.slice(d, h - d));
  }
  return s.length === 0 && s.push(i[0].slice(0, 0)), s;
}
function zn(i, t, e, n) {
  let s = 0, r = 0, o = t.length - 1;
  do {
    if (s >= o - 1)
      return e < t[o] ? n(i, s, e - t[s]) : null;
    r = s + Math.trunc((o - s) * 0.5), e < t[r] ? o = r : s = r;
  } while (s < o);
}
function jn(i, t) {
  return i.getValid(t);
}
function Ai(i) {
  function t(e, n, s) {
    return i(e[n], s);
  }
  return function(e) {
    const n = this.data;
    return zn(n, this._offsets, e, t);
  };
}
function no(i) {
  let t;
  function e(n, s, r) {
    return i(n[s], r, t);
  }
  return function(n, s) {
    const r = this.data;
    t = s;
    const o = zn(r, this._offsets, n, e);
    return t = void 0, o;
  };
}
function so(i) {
  let t;
  function e(n, s, r) {
    let o = r, a = 0, c = 0;
    for (let u = s - 1, d = n.length; ++u < d; ) {
      const h = n[u];
      if (~(a = i(h, t, o)))
        return c + a;
      o = 0, c += h.length;
    }
    return -1;
  }
  return function(n, s) {
    t = n;
    const r = this.data, o = typeof s != "number" ? e(r, 0, 0) : zn(r, this._offsets, s, e);
    return t = void 0, o;
  };
}
class g extends F {
}
function gc(i, t) {
  return t === null && i.length > 0 ? 0 : -1;
}
function mc(i, t) {
  const { nullBitmap: e } = i;
  if (!e || i.nullCount <= 0)
    return -1;
  let n = 0;
  for (const s of new En(e, i.offset + (t || 0), i.length, e, Xr)) {
    if (!s)
      return n;
    ++n;
  }
  return -1;
}
function B(i, t, e) {
  if (t === void 0)
    return -1;
  if (t === null)
    switch (i.typeId) {
      // Unions don't have a nullBitmap of its own, so compare the `searchElement` to `get()`.
      case l.Union:
        break;
      // Dictionaries do have a nullBitmap, but their dictionary could also have null elements.
      case l.Dictionary:
        break;
      // All other types can iterate the null bitmap
      default:
        return mc(i, e);
    }
  const n = X.getVisitFn(i), s = Se(t);
  for (let r = (e || 0) - 1, o = i.length; ++r < o; )
    if (s(n(i, r)))
      return r;
  return -1;
}
function ro(i, t, e) {
  const n = X.getVisitFn(i), s = Se(t);
  for (let r = (e || 0) - 1, o = i.length; ++r < o; )
    if (s(n(i, r)))
      return r;
  return -1;
}
g.prototype.visitNull = gc;
g.prototype.visitBool = B;
g.prototype.visitInt = B;
g.prototype.visitInt8 = B;
g.prototype.visitInt16 = B;
g.prototype.visitInt32 = B;
g.prototype.visitInt64 = B;
g.prototype.visitUint8 = B;
g.prototype.visitUint16 = B;
g.prototype.visitUint32 = B;
g.prototype.visitUint64 = B;
g.prototype.visitFloat = B;
g.prototype.visitFloat16 = B;
g.prototype.visitFloat32 = B;
g.prototype.visitFloat64 = B;
g.prototype.visitUtf8 = B;
g.prototype.visitLargeUtf8 = B;
g.prototype.visitBinary = B;
g.prototype.visitLargeBinary = B;
g.prototype.visitFixedSizeBinary = B;
g.prototype.visitDate = B;
g.prototype.visitDateDay = B;
g.prototype.visitDateMillisecond = B;
g.prototype.visitTimestamp = B;
g.prototype.visitTimestampSecond = B;
g.prototype.visitTimestampMillisecond = B;
g.prototype.visitTimestampMicrosecond = B;
g.prototype.visitTimestampNanosecond = B;
g.prototype.visitTime = B;
g.prototype.visitTimeSecond = B;
g.prototype.visitTimeMillisecond = B;
g.prototype.visitTimeMicrosecond = B;
g.prototype.visitTimeNanosecond = B;
g.prototype.visitDecimal = B;
g.prototype.visitList = B;
g.prototype.visitStruct = B;
g.prototype.visitUnion = B;
g.prototype.visitDenseUnion = ro;
g.prototype.visitSparseUnion = ro;
g.prototype.visitDictionary = B;
g.prototype.visitInterval = B;
g.prototype.visitIntervalDayTime = B;
g.prototype.visitIntervalYearMonth = B;
g.prototype.visitDuration = B;
g.prototype.visitDurationSecond = B;
g.prototype.visitDurationMillisecond = B;
g.prototype.visitDurationMicrosecond = B;
g.prototype.visitDurationNanosecond = B;
g.prototype.visitFixedSizeList = B;
g.prototype.visitMap = B;
const Oi = new g();
class m extends F {
}
function I(i) {
  const { type: t } = i;
  if (i.nullCount === 0 && i.stride === 1 && // Don't defer to native iterator for timestamps since Numbers are expected
  // (DataType.isTimestamp(type)) && type.unit === TimeUnit.MILLISECOND ||
  (f.isInt(t) && t.bitWidth !== 64 || f.isTime(t) && t.bitWidth !== 64 || f.isFloat(t) && t.precision !== Y.HALF))
    return new fs(i.data.length, (n) => {
      const s = i.data[n];
      return s.values.subarray(0, s.length)[Symbol.iterator]();
    });
  let e = 0;
  return new fs(i.data.length, (n) => {
    const r = i.data[n].length, o = i.slice(e, e + r);
    return e += r, new bc(o);
  });
}
class bc {
  constructor(t) {
    this.vector = t, this.index = 0;
  }
  next() {
    return this.index < this.vector.length ? {
      value: this.vector.get(this.index++)
    } : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
m.prototype.visitNull = I;
m.prototype.visitBool = I;
m.prototype.visitInt = I;
m.prototype.visitInt8 = I;
m.prototype.visitInt16 = I;
m.prototype.visitInt32 = I;
m.prototype.visitInt64 = I;
m.prototype.visitUint8 = I;
m.prototype.visitUint16 = I;
m.prototype.visitUint32 = I;
m.prototype.visitUint64 = I;
m.prototype.visitFloat = I;
m.prototype.visitFloat16 = I;
m.prototype.visitFloat32 = I;
m.prototype.visitFloat64 = I;
m.prototype.visitUtf8 = I;
m.prototype.visitLargeUtf8 = I;
m.prototype.visitBinary = I;
m.prototype.visitLargeBinary = I;
m.prototype.visitFixedSizeBinary = I;
m.prototype.visitDate = I;
m.prototype.visitDateDay = I;
m.prototype.visitDateMillisecond = I;
m.prototype.visitTimestamp = I;
m.prototype.visitTimestampSecond = I;
m.prototype.visitTimestampMillisecond = I;
m.prototype.visitTimestampMicrosecond = I;
m.prototype.visitTimestampNanosecond = I;
m.prototype.visitTime = I;
m.prototype.visitTimeSecond = I;
m.prototype.visitTimeMillisecond = I;
m.prototype.visitTimeMicrosecond = I;
m.prototype.visitTimeNanosecond = I;
m.prototype.visitDecimal = I;
m.prototype.visitList = I;
m.prototype.visitStruct = I;
m.prototype.visitUnion = I;
m.prototype.visitDenseUnion = I;
m.prototype.visitSparseUnion = I;
m.prototype.visitDictionary = I;
m.prototype.visitInterval = I;
m.prototype.visitIntervalDayTime = I;
m.prototype.visitIntervalYearMonth = I;
m.prototype.visitDuration = I;
m.prototype.visitDurationSecond = I;
m.prototype.visitDurationMillisecond = I;
m.prototype.visitDurationMicrosecond = I;
m.prototype.visitDurationNanosecond = I;
m.prototype.visitFixedSizeList = I;
m.prototype.visitMap = I;
const kn = new m();
var oo;
const ao = {}, co = {};
class D {
  constructor(t) {
    var e, n, s;
    const r = t[0] instanceof D ? t.flatMap((a) => a.data) : t;
    if (r.length === 0 || r.some((a) => !(a instanceof L)))
      throw new TypeError("Vector constructor expects an Array of Data instances.");
    const o = (e = r[0]) === null || e === void 0 ? void 0 : e.type;
    switch (r.length) {
      case 0:
        this._offsets = [0];
        break;
      case 1: {
        const { get: a, set: c, indexOf: u } = ao[o.typeId], d = r[0];
        this.isValid = (h) => jn(d, h), this.get = (h) => a(d, h), this.set = (h, k) => c(d, h, k), this.indexOf = (h) => u(d, h), this._offsets = [0, d.length];
        break;
      }
      default:
        Object.setPrototypeOf(this, co[o.typeId]), this._offsets = eo(r);
        break;
    }
    this.data = r, this.type = o, this.stride = _t(o), this.numChildren = (s = (n = o.children) === null || n === void 0 ? void 0 : n.length) !== null && s !== void 0 ? s : 0, this.length = this._offsets.at(-1);
  }
  /**
   * The aggregate size (in bytes) of this Vector's buffers and/or child Vectors.
   */
  get byteLength() {
    return this.data.reduce((t, e) => t + e.byteLength, 0);
  }
  /**
   * Whether this Vector's elements can contain null values.
   */
  get nullable() {
    return yc(this.data);
  }
  /**
   * The number of null elements in this Vector.
   */
  get nullCount() {
    return to(this.data);
  }
  /**
   * The Array or TypedArray constructor used for the JS representation
   *  of the element's values in {@link Vector.prototype.toArray `toArray()`}.
   */
  get ArrayType() {
    return this.type.ArrayType;
  }
  /**
   * The name that should be printed when the Vector is logged in a message.
   */
  get [Symbol.toStringTag]() {
    return `${this.VectorName}<${this.type[Symbol.toStringTag]}>`;
  }
  /**
   * The name of this Vector.
   */
  get VectorName() {
    return `${l[this.type.typeId]}Vector`;
  }
  /**
   * Check whether an element is null.
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(t) {
    return !1;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(t) {
    return null;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read. A negative index will count back from the last element.
   */
  at(t) {
    return this.get(Cn(t, this.length));
  }
  /**
   * Set an element value by position.
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(t, e) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(t, e) {
    return -1;
  }
  includes(t, e) {
    return this.indexOf(t, e) > -1;
  }
  /**
   * Iterator for the Vector's elements.
   */
  [Symbol.iterator]() {
    return kn.visit(this);
  }
  /**
   * Combines two or more Vectors of the same type.
   * @param others Additional Vectors to add to the end of this Vector.
   */
  concat(...t) {
    return new D(this.data.concat(t.flatMap((e) => e.data).flat(Number.POSITIVE_INFINITY)));
  }
  /**
   * Return a zero-copy sub-section of this Vector.
   * @param start The beginning of the specified portion of the Vector.
   * @param end The end of the specified portion of the Vector. This is exclusive of the element at the index 'end'.
   */
  slice(t, e) {
    return new D(Qr(this, t, e, ({ data: n, _offsets: s }, r, o) => io(n, s, r, o)));
  }
  toJSON() {
    return [...this];
  }
  /**
   * Return a JavaScript Array or TypedArray of the Vector's elements.
   *
   * @note If this Vector contains a single Data chunk and the Vector's type is a
   *  primitive numeric type corresponding to one of the JavaScript TypedArrays, this
   *  method returns a zero-copy slice of the underlying TypedArray values. If there's
   *  more than one chunk, the resulting TypedArray will be a copy of the data from each
   *  chunk's underlying TypedArray values.
   *
   * @returns An Array or TypedArray of the Vector's elements, based on the Vector's DataType.
   */
  toArray() {
    const { type: t, data: e, length: n, stride: s, ArrayType: r } = this;
    switch (t.typeId) {
      case l.Int:
      case l.Float:
      case l.Decimal:
      case l.Time:
      case l.Timestamp:
        switch (e.length) {
          case 0:
            return new r();
          case 1:
            return e[0].values.subarray(0, n * s);
          default:
            return e.reduce((o, { values: a, length: c }) => (o.array.set(a.subarray(0, c * s), o.offset), o.offset += c * s, o), { array: new r(n * s), offset: 0 }).array;
        }
    }
    return [...this];
  }
  /**
   * Returns a string representation of the Vector.
   *
   * @returns A string representation of the Vector.
   */
  toString() {
    return `[${[...this].join(",")}]`;
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(t) {
    var e;
    return this.getChildAt((e = this.type.children) === null || e === void 0 ? void 0 : e.findIndex((n) => n.name === t));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(t) {
    return t > -1 && t < this.numChildren ? new D(this.data.map(({ children: e }) => e[t])) : null;
  }
  get isMemoized() {
    return f.isDictionary(this.type) ? this.data[0].dictionary.isMemoized : !1;
  }
  /**
   * Adds memoization to the Vector's {@link get} method. For dictionary
   * vectors, this method return a vector that memoizes only the dictionary
   * values.
   *
   * Memoization is very useful when decoding a value is expensive such as
   * Utf8. The memoization creates a cache of the size of the Vector and
   * therefore increases memory usage.
   *
   * @returns A new vector that memoizes calls to {@link get}.
   */
  memoize() {
    if (f.isDictionary(this.type)) {
      const t = new Fi(this.data[0].dictionary), e = this.data.map((n) => {
        const s = n.clone();
        return s.dictionary = t, s;
      });
      return new D(e);
    }
    return new Fi(this);
  }
  /**
   * Returns a vector without memoization of the {@link get} method. If this
   * vector is not memoized, this method returns this vector.
   *
   * @returns A new vector without memoization.
   */
  unmemoize() {
    if (f.isDictionary(this.type) && this.isMemoized) {
      const t = this.data[0].dictionary.unmemoize(), e = this.data.map((n) => {
        const s = n.clone();
        return s.dictionary = t, s;
      });
      return new D(e);
    }
    return this;
  }
}
oo = Symbol.toStringTag;
D[oo] = ((i) => {
  i.type = f.prototype, i.data = [], i.length = 0, i.stride = 1, i.numChildren = 0, i._offsets = new Uint32Array([0]), i[Symbol.isConcatSpreadable] = !0;
  const t = Object.keys(l).map((e) => l[e]).filter((e) => typeof e == "number" && e !== l.NONE);
  for (const e of t) {
    const n = X.getVisitFnByTypeId(e), s = lt.getVisitFnByTypeId(e), r = Oi.getVisitFnByTypeId(e);
    ao[e] = { get: n, set: s, indexOf: r }, co[e] = Object.create(i, {
      isValid: { value: Ai(jn) },
      get: { value: Ai(X.getVisitFnByTypeId(e)) },
      set: { value: no(lt.getVisitFnByTypeId(e)) },
      indexOf: { value: so(Oi.getVisitFnByTypeId(e)) }
    });
  }
  return "Vector";
})(D.prototype);
class Fi extends D {
  constructor(t) {
    super(t.data);
    const e = this.get, n = this.set, s = this.slice, r = new Array(this.length);
    Object.defineProperty(this, "get", {
      value(o) {
        const a = r[o];
        if (a !== void 0)
          return a;
        const c = e.call(this, o);
        return r[o] = c, c;
      }
    }), Object.defineProperty(this, "set", {
      value(o, a) {
        n.call(this, o, a), r[o] = a;
      }
    }), Object.defineProperty(this, "slice", {
      value: (o, a) => new Fi(s.call(this, o, a))
    }), Object.defineProperty(this, "isMemoized", { value: !0 }), Object.defineProperty(this, "unmemoize", {
      value: () => new D(this.data)
    }), Object.defineProperty(this, "memoize", {
      value: () => this
    });
  }
}
function lo(i) {
  if (i) {
    if (i instanceof L)
      return new D([i]);
    if (i instanceof D)
      return new D(i.data);
    if (i.type instanceof f)
      return new D([_(i)]);
    if (Array.isArray(i))
      return new D(i.flatMap((t) => _c(t)));
    if (ArrayBuffer.isView(i)) {
      i instanceof DataView && (i = new Uint8Array(i.buffer));
      const t = { offset: 0, length: i.length, nullCount: -1, data: i };
      if (i instanceof Int8Array)
        return new D([_(Object.assign(Object.assign({}, t), { type: new ar() }))]);
      if (i instanceof Int16Array)
        return new D([_(Object.assign(Object.assign({}, t), { type: new cr() }))]);
      if (i instanceof Int32Array)
        return new D([_(Object.assign(Object.assign({}, t), { type: new qt() }))]);
      if (i instanceof BigInt64Array)
        return new D([_(Object.assign(Object.assign({}, t), { type: new mn() }))]);
      if (i instanceof Uint8Array || i instanceof Uint8ClampedArray)
        return new D([_(Object.assign(Object.assign({}, t), { type: new lr() }))]);
      if (i instanceof Uint16Array)
        return new D([_(Object.assign(Object.assign({}, t), { type: new ur() }))]);
      if (i instanceof Uint32Array)
        return new D([_(Object.assign(Object.assign({}, t), { type: new dr() }))]);
      if (i instanceof BigUint64Array)
        return new D([_(Object.assign(Object.assign({}, t), { type: new hr() }))]);
      if (i instanceof Float32Array)
        return new D([_(Object.assign(Object.assign({}, t), { type: new fr() }))]);
      if (i instanceof Float64Array)
        return new D([_(Object.assign(Object.assign({}, t), { type: new bn() }))]);
      throw new Error("Unrecognized input");
    }
  }
  throw new Error("Unrecognized input");
}
function _c(i) {
  return i instanceof L ? [i] : i instanceof D ? i.data : lo(i).data;
}
function vc(i) {
  if (!i || i.length <= 0)
    return function(s) {
      return !0;
    };
  let t = "";
  const e = i.filter((n) => n === n);
  return e.length > 0 && (t = `
    switch (x) {${e.map((n) => `
        case ${wc(n)}:`).join("")}
            return false;
    }`), i.length !== e.length && (t = `if (x !== x) return false;
${t}`), new Function("x", `${t}
return true;`);
}
function wc(i) {
  return typeof i != "bigint" ? Zt(i) : `${Zt(i)}n`;
}
function Zi(i, t) {
  const e = Math.ceil(i) * t - 1;
  return (e - e % 64 + 64 || 64) / t;
}
function ps(i, t = 0) {
  return i.length >= t ? i.subarray(0, t) : en(new i.constructor(t), i, 0);
}
class Ge {
  constructor(t, e = 0, n = 1) {
    this.length = Math.ceil(e / n), this.buffer = new t(this.length), this.stride = n, this.BYTES_PER_ELEMENT = t.BYTES_PER_ELEMENT, this.ArrayType = t;
  }
  get byteLength() {
    return Math.ceil(this.length * this.stride) * this.BYTES_PER_ELEMENT;
  }
  get reservedLength() {
    return this.buffer.length / this.stride;
  }
  get reservedByteLength() {
    return this.buffer.byteLength;
  }
  // @ts-ignore
  set(t, e) {
    return this;
  }
  append(t) {
    return this.set(this.length, t);
  }
  reserve(t) {
    if (t > 0) {
      this.length += t;
      const e = this.stride, n = this.length * e, s = this.buffer.length;
      n >= s && this._resize(s === 0 ? Zi(n * 1, this.BYTES_PER_ELEMENT) : Zi(n * 2, this.BYTES_PER_ELEMENT));
    }
    return this;
  }
  flush(t = this.length) {
    t = Zi(t * this.stride, this.BYTES_PER_ELEMENT);
    const e = ps(this.buffer, t);
    return this.clear(), e;
  }
  clear() {
    return this.length = 0, this.buffer = new this.ArrayType(), this;
  }
  _resize(t) {
    return this.buffer = ps(this.buffer, t);
  }
}
class Ze extends Ge {
  last() {
    return this.get(this.length - 1);
  }
  get(t) {
    return this.buffer[t];
  }
  set(t, e) {
    return this.reserve(t - this.length + 1), this.buffer[t * this.stride] = e, this;
  }
}
class uo extends Ze {
  constructor() {
    super(Uint8Array, 0, 1 / 8), this.numValid = 0;
  }
  get numInvalid() {
    return this.length - this.numValid;
  }
  get(t) {
    return this.buffer[t >> 3] >> t % 8 & 1;
  }
  set(t, e) {
    const { buffer: n } = this.reserve(t - this.length + 1), s = t >> 3, r = t % 8, o = n[s] >> r & 1;
    return e ? o === 0 && (n[s] |= 1 << r, ++this.numValid) : o === 1 && (n[s] &= ~(1 << r), --this.numValid), this;
  }
  clear() {
    return this.numValid = 0, super.clear();
  }
}
class ho extends Ze {
  constructor(t) {
    super(t.OffsetArrayType, 1, 1);
  }
  append(t) {
    return this.set(this.length - 1, t);
  }
  set(t, e) {
    const n = this.length - 1, s = this.reserve(t - n + 1).buffer;
    return n < t++ && n >= 0 && s.fill(s[n], n, t), s[t] = s[t - 1] + e, this;
  }
  flush(t = this.length - 1) {
    return t > this.length && this.set(t - 1, this.BYTES_PER_ELEMENT > 4 ? BigInt(0) : 0), super.flush(t + 1);
  }
}
let tt = class {
  /** @nocollapse */
  // @ts-ignore
  static throughNode(t) {
    throw new Error('"throughNode" not available in this environment');
  }
  /** @nocollapse */
  // @ts-ignore
  static throughDOM(t) {
    throw new Error('"throughDOM" not available in this environment');
  }
  /**
   * Construct a builder with the given Arrow DataType with optional null values,
   * which will be interpreted as "null" when set or appended to the `Builder`.
   * @param {{ type: T, nullValues?: any[] }} options A `BuilderOptions` object used to create this `Builder`.
   */
  constructor({ type: t, nullValues: e }) {
    this.length = 0, this.finished = !1, this.type = t, this.children = [], this.nullValues = e, this.stride = _t(t), this._nulls = new uo(), e && e.length > 0 && (this._isValid = vc(e));
  }
  /**
   * Flush the `Builder` and return a `Vector<T>`.
   * @returns {Vector<T>} A `Vector<T>` of the flushed values.
   */
  toVector() {
    return new D([this.flush()]);
  }
  get ArrayType() {
    return this.type.ArrayType;
  }
  get nullCount() {
    return this._nulls.numInvalid;
  }
  get numChildren() {
    return this.children.length;
  }
  /**
   * @returns The aggregate length (in bytes) of the values that have been written.
   */
  get byteLength() {
    let t = 0;
    const { _offsets: e, _values: n, _nulls: s, _typeIds: r, children: o } = this;
    return e && (t += e.byteLength), n && (t += n.byteLength), s && (t += s.byteLength), r && (t += r.byteLength), o.reduce((a, c) => a + c.byteLength, t);
  }
  /**
   * @returns The aggregate number of rows that have been reserved to write new values.
   */
  get reservedLength() {
    return this._nulls.reservedLength;
  }
  /**
   * @returns The aggregate length (in bytes) that has been reserved to write new values.
   */
  get reservedByteLength() {
    let t = 0;
    return this._offsets && (t += this._offsets.reservedByteLength), this._values && (t += this._values.reservedByteLength), this._nulls && (t += this._nulls.reservedByteLength), this._typeIds && (t += this._typeIds.reservedByteLength), this.children.reduce((e, n) => e + n.reservedByteLength, t);
  }
  get valueOffsets() {
    return this._offsets ? this._offsets.buffer : null;
  }
  get values() {
    return this._values ? this._values.buffer : null;
  }
  get nullBitmap() {
    return this._nulls ? this._nulls.buffer : null;
  }
  get typeIds() {
    return this._typeIds ? this._typeIds.buffer : null;
  }
  /**
   * Appends a value (or null) to this `Builder`.
   * This is equivalent to `builder.set(builder.length, value)`.
   * @param {T['TValue'] | TNull } value The value to append.
   */
  append(t) {
    return this.set(this.length, t);
  }
  /**
   * Validates whether a value is valid (true), or null (false)
   * @param {T['TValue'] | TNull } value The value to compare against null the value representations
   */
  isValid(t) {
    return this._isValid(t);
  }
  /**
   * Write a value (or null-value sentinel) at the supplied index.
   * If the value matches one of the null-value representations, a 1-bit is
   * written to the null `BitmapBufferBuilder`. Otherwise, a 0 is written to
   * the null `BitmapBufferBuilder`, and the value is passed to
   * `Builder.prototype.setValue()`.
   * @param {number} index The index of the value to write.
   * @param {T['TValue'] | TNull } value The value to write at the supplied index.
   * @returns {this} The updated `Builder` instance.
   */
  set(t, e) {
    return this.setValid(t, this.isValid(e)) && this.setValue(t, e), this;
  }
  /**
   * Write a value to the underlying buffers at the supplied index, bypassing
   * the null-value check. This is a low-level method that
   * @param {number} index
   * @param {T['TValue'] | TNull } value
   */
  setValue(t, e) {
    this._setValue(this, t, e);
  }
  setValid(t, e) {
    return this.length = this._nulls.set(t, +e).length, e;
  }
  // @ts-ignore
  addChild(t, e = `${this.numChildren}`) {
    throw new Error(`Cannot append children to non-nested type "${this.type}"`);
  }
  /**
   * Retrieve the child `Builder` at the supplied `index`, or null if no child
   * exists at that index.
   * @param {number} index The index of the child `Builder` to retrieve.
   * @returns {Builder | null} The child Builder at the supplied index or null.
   */
  getChildAt(t) {
    return this.children[t] || null;
  }
  /**
   * Commit all the values that have been written to their underlying
   * ArrayBuffers, including any child Builders if applicable, and reset
   * the internal `Builder` state.
   * @returns A `Data<T>` of the buffers and children representing the values written.
   */
  flush() {
    let t, e, n, s;
    const { type: r, length: o, nullCount: a, _typeIds: c, _offsets: u, _values: d, _nulls: h } = this;
    (e = c?.flush(o)) ? s = u?.flush(o) : (s = u?.flush(o)) ? t = d?.flush(u.last()) : t = d?.flush(o), a > 0 && (n = h?.flush(o));
    const k = this.children.map((M) => M.flush());
    return this.clear(), _({
      type: r,
      length: o,
      nullCount: a,
      children: k,
      child: k[0],
      data: t,
      typeIds: e,
      nullBitmap: n,
      valueOffsets: s
    });
  }
  /**
   * Finalize this `Builder`, and child builders if applicable.
   * @returns {this} The finalized `Builder` instance.
   */
  finish() {
    this.finished = !0;
    for (const t of this.children)
      t.finish();
    return this;
  }
  /**
   * Clear this Builder's internal state, including child Builders if applicable, and reset the length to 0.
   * @returns {this} The cleared `Builder` instance.
   */
  clear() {
    var t, e, n, s;
    this.length = 0, (t = this._nulls) === null || t === void 0 || t.clear(), (e = this._values) === null || e === void 0 || e.clear(), (n = this._offsets) === null || n === void 0 || n.clear(), (s = this._typeIds) === null || s === void 0 || s.clear();
    for (const r of this.children)
      r.clear();
    return this;
  }
};
tt.prototype.length = 1;
tt.prototype.stride = 1;
tt.prototype.children = null;
tt.prototype.finished = !1;
tt.prototype.nullValues = null;
tt.prototype._isValid = () => !0;
class Ct extends tt {
  constructor(t) {
    super(t), this._values = new Ze(this.ArrayType, 0, this.stride);
  }
  setValue(t, e) {
    const n = this._values;
    return n.reserve(t - n.length + 1), super.setValue(t, e);
  }
}
class Be extends tt {
  constructor(t) {
    super(t), this._pendingLength = 0, this._offsets = new ho(t.type);
  }
  setValue(t, e) {
    const n = this._pending || (this._pending = /* @__PURE__ */ new Map()), s = n.get(t);
    s && (this._pendingLength -= s.length), this._pendingLength += e instanceof Ei ? e[Kt].length : e.length, n.set(t, e);
  }
  setValid(t, e) {
    return super.setValid(t, e) ? !0 : ((this._pending || (this._pending = /* @__PURE__ */ new Map())).set(t, void 0), !1);
  }
  clear() {
    return this._pendingLength = 0, this._pending = void 0, super.clear();
  }
  flush() {
    return this._flush(), super.flush();
  }
  finish() {
    return this._flush(), super.finish();
  }
  _flush() {
    const t = this._pending, e = this._pendingLength;
    return this._pendingLength = 0, this._pending = void 0, t && t.size > 0 && this._flushPending(t, e), this;
  }
}
class un {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  /**
   * Index to the start of the RecordBlock (note this is past the Message header)
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * Length of the metadata
   */
  metaDataLength() {
    return this.bb.readInt32(this.bb_pos + 8);
  }
  /**
   * Length of the data (this is aligned so there can be a gap between this and
   * the metadata).
   */
  bodyLength() {
    return this.bb.readInt64(this.bb_pos + 16);
  }
  static sizeOf() {
    return 24;
  }
  static createBlock(t, e, n, s) {
    return t.prep(8, 24), t.writeInt64(BigInt(s ?? 0)), t.pad(4), t.writeInt32(n), t.writeInt64(BigInt(e ?? 0)), t.offset();
  }
}
class et {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsFooter(t, e) {
    return (e || new et()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFooter(t, e) {
    return t.setPosition(t.position() + V), (e || new et()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  version() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : P.V1;
  }
  schema(t) {
    const e = this.bb.__offset(this.bb_pos, 6);
    return e ? (t || new mt()).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
  }
  dictionaries(t, e) {
    const n = this.bb.__offset(this.bb_pos, 8);
    return n ? (e || new un()).__init(this.bb.__vector(this.bb_pos + n) + t * 24, this.bb) : null;
  }
  dictionariesLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  recordBatches(t, e) {
    const n = this.bb.__offset(this.bb_pos, 10);
    return n ? (e || new un()).__init(this.bb.__vector(this.bb_pos + n) + t * 24, this.bb) : null;
  }
  recordBatchesLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(t, e) {
    const n = this.bb.__offset(this.bb_pos, 12);
    return n ? (e || new $()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startFooter(t) {
    t.startObject(5);
  }
  static addVersion(t, e) {
    t.addFieldInt16(0, e, P.V1);
  }
  static addSchema(t, e) {
    t.addFieldOffset(1, e, 0);
  }
  static addDictionaries(t, e) {
    t.addFieldOffset(2, e, 0);
  }
  static startDictionariesVector(t, e) {
    t.startVector(24, e, 8);
  }
  static addRecordBatches(t, e) {
    t.addFieldOffset(3, e, 0);
  }
  static startRecordBatchesVector(t, e) {
    t.startVector(24, e, 8);
  }
  static addCustomMetadata(t, e) {
    t.addFieldOffset(4, e, 0);
  }
  static createCustomMetadataVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, e) {
    t.startVector(4, e, 4);
  }
  static endFooter(t) {
    return t.endObject();
  }
  static finishFooterBuffer(t, e) {
    t.finish(e);
  }
  static finishSizePrefixedFooterBuffer(t, e) {
    t.finish(e, void 0, !0);
  }
}
class x {
  constructor(t = [], e, n, s = P.V5) {
    this.fields = t || [], this.metadata = e || /* @__PURE__ */ new Map(), n || (n = dn(t)), this.dictionaries = n, this.metadataVersion = s;
  }
  get [Symbol.toStringTag]() {
    return "Schema";
  }
  get names() {
    return this.fields.map((t) => t.name);
  }
  toString() {
    return `Schema<{ ${this.fields.map((t, e) => `${e}: ${t}`).join(", ")} }>`;
  }
  /**
   * Construct a new Schema containing only specified fields.
   *
   * @param fieldNames Names of fields to keep.
   * @returns A new Schema of fields matching the specified names.
   */
  select(t) {
    const e = new Set(t), n = this.fields.filter((s) => e.has(s.name));
    return new x(n, this.metadata);
  }
  /**
   * Construct a new Schema containing only fields at the specified indices.
   *
   * @param fieldIndices Indices of fields to keep.
   * @returns A new Schema of fields at the specified indices.
   */
  selectAt(t) {
    const e = t.map((n) => this.fields[n]).filter(Boolean);
    return new x(e, this.metadata);
  }
  assign(...t) {
    const e = t[0] instanceof x ? t[0] : Array.isArray(t[0]) ? new x(t[0]) : new x(t), n = [...this.fields], s = ni(ni(/* @__PURE__ */ new Map(), this.metadata), e.metadata), r = e.fields.filter((a) => {
      const c = n.findIndex((u) => u.name === a.name);
      return ~c ? (n[c] = a.clone({
        metadata: ni(ni(/* @__PURE__ */ new Map(), n[c].metadata), a.metadata)
      })) && !1 : !0;
    }), o = dn(r, /* @__PURE__ */ new Map());
    return new x([...n, ...r], s, new Map([...this.dictionaries, ...o]));
  }
}
x.prototype.fields = null;
x.prototype.metadata = null;
x.prototype.dictionaries = null;
class N {
  /** @nocollapse */
  static new(...t) {
    let [e, n, s, r] = t;
    return t[0] && typeof t[0] == "object" && ({ name: e } = t[0], n === void 0 && (n = t[0].type), s === void 0 && (s = t[0].nullable), r === void 0 && (r = t[0].metadata)), new N(`${e}`, n, s, r);
  }
  constructor(t, e, n = !1, s) {
    this.name = t, this.type = e, this.nullable = n, this.metadata = s || /* @__PURE__ */ new Map();
  }
  get typeId() {
    return this.type.typeId;
  }
  get [Symbol.toStringTag]() {
    return "Field";
  }
  toString() {
    return `${this.name}: ${this.type}`;
  }
  clone(...t) {
    let [e, n, s, r] = t;
    return !t[0] || typeof t[0] != "object" ? [e = this.name, n = this.type, s = this.nullable, r = this.metadata] = t : { name: e = this.name, type: n = this.type, nullable: s = this.nullable, metadata: r = this.metadata } = t[0], N.new(e, n, s, r);
  }
}
N.prototype.type = null;
N.prototype.name = null;
N.prototype.nullable = null;
N.prototype.metadata = null;
function ni(i, t) {
  return new Map([...i || /* @__PURE__ */ new Map(), ...t || /* @__PURE__ */ new Map()]);
}
function dn(i, t = /* @__PURE__ */ new Map()) {
  for (let e = -1, n = i.length; ++e < n; ) {
    const r = i[e].type;
    if (f.isDictionary(r)) {
      if (!t.has(r.id))
        t.set(r.id, r.dictionary);
      else if (t.get(r.id) !== r.dictionary)
        throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
    }
    r.children && r.children.length > 0 && dn(r.children, t);
  }
  return t;
}
var Ic = Us, Sc = ge;
class Pn {
  /** @nocollapse */
  static decode(t) {
    t = new Sc(T(t));
    const e = et.getRootAsFooter(t), n = x.decode(e.schema(), /* @__PURE__ */ new Map(), e.version());
    return new Bc(n, e);
  }
  /** @nocollapse */
  static encode(t) {
    const e = new Ic(), n = x.encode(e, t.schema);
    et.startRecordBatchesVector(e, t.numRecordBatches);
    for (const o of [...t.recordBatches()].slice().reverse())
      ve.encode(e, o);
    const s = e.endVector();
    et.startDictionariesVector(e, t.numDictionaries);
    for (const o of [...t.dictionaryBatches()].slice().reverse())
      ve.encode(e, o);
    const r = e.endVector();
    return et.startFooter(e), et.addSchema(e, n), et.addVersion(e, P.V5), et.addRecordBatches(e, s), et.addDictionaries(e, r), et.finishFooterBuffer(e, et.endFooter(e)), e.asUint8Array();
  }
  get numRecordBatches() {
    return this._recordBatches.length;
  }
  get numDictionaries() {
    return this._dictionaryBatches.length;
  }
  constructor(t, e = P.V5, n, s) {
    this.schema = t, this.version = e, n && (this._recordBatches = n), s && (this._dictionaryBatches = s);
  }
  *recordBatches() {
    for (let t, e = -1, n = this.numRecordBatches; ++e < n; )
      (t = this.getRecordBatch(e)) && (yield t);
  }
  *dictionaryBatches() {
    for (let t, e = -1, n = this.numDictionaries; ++e < n; )
      (t = this.getDictionaryBatch(e)) && (yield t);
  }
  getRecordBatch(t) {
    return t >= 0 && t < this.numRecordBatches && this._recordBatches[t] || null;
  }
  getDictionaryBatch(t) {
    return t >= 0 && t < this.numDictionaries && this._dictionaryBatches[t] || null;
  }
}
class Bc extends Pn {
  get numRecordBatches() {
    return this._footer.recordBatchesLength();
  }
  get numDictionaries() {
    return this._footer.dictionariesLength();
  }
  constructor(t, e) {
    super(t, e.version()), this._footer = e;
  }
  getRecordBatch(t) {
    if (t >= 0 && t < this.numRecordBatches) {
      const e = this._footer.recordBatches(t);
      if (e)
        return ve.decode(e);
    }
    return null;
  }
  getDictionaryBatch(t) {
    if (t >= 0 && t < this.numDictionaries) {
      const e = this._footer.dictionaries(t);
      if (e)
        return ve.decode(e);
    }
    return null;
  }
}
class ve {
  /** @nocollapse */
  static decode(t) {
    return new ve(t.metaDataLength(), t.bodyLength(), t.offset());
  }
  /** @nocollapse */
  static encode(t, e) {
    const { metaDataLength: n } = e, s = BigInt(e.offset), r = BigInt(e.bodyLength);
    return un.createBlock(t, s, n, r);
  }
  constructor(t, e, n) {
    this.metaDataLength = t, this.offset = z(n), this.bodyLength = z(e);
  }
}
const j = Object.freeze({ done: !0, value: void 0 });
class ys {
  constructor(t) {
    this._json = t;
  }
  get schema() {
    return this._json.schema;
  }
  get batches() {
    return this._json.batches || [];
  }
  get dictionaries() {
    return this._json.dictionaries || [];
  }
}
class fo {
  tee() {
    return this._getDOMStream().tee();
  }
  pipe(t, e) {
    return this._getNodeStream().pipe(t, e);
  }
  pipeTo(t, e) {
    return this._getDOMStream().pipeTo(t, e);
  }
  pipeThrough(t, e) {
    return this._getDOMStream().pipeThrough(t, e);
  }
  _getDOMStream() {
    return this._DOMStream || (this._DOMStream = this.toDOMStream());
  }
  _getNodeStream() {
    return this._nodeStream || (this._nodeStream = this.toNodeStream());
  }
}
class Dc extends fo {
  constructor() {
    super(), this._values = [], this.resolvers = [], this._closedPromise = new Promise((t) => this._closedPromiseResolve = t);
  }
  get closed() {
    return this._closedPromise;
  }
  cancel(t) {
    return A(this, void 0, void 0, function* () {
      yield this.return(t);
    });
  }
  write(t) {
    this._ensureOpen() && (this.resolvers.length <= 0 ? this._values.push(t) : this.resolvers.shift().resolve({ done: !1, value: t }));
  }
  abort(t) {
    this._closedPromiseResolve && (this.resolvers.length <= 0 ? this._error = { error: t } : this.resolvers.shift().reject({ done: !0, value: t }));
  }
  close() {
    if (this._closedPromiseResolve) {
      const { resolvers: t } = this;
      for (; t.length > 0; )
        t.shift().resolve(j);
      this._closedPromiseResolve(), this._closedPromiseResolve = void 0;
    }
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  toDOMStream(t) {
    return rt.toDOMStream(this._closedPromiseResolve || this._error ? this : this._values, t);
  }
  toNodeStream(t) {
    return rt.toNodeStream(this._closedPromiseResolve || this._error ? this : this._values, t);
  }
  throw(t) {
    return A(this, void 0, void 0, function* () {
      return yield this.abort(t), j;
    });
  }
  return(t) {
    return A(this, void 0, void 0, function* () {
      return yield this.close(), j;
    });
  }
  read(t) {
    return A(this, void 0, void 0, function* () {
      return (yield this.next(t, "read")).value;
    });
  }
  peek(t) {
    return A(this, void 0, void 0, function* () {
      return (yield this.next(t, "peek")).value;
    });
  }
  next(...t) {
    return this._values.length > 0 ? Promise.resolve({ done: !1, value: this._values.shift() }) : this._error ? Promise.reject({ done: !0, value: this._error.error }) : this._closedPromiseResolve ? new Promise((e, n) => {
      this.resolvers.push({ resolve: e, reject: n });
    }) : Promise.resolve(j);
  }
  _ensureOpen() {
    if (this._closedPromiseResolve)
      return !0;
    throw new Error("AsyncQueue is closed");
  }
}
class Ac extends Dc {
  write(t) {
    if ((t = T(t)).byteLength > 0)
      return super.write(t);
  }
  toString(t = !1) {
    return t ? Xi(this.toUint8Array(!0)) : this.toUint8Array(!1).then(Xi);
  }
  toUint8Array(t = !1) {
    return t ? Bt(this._values)[0] : A(this, void 0, void 0, function* () {
      var e, n, s, r;
      const o = [];
      let a = 0;
      try {
        for (var c = !0, u = de(this), d; d = yield u.next(), e = d.done, !e; c = !0) {
          r = d.value, c = !1;
          const h = r;
          o.push(h), a += h.byteLength;
        }
      } catch (h) {
        n = { error: h };
      } finally {
        try {
          !c && !e && (s = u.return) && (yield s.call(u));
        } finally {
          if (n) throw n.error;
        }
      }
      return Bt(o, a)[0];
    });
  }
}
class Ti {
  constructor(t) {
    t && (this.source = new Oc(rt.fromIterable(t)));
  }
  [Symbol.iterator]() {
    return this;
  }
  next(t) {
    return this.source.next(t);
  }
  throw(t) {
    return this.source.throw(t);
  }
  return(t) {
    return this.source.return(t);
  }
  peek(t) {
    return this.source.peek(t);
  }
  read(t) {
    return this.source.read(t);
  }
}
class we {
  constructor(t) {
    t instanceof we ? this.source = t.source : t instanceof Ac ? this.source = new Ht(rt.fromAsyncIterable(t)) : Ms(t) ? this.source = new Ht(rt.fromNodeStream(t)) : pn(t) ? this.source = new Ht(rt.fromDOMStream(t)) : Fs(t) ? this.source = new Ht(rt.fromDOMStream(t.body)) : Ci(t) ? this.source = new Ht(rt.fromIterable(t)) : ze(t) ? this.source = new Ht(rt.fromAsyncIterable(t)) : fn(t) && (this.source = new Ht(rt.fromAsyncIterable(t)));
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next(t) {
    return this.source.next(t);
  }
  throw(t) {
    return this.source.throw(t);
  }
  return(t) {
    return this.source.return(t);
  }
  get closed() {
    return this.source.closed;
  }
  cancel(t) {
    return this.source.cancel(t);
  }
  peek(t) {
    return this.source.peek(t);
  }
  read(t) {
    return this.source.read(t);
  }
}
class Oc {
  constructor(t) {
    this.source = t;
  }
  cancel(t) {
    this.return(t);
  }
  peek(t) {
    return this.next(t, "peek").value;
  }
  read(t) {
    return this.next(t, "read").value;
  }
  next(t, e = "read") {
    return this.source.next({ cmd: e, size: t });
  }
  throw(t) {
    return Object.create(this.source.throw && this.source.throw(t) || j);
  }
  return(t) {
    return Object.create(this.source.return && this.source.return(t) || j);
  }
}
class Ht {
  constructor(t) {
    this.source = t, this._closedPromise = new Promise((e) => this._closedPromiseResolve = e);
  }
  cancel(t) {
    return A(this, void 0, void 0, function* () {
      yield this.return(t);
    });
  }
  get closed() {
    return this._closedPromise;
  }
  read(t) {
    return A(this, void 0, void 0, function* () {
      return (yield this.next(t, "read")).value;
    });
  }
  peek(t) {
    return A(this, void 0, void 0, function* () {
      return (yield this.next(t, "peek")).value;
    });
  }
  next(t) {
    return A(this, arguments, void 0, function* (e, n = "read") {
      return yield this.source.next({ cmd: n, size: e });
    });
  }
  throw(t) {
    return A(this, void 0, void 0, function* () {
      const e = this.source.throw && (yield this.source.throw(t)) || j;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(e);
    });
  }
  return(t) {
    return A(this, void 0, void 0, function* () {
      const e = this.source.return && (yield this.source.return(t)) || j;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(e);
    });
  }
}
class gs extends Ti {
  constructor(t, e) {
    super(), this.position = 0, this.buffer = T(t), this.size = e === void 0 ? this.buffer.byteLength : e;
  }
  readInt32(t) {
    const { buffer: e, byteOffset: n } = this.readAt(t, 4);
    return new DataView(e, n).getInt32(0, !0);
  }
  seek(t) {
    return this.position = Math.min(t, this.size), t < this.size;
  }
  read(t) {
    const { buffer: e, size: n, position: s } = this;
    return e && s < n ? (typeof t != "number" && (t = Number.POSITIVE_INFINITY), this.position = Math.min(n, s + Math.min(n - s, t)), e.subarray(s, this.position)) : null;
  }
  readAt(t, e) {
    const n = this.buffer, s = Math.min(this.size, t + e);
    return n ? n.subarray(t, s) : new Uint8Array(e);
  }
  close() {
    this.buffer && (this.buffer = null);
  }
  throw(t) {
    return this.close(), { done: !0, value: t };
  }
  return(t) {
    return this.close(), { done: !0, value: t };
  }
}
class Mi extends we {
  constructor(t, e) {
    super(), this.position = 0, this._handle = t, typeof e == "number" ? this.size = e : this._pending = A(this, void 0, void 0, function* () {
      this.size = (yield t.stat()).size, delete this._pending;
    });
  }
  readInt32(t) {
    return A(this, void 0, void 0, function* () {
      const { buffer: e, byteOffset: n } = yield this.readAt(t, 4);
      return new DataView(e, n).getInt32(0, !0);
    });
  }
  seek(t) {
    return A(this, void 0, void 0, function* () {
      return this._pending && (yield this._pending), this.position = Math.min(t, this.size), t < this.size;
    });
  }
  read(t) {
    return A(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: e, size: n, position: s } = this;
      if (e && s < n) {
        typeof t != "number" && (t = Number.POSITIVE_INFINITY);
        let r = s, o = 0, a = 0;
        const c = Math.min(n, r + Math.min(n - r, t)), u = new Uint8Array(Math.max(0, (this.position = c) - r));
        for (; (r += a) < c && (o += a) < u.byteLength; )
          ({ bytesRead: a } = yield e.read(u, o, u.byteLength - o, r));
        return u;
      }
      return null;
    });
  }
  readAt(t, e) {
    return A(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: n, size: s } = this;
      if (n && t + e < s) {
        const r = Math.min(s, t + e), o = new Uint8Array(r - t);
        return (yield n.read(o, 0, e, t)).buffer;
      }
      return new Uint8Array(e);
    });
  }
  close() {
    return A(this, void 0, void 0, function* () {
      const t = this._handle;
      this._handle = null, t && (yield t.close());
    });
  }
  throw(t) {
    return A(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: t };
    });
  }
  return(t) {
    return A(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: t };
    });
  }
}
const Fc = 65536;
function ue(i) {
  return i < 0 && (i = 4294967295 + i + 1), `0x${i.toString(16)}`;
}
const Ie = 8, $n = [
  1,
  10,
  100,
  1e3,
  1e4,
  1e5,
  1e6,
  1e7,
  1e8
];
class po {
  constructor(t) {
    this.buffer = t;
  }
  high() {
    return this.buffer[1];
  }
  low() {
    return this.buffer[0];
  }
  _times(t) {
    const e = new Uint32Array([
      this.buffer[1] >>> 16,
      this.buffer[1] & 65535,
      this.buffer[0] >>> 16,
      this.buffer[0] & 65535
    ]), n = new Uint32Array([
      t.buffer[1] >>> 16,
      t.buffer[1] & 65535,
      t.buffer[0] >>> 16,
      t.buffer[0] & 65535
    ]);
    let s = e[3] * n[3];
    this.buffer[0] = s & 65535;
    let r = s >>> 16;
    return s = e[2] * n[3], r += s, s = e[3] * n[2] >>> 0, r += s, this.buffer[0] += r << 16, this.buffer[1] = r >>> 0 < s ? Fc : 0, this.buffer[1] += r >>> 16, this.buffer[1] += e[1] * n[3] + e[2] * n[2] + e[3] * n[1], this.buffer[1] += e[0] * n[3] + e[1] * n[2] + e[2] * n[1] + e[3] * n[0] << 16, this;
  }
  _plus(t) {
    const e = this.buffer[0] + t.buffer[0] >>> 0;
    this.buffer[1] += t.buffer[1], e < this.buffer[0] >>> 0 && ++this.buffer[1], this.buffer[0] = e;
  }
  lessThan(t) {
    return this.buffer[1] < t.buffer[1] || this.buffer[1] === t.buffer[1] && this.buffer[0] < t.buffer[0];
  }
  equals(t) {
    return this.buffer[1] === t.buffer[1] && this.buffer[0] == t.buffer[0];
  }
  greaterThan(t) {
    return t.lessThan(this);
  }
  hex() {
    return `${ue(this.buffer[1])} ${ue(this.buffer[0])}`;
  }
}
class R extends po {
  times(t) {
    return this._times(t), this;
  }
  plus(t) {
    return this._plus(t), this;
  }
  /** @nocollapse */
  static from(t, e = new Uint32Array(2)) {
    return R.fromString(typeof t == "string" ? t : t.toString(), e);
  }
  /** @nocollapse */
  static fromNumber(t, e = new Uint32Array(2)) {
    return R.fromString(t.toString(), e);
  }
  /** @nocollapse */
  static fromString(t, e = new Uint32Array(2)) {
    const n = t.length, s = new R(e);
    for (let r = 0; r < n; ) {
      const o = Ie < n - r ? Ie : n - r, a = new R(new Uint32Array([Number.parseInt(t.slice(r, r + o), 10), 0])), c = new R(new Uint32Array([$n[o], 0]));
      s.times(c), s.plus(a), r += o;
    }
    return s;
  }
  /** @nocollapse */
  static convertArray(t) {
    const e = new Uint32Array(t.length * 2);
    for (let n = -1, s = t.length; ++n < s; )
      R.from(t[n], new Uint32Array(e.buffer, e.byteOffset + 2 * n * 4, 2));
    return e;
  }
  /** @nocollapse */
  static multiply(t, e) {
    return new R(new Uint32Array(t.buffer)).times(e);
  }
  /** @nocollapse */
  static add(t, e) {
    return new R(new Uint32Array(t.buffer)).plus(e);
  }
}
class G extends po {
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[0] == 0 && ++this.buffer[1], this;
  }
  times(t) {
    return this._times(t), this;
  }
  plus(t) {
    return this._plus(t), this;
  }
  lessThan(t) {
    const e = this.buffer[1] << 0, n = t.buffer[1] << 0;
    return e < n || e === n && this.buffer[0] < t.buffer[0];
  }
  /** @nocollapse */
  static from(t, e = new Uint32Array(2)) {
    return G.fromString(typeof t == "string" ? t : t.toString(), e);
  }
  /** @nocollapse */
  static fromNumber(t, e = new Uint32Array(2)) {
    return G.fromString(t.toString(), e);
  }
  /** @nocollapse */
  static fromString(t, e = new Uint32Array(2)) {
    const n = t.startsWith("-"), s = t.length, r = new G(e);
    for (let o = n ? 1 : 0; o < s; ) {
      const a = Ie < s - o ? Ie : s - o, c = new G(new Uint32Array([Number.parseInt(t.slice(o, o + a), 10), 0])), u = new G(new Uint32Array([$n[a], 0]));
      r.times(u), r.plus(c), o += a;
    }
    return n ? r.negate() : r;
  }
  /** @nocollapse */
  static convertArray(t) {
    const e = new Uint32Array(t.length * 2);
    for (let n = -1, s = t.length; ++n < s; )
      G.from(t[n], new Uint32Array(e.buffer, e.byteOffset + 2 * n * 4, 2));
    return e;
  }
  /** @nocollapse */
  static multiply(t, e) {
    return new G(new Uint32Array(t.buffer)).times(e);
  }
  /** @nocollapse */
  static add(t, e) {
    return new G(new Uint32Array(t.buffer)).plus(e);
  }
}
class bt {
  constructor(t) {
    this.buffer = t;
  }
  high() {
    return new G(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2));
  }
  low() {
    return new G(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset, 2));
  }
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[2] = ~this.buffer[2], this.buffer[3] = ~this.buffer[3], this.buffer[0] == 0 && ++this.buffer[1], this.buffer[1] == 0 && ++this.buffer[2], this.buffer[2] == 0 && ++this.buffer[3], this;
  }
  times(t) {
    const e = new R(new Uint32Array([this.buffer[3], 0])), n = new R(new Uint32Array([this.buffer[2], 0])), s = new R(new Uint32Array([this.buffer[1], 0])), r = new R(new Uint32Array([this.buffer[0], 0])), o = new R(new Uint32Array([t.buffer[3], 0])), a = new R(new Uint32Array([t.buffer[2], 0])), c = new R(new Uint32Array([t.buffer[1], 0])), u = new R(new Uint32Array([t.buffer[0], 0]));
    let d = R.multiply(r, u);
    this.buffer[0] = d.low();
    const h = new R(new Uint32Array([d.high(), 0]));
    return d = R.multiply(s, u), h.plus(d), d = R.multiply(r, c), h.plus(d), this.buffer[1] = h.low(), this.buffer[3] = h.lessThan(d) ? 1 : 0, this.buffer[2] = h.high(), new R(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2)).plus(R.multiply(n, u)).plus(R.multiply(s, c)).plus(R.multiply(r, a)), this.buffer[3] += R.multiply(e, u).plus(R.multiply(n, c)).plus(R.multiply(s, a)).plus(R.multiply(r, o)).low(), this;
  }
  plus(t) {
    const e = new Uint32Array(4);
    return e[3] = this.buffer[3] + t.buffer[3] >>> 0, e[2] = this.buffer[2] + t.buffer[2] >>> 0, e[1] = this.buffer[1] + t.buffer[1] >>> 0, e[0] = this.buffer[0] + t.buffer[0] >>> 0, e[0] < this.buffer[0] >>> 0 && ++e[1], e[1] < this.buffer[1] >>> 0 && ++e[2], e[2] < this.buffer[2] >>> 0 && ++e[3], this.buffer[3] = e[3], this.buffer[2] = e[2], this.buffer[1] = e[1], this.buffer[0] = e[0], this;
  }
  hex() {
    return `${ue(this.buffer[3])} ${ue(this.buffer[2])} ${ue(this.buffer[1])} ${ue(this.buffer[0])}`;
  }
  /** @nocollapse */
  static multiply(t, e) {
    return new bt(new Uint32Array(t.buffer)).times(e);
  }
  /** @nocollapse */
  static add(t, e) {
    return new bt(new Uint32Array(t.buffer)).plus(e);
  }
  /** @nocollapse */
  static from(t, e = new Uint32Array(4)) {
    return bt.fromString(typeof t == "string" ? t : t.toString(), e);
  }
  /** @nocollapse */
  static fromNumber(t, e = new Uint32Array(4)) {
    return bt.fromString(t.toString(), e);
  }
  /** @nocollapse */
  static fromString(t, e = new Uint32Array(4)) {
    const n = t.startsWith("-"), s = t.length, r = new bt(e);
    for (let o = n ? 1 : 0; o < s; ) {
      const a = Ie < s - o ? Ie : s - o, c = new bt(new Uint32Array([Number.parseInt(t.slice(o, o + a), 10), 0, 0, 0])), u = new bt(new Uint32Array([$n[a], 0, 0, 0]));
      r.times(u), r.plus(c), o += a;
    }
    return n ? r.negate() : r;
  }
  /** @nocollapse */
  static convertArray(t) {
    const e = new Uint32Array(t.length * 4);
    for (let n = -1, s = t.length; ++n < s; )
      bt.from(t[n], new Uint32Array(e.buffer, e.byteOffset + 16 * n, 4));
    return e;
  }
}
class yo extends F {
  constructor(t, e, n, s, r = P.V5) {
    super(), this.nodesIndex = -1, this.buffersIndex = -1, this.bytes = t, this.nodes = e, this.buffers = n, this.dictionaries = s, this.metadataVersion = r;
  }
  visit(t) {
    return super.visit(t instanceof N ? t.type : t);
  }
  visitNull(t, { length: e } = this.nextFieldNode()) {
    return _({ type: t, length: e });
  }
  visitBool(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitInt(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitFloat(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitUtf8(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitLargeUtf8(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitBinary(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitLargeBinary(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitFixedSizeBinary(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitDate(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitTimestamp(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitTime(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitDecimal(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitList(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), child: this.visit(t.children[0]) });
  }
  visitStruct(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), children: this.visitMany(t.children) });
  }
  visitUnion(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return this.metadataVersion < P.V5 && this.readNullBitmap(t, n), t.mode === q.Sparse ? this.visitSparseUnion(t, { length: e, nullCount: n }) : this.visitDenseUnion(t, { length: e, nullCount: n });
  }
  visitDenseUnion(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, typeIds: this.readTypeIds(t), valueOffsets: this.readOffsets(t), children: this.visitMany(t.children) });
  }
  visitSparseUnion(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, typeIds: this.readTypeIds(t), children: this.visitMany(t.children) });
  }
  visitDictionary(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t.indices), dictionary: this.readDictionary(t) });
  }
  visitInterval(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitDuration(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), data: this.readData(t) });
  }
  visitFixedSizeList(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), child: this.visit(t.children[0]) });
  }
  visitMap(t, { length: e, nullCount: n } = this.nextFieldNode()) {
    return _({ type: t, length: e, nullCount: n, nullBitmap: this.readNullBitmap(t, n), valueOffsets: this.readOffsets(t), child: this.visit(t.children[0]) });
  }
  nextFieldNode() {
    return this.nodes[++this.nodesIndex];
  }
  nextBufferRange() {
    return this.buffers[++this.buffersIndex];
  }
  readNullBitmap(t, e, n = this.nextBufferRange()) {
    return e > 0 && this.readData(t, n) || new Uint8Array(0);
  }
  readOffsets(t, e) {
    return this.readData(t, e);
  }
  readTypeIds(t, e) {
    return this.readData(t, e);
  }
  readData(t, { length: e, offset: n } = this.nextBufferRange()) {
    return this.bytes.subarray(n, n + e);
  }
  readDictionary(t) {
    return this.dictionaries.get(t.id);
  }
}
class Tc extends yo {
  constructor(t, e, n, s, r) {
    super(new Uint8Array(0), e, n, s, r), this.sources = t;
  }
  readNullBitmap(t, e, { offset: n } = this.nextBufferRange()) {
    return e <= 0 ? new Uint8Array(0) : cn(this.sources[n]);
  }
  readOffsets(t, { offset: e } = this.nextBufferRange()) {
    return C(Uint8Array, C(t.OffsetArrayType, this.sources[e]));
  }
  readTypeIds(t, { offset: e } = this.nextBufferRange()) {
    return C(Uint8Array, C(t.ArrayType, this.sources[e]));
  }
  readData(t, { offset: e } = this.nextBufferRange()) {
    const { sources: n } = this;
    return f.isTimestamp(t) || (f.isInt(t) || f.isTime(t)) && t.bitWidth === 64 || f.isDuration(t) || f.isDate(t) && t.unit === ct.MILLISECOND ? C(Uint8Array, G.convertArray(n[e])) : f.isDecimal(t) ? C(Uint8Array, bt.convertArray(n[e])) : f.isBinary(t) || f.isLargeBinary(t) || f.isFixedSizeBinary(t) ? Mc(n[e]) : f.isBool(t) ? cn(n[e]) : f.isUtf8(t) || f.isLargeUtf8(t) ? Ke(n[e].join("")) : C(Uint8Array, C(t.ArrayType, n[e].map((s) => +s)));
  }
}
function Mc(i) {
  const t = i.join(""), e = new Uint8Array(t.length / 2);
  for (let n = 0; n < t.length; n += 2)
    e[n >> 1] = Number.parseInt(t.slice(n, n + 2), 16);
  return e;
}
class go extends Be {
  constructor(t) {
    super(t), this._values = new Ge(Uint8Array);
  }
  get byteLength() {
    let t = this._pendingLength + this.length * 4;
    return this._offsets && (t += this._offsets.byteLength), this._values && (t += this._values.byteLength), this._nulls && (t += this._nulls.byteLength), t;
  }
  setValue(t, e) {
    return super.setValue(t, T(e));
  }
  _flushPending(t, e) {
    const n = this._offsets, s = this._values.reserve(e).buffer;
    let r = 0;
    for (const [o, a] of t)
      if (a === void 0)
        n.set(o, 0);
      else {
        const c = a.length;
        s.set(a, r), n.set(o, c), r += c;
      }
  }
}
class mo extends Be {
  constructor(t) {
    super(t), this._values = new Ge(Uint8Array);
  }
  get byteLength() {
    let t = this._pendingLength + this.length * 4;
    return this._offsets && (t += this._offsets.byteLength), this._values && (t += this._values.byteLength), this._nulls && (t += this._nulls.byteLength), t;
  }
  setValue(t, e) {
    return super.setValue(t, T(e));
  }
  _flushPending(t, e) {
    const n = this._offsets, s = this._values.reserve(e).buffer;
    let r = 0;
    for (const [o, a] of t)
      if (a === void 0)
        n.set(o, BigInt(0));
      else {
        const c = a.length;
        s.set(a, r), n.set(o, BigInt(c)), r += c;
      }
  }
}
class Lc extends tt {
  constructor(t) {
    super(t), this._values = new uo();
  }
  setValue(t, e) {
    this._values.set(t, +e);
  }
}
class ji extends Ct {
}
ji.prototype._setValue = Ir;
class bo extends ji {
}
bo.prototype._setValue = vn;
class _o extends ji {
}
_o.prototype._setValue = wn;
class vo extends Ct {
}
vo.prototype._setValue = Dr;
class Nc extends tt {
  constructor({ type: t, nullValues: e, dictionaryHashFunction: n }) {
    super({ type: new Yt(t.dictionary, t.indices, t.id, t.isOrdered) }), this._nulls = null, this._dictionaryOffset = 0, this._keysToIndices = /* @__PURE__ */ Object.create(null), this.indices = Li({ type: this.type.indices, nullValues: e }), this.dictionary = Li({ type: this.type.dictionary, nullValues: null }), typeof n == "function" && (this.valueToKey = n);
  }
  get values() {
    return this.indices.values;
  }
  get nullCount() {
    return this.indices.nullCount;
  }
  get nullBitmap() {
    return this.indices.nullBitmap;
  }
  get byteLength() {
    return this.indices.byteLength + this.dictionary.byteLength;
  }
  get reservedLength() {
    return this.indices.reservedLength + this.dictionary.reservedLength;
  }
  get reservedByteLength() {
    return this.indices.reservedByteLength + this.dictionary.reservedByteLength;
  }
  isValid(t) {
    return this.indices.isValid(t);
  }
  setValid(t, e) {
    const n = this.indices;
    return e = n.setValid(t, e), this.length = n.length, e;
  }
  setValue(t, e) {
    const n = this._keysToIndices, s = this.valueToKey(e);
    let r = n[s];
    return r === void 0 && (n[s] = r = this._dictionaryOffset + this.dictionary.append(e).length - 1), this.indices.setValue(t, r);
  }
  flush() {
    const t = this.type, e = this._dictionary, n = this.dictionary.toVector(), s = this.indices.flush().clone(t);
    return s.dictionary = e ? e.concat(n) : n, this.finished || (this._dictionaryOffset += n.length), this._dictionary = s.dictionary, this.clear(), s;
  }
  finish() {
    return this.indices.finish(), this.dictionary.finish(), this._dictionaryOffset = 0, this._keysToIndices = /* @__PURE__ */ Object.create(null), super.finish();
  }
  clear() {
    return this.indices.clear(), this.dictionary.clear(), super.clear();
  }
  valueToKey(t) {
    return typeof t == "string" ? t : `${t}`;
  }
}
class wo extends Ct {
}
wo.prototype._setValue = _r;
class Uc extends tt {
  setValue(t, e) {
    const [n] = this.children, s = t * this.stride;
    for (let r = -1, o = e.length; ++r < o; )
      n.set(s + r, e[r]);
  }
  addChild(t, e = "0") {
    if (this.numChildren > 0)
      throw new Error("FixedSizeListBuilder can only have one child.");
    const n = this.children.push(t);
    return this.type = new Je(this.type.listSize, new N(e, t.type, !0)), n;
  }
}
class ki extends Ct {
  setValue(t, e) {
    this._values.set(t, e);
  }
}
class xc extends ki {
  setValue(t, e) {
    super.setValue(t, gr(e));
  }
}
class Vc extends ki {
}
class Rc extends ki {
}
class Pi extends Ct {
}
Pi.prototype._setValue = Fr;
class Io extends Pi {
}
Io.prototype._setValue = Mn;
class So extends Pi {
}
So.prototype._setValue = Ln;
class De extends Ct {
}
De.prototype._setValue = Tr;
class Bo extends De {
}
Bo.prototype._setValue = Nn;
class Do extends De {
}
Do.prototype._setValue = Un;
class Ao extends De {
}
Ao.prototype._setValue = xn;
class Oo extends De {
}
Oo.prototype._setValue = Vn;
class Et extends Ct {
  setValue(t, e) {
    this._values.set(t, e);
  }
}
class Cc extends Et {
}
class Ec extends Et {
}
class zc extends Et {
}
class jc extends Et {
}
class kc extends Et {
}
class Pc extends Et {
}
class $c extends Et {
}
class Wc extends Et {
}
class Yc extends Be {
  constructor(t) {
    super(t), this._offsets = new ho(t.type);
  }
  addChild(t, e = "0") {
    if (this.numChildren > 0)
      throw new Error("ListBuilder can only have one child.");
    return this.children[this.numChildren] = t, this.type = new _e(new N(e, t.type, !0)), this.numChildren - 1;
  }
  _flushPending(t) {
    const e = this._offsets, [n] = this.children;
    for (const [s, r] of t)
      if (typeof r > "u")
        e.set(s, 0);
      else {
        const o = r, a = o.length, c = e.set(s, a).buffer[s];
        for (let u = -1; ++u < a; )
          n.set(c + u, o[u]);
      }
  }
}
class Jc extends Be {
  set(t, e) {
    return super.set(t, e);
  }
  setValue(t, e) {
    const n = e instanceof Map ? e : new Map(Object.entries(e)), s = this._pending || (this._pending = /* @__PURE__ */ new Map()), r = s.get(t);
    r && (this._pendingLength -= r.size), this._pendingLength += n.size, s.set(t, n);
  }
  addChild(t, e = `${this.numChildren}`) {
    if (this.numChildren > 0)
      throw new Error("ListBuilder can only have one child.");
    return this.children[this.numChildren] = t, this.type = new He(new N(e, t.type, !0), this.type.keysSorted), this.numChildren - 1;
  }
  _flushPending(t) {
    const e = this._offsets, [n] = this.children;
    for (const [s, r] of t)
      if (r === void 0)
        e.set(s, 0);
      else {
        let { [s]: o, [s + 1]: a } = e.set(s, r.size).buffer;
        for (const c of r.entries())
          if (n.set(o, c), ++o >= a)
            break;
      }
  }
}
class Hc extends tt {
  // @ts-ignore
  setValue(t, e) {
  }
  setValid(t, e) {
    return this.length = Math.max(t + 1, this.length), e;
  }
}
class Kc extends tt {
  setValue(t, e) {
    const { children: n, type: s } = this;
    switch (Array.isArray(e) || e.constructor) {
      case !0:
        return s.children.forEach((r, o) => n[o].set(t, e[o]));
      case Map:
        return s.children.forEach((r, o) => n[o].set(t, e.get(r.name)));
      default:
        return s.children.forEach((r, o) => n[o].set(t, e[r.name]));
    }
  }
  /** @inheritdoc */
  setValid(t, e) {
    return super.setValid(t, e) || this.children.forEach((n) => n.setValid(t, e)), e;
  }
  addChild(t, e = `${this.numChildren}`) {
    const n = this.children.push(t);
    return this.type = new J([...this.type.children, new N(e, t.type, !0)]), n;
  }
}
class Ae extends Ct {
}
Ae.prototype._setValue = Sr;
class Fo extends Ae {
}
Fo.prototype._setValue = In;
class To extends Ae {
}
To.prototype._setValue = Sn;
class Mo extends Ae {
}
Mo.prototype._setValue = Bn;
class Lo extends Ae {
}
Lo.prototype._setValue = Dn;
class Oe extends Ct {
}
Oe.prototype._setValue = Br;
class No extends Oe {
}
No.prototype._setValue = An;
class Uo extends Oe {
}
Uo.prototype._setValue = On;
class xo extends Oe {
}
xo.prototype._setValue = Fn;
class Vo extends Oe {
}
Vo.prototype._setValue = Tn;
class Wn extends tt {
  constructor(t) {
    super(t), this._typeIds = new Ze(Int8Array, 0, 1), typeof t.valueToChildTypeId == "function" && (this._valueToChildTypeId = t.valueToChildTypeId);
  }
  get typeIdToChildIndex() {
    return this.type.typeIdToChildIndex;
  }
  append(t, e) {
    return this.set(this.length, t, e);
  }
  set(t, e, n) {
    return n === void 0 && (n = this._valueToChildTypeId(this, e, t)), this.setValue(t, e, n), this;
  }
  setValue(t, e, n) {
    this._typeIds.set(t, n);
    const s = this.type.typeIdToChildIndex[n], r = this.children[s];
    r?.set(t, e);
  }
  addChild(t, e = `${this.children.length}`) {
    const n = this.children.push(t), { type: { children: s, mode: r, typeIds: o } } = this, a = [...s, new N(e, t.type)];
    return this.type = new Ye(r, [...o, n], a), n;
  }
  /** @ignore */
  // @ts-ignore
  _valueToChildTypeId(t, e, n) {
    throw new Error("Cannot map UnionBuilder value to child typeId. Pass the `childTypeId` as the second argument to unionBuilder.append(), or supply a `valueToChildTypeId` function as part of the UnionBuilder constructor options.");
  }
}
class Gc extends Wn {
}
class Zc extends Wn {
  constructor(t) {
    super(t), this._offsets = new Ze(Int32Array);
  }
  /** @ignore */
  setValue(t, e, n) {
    const s = this._typeIds.set(t, n).buffer[t], r = this.getChildAt(this.type.typeIdToChildIndex[s]), o = this._offsets.set(t, r.length).buffer[t];
    r?.set(o, e);
  }
}
class Ro extends Be {
  constructor(t) {
    super(t), this._values = new Ge(Uint8Array);
  }
  get byteLength() {
    let t = this._pendingLength + this.length * 4;
    return this._offsets && (t += this._offsets.byteLength), this._values && (t += this._values.byteLength), this._nulls && (t += this._nulls.byteLength), t;
  }
  setValue(t, e) {
    return super.setValue(t, Ke(e));
  }
  // @ts-ignore
  _flushPending(t, e) {
  }
}
Ro.prototype._flushPending = go.prototype._flushPending;
class Co extends Be {
  constructor(t) {
    super(t), this._values = new Ge(Uint8Array);
  }
  get byteLength() {
    let t = this._pendingLength + this.length * 4;
    return this._offsets && (t += this._offsets.byteLength), this._values && (t += this._values.byteLength), this._nulls && (t += this._nulls.byteLength), t;
  }
  setValue(t, e) {
    return super.setValue(t, Ke(e));
  }
  // @ts-ignore
  _flushPending(t, e) {
  }
}
Co.prototype._flushPending = mo.prototype._flushPending;
class qc extends F {
  visitNull() {
    return Hc;
  }
  visitBool() {
    return Lc;
  }
  visitInt() {
    return Et;
  }
  visitInt8() {
    return Cc;
  }
  visitInt16() {
    return Ec;
  }
  visitInt32() {
    return zc;
  }
  visitInt64() {
    return jc;
  }
  visitUint8() {
    return kc;
  }
  visitUint16() {
    return Pc;
  }
  visitUint32() {
    return $c;
  }
  visitUint64() {
    return Wc;
  }
  visitFloat() {
    return ki;
  }
  visitFloat16() {
    return xc;
  }
  visitFloat32() {
    return Vc;
  }
  visitFloat64() {
    return Rc;
  }
  visitUtf8() {
    return Ro;
  }
  visitLargeUtf8() {
    return Co;
  }
  visitBinary() {
    return go;
  }
  visitLargeBinary() {
    return mo;
  }
  visitFixedSizeBinary() {
    return wo;
  }
  visitDate() {
    return ji;
  }
  visitDateDay() {
    return bo;
  }
  visitDateMillisecond() {
    return _o;
  }
  visitTimestamp() {
    return Ae;
  }
  visitTimestampSecond() {
    return Fo;
  }
  visitTimestampMillisecond() {
    return To;
  }
  visitTimestampMicrosecond() {
    return Mo;
  }
  visitTimestampNanosecond() {
    return Lo;
  }
  visitTime() {
    return Oe;
  }
  visitTimeSecond() {
    return No;
  }
  visitTimeMillisecond() {
    return Uo;
  }
  visitTimeMicrosecond() {
    return xo;
  }
  visitTimeNanosecond() {
    return Vo;
  }
  visitDecimal() {
    return vo;
  }
  visitList() {
    return Yc;
  }
  visitStruct() {
    return Kc;
  }
  visitUnion() {
    return Wn;
  }
  visitDenseUnion() {
    return Zc;
  }
  visitSparseUnion() {
    return Gc;
  }
  visitDictionary() {
    return Nc;
  }
  visitInterval() {
    return Pi;
  }
  visitIntervalDayTime() {
    return Io;
  }
  visitIntervalYearMonth() {
    return So;
  }
  visitDuration() {
    return De;
  }
  visitDurationSecond() {
    return Bo;
  }
  visitDurationMillisecond() {
    return Do;
  }
  visitDurationMicrosecond() {
    return Ao;
  }
  visitDurationNanosecond() {
    return Oo;
  }
  visitFixedSizeList() {
    return Uc;
  }
  visitMap() {
    return Jc;
  }
}
const Qc = new qc();
class b extends F {
  compareSchemas(t, e) {
    return t === e || e instanceof t.constructor && this.compareManyFields(t.fields, e.fields);
  }
  compareManyFields(t, e) {
    return t === e || Array.isArray(t) && Array.isArray(e) && t.length === e.length && t.every((n, s) => this.compareFields(n, e[s]));
  }
  compareFields(t, e) {
    return t === e || e instanceof t.constructor && t.name === e.name && t.nullable === e.nullable && this.visit(t.type, e.type);
  }
}
function K(i, t) {
  return t instanceof i.constructor;
}
function Qt(i, t) {
  return i === t || K(i, t);
}
function zt(i, t) {
  return i === t || K(i, t) && i.bitWidth === t.bitWidth && i.isSigned === t.isSigned;
}
function $i(i, t) {
  return i === t || K(i, t) && i.precision === t.precision;
}
function Xc(i, t) {
  return i === t || K(i, t) && i.byteWidth === t.byteWidth;
}
function Yn(i, t) {
  return i === t || K(i, t) && i.unit === t.unit;
}
function qe(i, t) {
  return i === t || K(i, t) && i.unit === t.unit && i.timezone === t.timezone;
}
function Qe(i, t) {
  return i === t || K(i, t) && i.unit === t.unit && i.bitWidth === t.bitWidth;
}
function tl(i, t) {
  return i === t || K(i, t) && i.children.length === t.children.length && xt.compareManyFields(i.children, t.children);
}
function el(i, t) {
  return i === t || K(i, t) && i.children.length === t.children.length && xt.compareManyFields(i.children, t.children);
}
function Jn(i, t) {
  return i === t || K(i, t) && i.mode === t.mode && i.typeIds.every((e, n) => e === t.typeIds[n]) && xt.compareManyFields(i.children, t.children);
}
function il(i, t) {
  return i === t || K(i, t) && i.id === t.id && i.isOrdered === t.isOrdered && xt.visit(i.indices, t.indices) && xt.visit(i.dictionary, t.dictionary);
}
function Hn(i, t) {
  return i === t || K(i, t) && i.unit === t.unit;
}
function Xe(i, t) {
  return i === t || K(i, t) && i.unit === t.unit;
}
function nl(i, t) {
  return i === t || K(i, t) && i.listSize === t.listSize && i.children.length === t.children.length && xt.compareManyFields(i.children, t.children);
}
function sl(i, t) {
  return i === t || K(i, t) && i.keysSorted === t.keysSorted && i.children.length === t.children.length && xt.compareManyFields(i.children, t.children);
}
b.prototype.visitNull = Qt;
b.prototype.visitBool = Qt;
b.prototype.visitInt = zt;
b.prototype.visitInt8 = zt;
b.prototype.visitInt16 = zt;
b.prototype.visitInt32 = zt;
b.prototype.visitInt64 = zt;
b.prototype.visitUint8 = zt;
b.prototype.visitUint16 = zt;
b.prototype.visitUint32 = zt;
b.prototype.visitUint64 = zt;
b.prototype.visitFloat = $i;
b.prototype.visitFloat16 = $i;
b.prototype.visitFloat32 = $i;
b.prototype.visitFloat64 = $i;
b.prototype.visitUtf8 = Qt;
b.prototype.visitLargeUtf8 = Qt;
b.prototype.visitBinary = Qt;
b.prototype.visitLargeBinary = Qt;
b.prototype.visitFixedSizeBinary = Xc;
b.prototype.visitDate = Yn;
b.prototype.visitDateDay = Yn;
b.prototype.visitDateMillisecond = Yn;
b.prototype.visitTimestamp = qe;
b.prototype.visitTimestampSecond = qe;
b.prototype.visitTimestampMillisecond = qe;
b.prototype.visitTimestampMicrosecond = qe;
b.prototype.visitTimestampNanosecond = qe;
b.prototype.visitTime = Qe;
b.prototype.visitTimeSecond = Qe;
b.prototype.visitTimeMillisecond = Qe;
b.prototype.visitTimeMicrosecond = Qe;
b.prototype.visitTimeNanosecond = Qe;
b.prototype.visitDecimal = Qt;
b.prototype.visitList = tl;
b.prototype.visitStruct = el;
b.prototype.visitUnion = Jn;
b.prototype.visitDenseUnion = Jn;
b.prototype.visitSparseUnion = Jn;
b.prototype.visitDictionary = il;
b.prototype.visitInterval = Hn;
b.prototype.visitIntervalDayTime = Hn;
b.prototype.visitIntervalYearMonth = Hn;
b.prototype.visitDuration = Xe;
b.prototype.visitDurationSecond = Xe;
b.prototype.visitDurationMillisecond = Xe;
b.prototype.visitDurationMicrosecond = Xe;
b.prototype.visitDurationNanosecond = Xe;
b.prototype.visitFixedSizeList = nl;
b.prototype.visitMap = sl;
const xt = new b();
function rl(i, t) {
  return xt.compareSchemas(i, t);
}
function ol(i, t) {
  return xt.visit(i, t);
}
function Li(i) {
  const t = i.type, e = new (Qc.getVisitFn(t)())(i);
  if (t.children && t.children.length > 0) {
    const n = i.children || [], s = { nullValues: i.nullValues }, r = Array.isArray(n) ? ((o, a) => n[a] || s) : (({ name: o }) => n[o] || s);
    for (const [o, a] of t.children.entries()) {
      const { type: c } = a, u = r(a, o);
      e.children.push(Li(Object.assign(Object.assign({}, u), { type: c })));
    }
  }
  return e;
}
function al(i, t) {
  if (i instanceof L || i instanceof D || i.type instanceof f || ArrayBuffer.isView(i))
    return lo(i);
  const e = { type: di(i), nullValues: [null] }, n = [...cl(e)(i)], s = n.length === 1 ? n[0] : n.reduce((r, o) => r.concat(o));
  return f.isDictionary(s.type) ? s.memoize() : s;
}
function di(i) {
  if (i.length === 0)
    return new Ut();
  let t = 0, e = 0, n = 0, s = 0, r = 0, o = 0, a = 0, c = 0;
  for (const u of i) {
    if (u == null) {
      ++t;
      continue;
    }
    switch (typeof u) {
      case "bigint":
        ++o;
        continue;
      case "boolean":
        ++a;
        continue;
      case "number":
        ++s;
        continue;
      case "string":
        ++r;
        continue;
      case "object":
        Array.isArray(u) ? ++e : Object.prototype.toString.call(u) === "[object Date]" ? ++c : ++n;
        continue;
    }
    throw new TypeError("Unable to infer Vector type from input values, explicit type declaration expected.");
  }
  if (s + t === i.length)
    return new bn();
  if (r + t === i.length)
    return new Yt(new Pe(), new qt());
  if (o + t === i.length)
    return new mn();
  if (a + t === i.length)
    return new $e();
  if (c + t === i.length)
    return new va();
  if (e + t === i.length) {
    const u = i, d = di(u[u.findIndex((h) => h != null)]);
    if (u.every((h) => h == null || ol(d, di(h))))
      return new _e(new N("", d, !0));
  } else if (n + t === i.length) {
    const u = /* @__PURE__ */ new Map();
    for (const d of i)
      for (const h of Object.keys(d))
        !u.has(h) && d[h] != null && u.set(h, new N(h, di([d[h]]), !0));
    return new J([...u.values()]);
  }
  throw new TypeError("Unable to infer Vector type from input values, explicit type declaration expected.");
}
function cl(i) {
  const { ["queueingStrategy"]: t = "count" } = i, { ["highWaterMark"]: e = t !== "bytes" ? Number.POSITIVE_INFINITY : Math.pow(2, 14) } = i, n = t !== "bytes" ? "length" : "byteLength";
  return function* (s) {
    let r = 0;
    const o = Li(i);
    for (const a of s)
      o.append(a)[n] >= e && ++r && (yield o.toVector());
    (o.finish().length > 0 || r === 0) && (yield o.toVector());
  };
}
function qi(i, t) {
  return ll(i, t.map((e) => e.data.concat()));
}
function ll(i, t) {
  const e = [...i.fields], n = [], s = { numBatches: t.reduce((h, k) => Math.max(h, k.length), 0) };
  let r = 0, o = 0, a = -1;
  const c = t.length;
  let u, d = [];
  for (; s.numBatches-- > 0; ) {
    for (o = Number.POSITIVE_INFINITY, a = -1; ++a < c; )
      d[a] = u = t[a].shift(), o = Math.min(o, u ? u.length : o);
    Number.isFinite(o) && (d = ul(e, o, d, t, s), o > 0 && (n[r++] = _({
      type: new J(e),
      length: o,
      nullCount: 0,
      children: d.slice()
    })));
  }
  return [
    i = i.assign(e),
    n.map((h) => new dt(i, h))
  ];
}
function ul(i, t, e, n, s) {
  var r;
  const o = (t + 63 & -64) >> 3;
  for (let a = -1, c = n.length; ++a < c; ) {
    const u = e[a], d = u?.length;
    if (d >= t)
      d === t ? e[a] = u : (e[a] = u.slice(0, t), s.numBatches = Math.max(s.numBatches, n[a].unshift(u.slice(t, d - t))));
    else {
      const h = i[a];
      i[a] = h.clone({ nullable: !0 }), e[a] = (r = u?._changeLengthAndBackfillNullBitmap(t)) !== null && r !== void 0 ? r : _({
        type: h.type,
        length: t,
        nullCount: t,
        nullBitmap: new Uint8Array(o)
      });
    }
  }
  return e;
}
var Eo;
class nt {
  constructor(...t) {
    var e, n;
    if (t.length === 0)
      return this.batches = [], this.schema = new x([]), this._offsets = [0], this;
    let s, r;
    t[0] instanceof x && (s = t.shift()), t.at(-1) instanceof Uint32Array && (r = t.pop());
    const o = (c) => {
      if (c) {
        if (c instanceof dt)
          return [c];
        if (c instanceof nt)
          return c.batches;
        if (c instanceof L) {
          if (c.type instanceof J)
            return [new dt(new x(c.type.children), c)];
        } else {
          if (Array.isArray(c))
            return c.flatMap((u) => o(u));
          if (typeof c[Symbol.iterator] == "function")
            return [...c].flatMap((u) => o(u));
          if (typeof c == "object") {
            const u = Object.keys(c), d = u.map((M) => new D([c[M]])), h = s ?? new x(u.map((M, W) => new N(String(M), d[W].type, d[W].nullable))), [, k] = qi(h, d);
            return k.length === 0 ? [new dt(c)] : k;
          }
        }
      }
      return [];
    }, a = t.flatMap((c) => o(c));
    if (s = (n = s ?? ((e = a[0]) === null || e === void 0 ? void 0 : e.schema)) !== null && n !== void 0 ? n : new x([]), !(s instanceof x))
      throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
    for (const c of a) {
      if (!(c instanceof dt))
        throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
      if (!rl(s, c.schema))
        throw new TypeError("Table and inner RecordBatch schemas must be equivalent.");
    }
    this.schema = s, this.batches = a, this._offsets = r ?? eo(this.data);
  }
  /**
   * The contiguous {@link RecordBatch `RecordBatch`} chunks of the Table rows.
   */
  get data() {
    return this.batches.map(({ data: t }) => t);
  }
  /**
   * The number of columns in this Table.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this Table.
   */
  get numRows() {
    return this.data.reduce((t, e) => t + e.length, 0);
  }
  /**
   * The number of null rows in this Table.
   */
  get nullCount() {
    return this._nullCount === -1 && (this._nullCount = to(this.data)), this._nullCount;
  }
  /**
   * Check whether an element is null.
   *
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(t) {
    return !1;
  }
  /**
   * Get an element value by position.
   *
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(t) {
    return null;
  }
  /**
    * Get an element value by position.
    * @param index The index of the element to read. A negative index will count back from the last element.
    */
  // @ts-ignore
  at(t) {
    return this.get(Cn(t, this.numRows));
  }
  /**
   * Set an element value by position.
   *
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(t, e) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   *
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(t, e) {
    return -1;
  }
  /**
   * Iterator for rows in this Table.
   */
  [Symbol.iterator]() {
    return this.batches.length > 0 ? kn.visit(new D(this.data)) : new Array(0)[Symbol.iterator]();
  }
  /**
   * Return a JavaScript Array of the Table rows.
   *
   * @returns An Array of Table rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Returns a string representation of the Table rows.
   *
   * @returns A string representation of the Table rows.
   */
  toString() {
    return `[
  ${this.toArray().join(`,
  `)}
]`;
  }
  /**
   * Combines two or more Tables of the same schema.
   *
   * @param others Additional Tables to add to the end of this Tables.
   */
  concat(...t) {
    const e = this.schema, n = this.data.concat(t.flatMap(({ data: s }) => s));
    return new nt(e, n.map((s) => new dt(e, s)));
  }
  /**
   * Return a zero-copy sub-section of this Table.
   *
   * @param begin The beginning of the specified portion of the Table.
   * @param end The end of the specified portion of the Table. This is exclusive of the element at the index 'end'.
   */
  slice(t, e) {
    const n = this.schema;
    [t, e] = Qr({ length: this.numRows }, t, e);
    const s = io(this.data, this._offsets, t, e);
    return new nt(n, s.map((r) => new dt(n, r)));
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   *
   * @param name The name of the child to retrieve.
   */
  getChild(t) {
    return this.getChildAt(this.schema.fields.findIndex((e) => e.name === t));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   *
   * @param index The index of the child to retrieve.
   */
  getChildAt(t) {
    if (t > -1 && t < this.schema.fields.length) {
      const e = this.data.map((n) => n.children[t]);
      if (e.length === 0) {
        const { type: n } = this.schema.fields[t], s = _({ type: n, length: 0, nullCount: 0 });
        e.push(s._changeLengthAndBackfillNullBitmap(this.numRows));
      }
      return new D(e);
    }
    return null;
  }
  /**
   * Sets a child Vector by name.
   *
   * @param name The name of the child to overwrite.
   * @returns A new Table with the supplied child for the specified name.
   */
  setChild(t, e) {
    var n;
    return this.setChildAt((n = this.schema.fields) === null || n === void 0 ? void 0 : n.findIndex((s) => s.name === t), e);
  }
  setChildAt(t, e) {
    let n = this.schema, s = [...this.batches];
    if (t > -1 && t < this.numCols) {
      e || (e = new D([_({ type: new Ut(), length: this.numRows })]));
      const r = n.fields.slice(), o = r[t].clone({ type: e.type }), a = this.schema.fields.map((c, u) => this.getChildAt(u));
      [r[t], a[t]] = [o, e], [n, s] = qi(n, a);
    }
    return new nt(n, s);
  }
  /**
   * Construct a new Table containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new Table of columns matching the specified names.
   */
  select(t) {
    const e = this.schema.fields.reduce((n, s, r) => n.set(s.name, r), /* @__PURE__ */ new Map());
    return this.selectAt(t.map((n) => e.get(n)).filter((n) => n > -1));
  }
  /**
   * Construct a new Table containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new Table of columns at the specified indices.
   */
  selectAt(t) {
    const e = this.schema.selectAt(t), n = this.batches.map((s) => s.selectAt(t));
    return new nt(e, n);
  }
  assign(t) {
    const e = this.schema.fields, [n, s] = t.schema.fields.reduce((a, c, u) => {
      const [d, h] = a, k = e.findIndex((M) => M.name === c.name);
      return ~k ? h[k] = u : d.push(u), a;
    }, [[], []]), r = this.schema.assign(t.schema), o = [
      ...e.map((a, c) => [c, s[c]]).map(([a, c]) => c === void 0 ? this.getChildAt(a) : t.getChildAt(c)),
      ...n.map((a) => t.getChildAt(a))
    ].filter(Boolean);
    return new nt(...qi(r, o));
  }
}
Eo = Symbol.toStringTag;
nt[Eo] = ((i) => (i.schema = null, i.batches = [], i._offsets = new Uint32Array([0]), i._nullCount = -1, i[Symbol.isConcatSpreadable] = !0, i.isValid = Ai(jn), i.get = Ai(X.getVisitFn(l.Struct)), i.set = no(lt.getVisitFn(l.Struct)), i.indexOf = so(Oi.getVisitFn(l.Struct)), "Table"))(nt.prototype);
function Ql(i) {
  const t = {}, e = Object.entries(i);
  for (const [n, s] of e)
    t[n] = al(s);
  return new nt(t);
}
var zo;
let dt = class Ce {
  constructor(...t) {
    switch (t.length) {
      case 2: {
        if ([this.schema] = t, !(this.schema instanceof x))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        if ([
          ,
          this.data = _({
            nullCount: 0,
            type: new J(this.schema.fields),
            children: this.schema.fields.map((e) => _({ type: e.type, nullCount: 0 }))
          })
        ] = t, !(this.data instanceof L))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        [this.schema, this.data] = ms(this.schema, this.data.children);
        break;
      }
      case 1: {
        const [e] = t, { fields: n, children: s, length: r } = Object.keys(e).reduce((c, u, d) => (c.children[d] = e[u], c.length = Math.max(c.length, e[u].length), c.fields[d] = N.new({ name: u, type: e[u].type, nullable: !0 }), c), {
          length: 0,
          fields: new Array(),
          children: new Array()
        }), o = new x(n), a = _({ type: new J(n), length: r, children: s, nullCount: 0 });
        [this.schema, this.data] = ms(o, a.children, r);
        break;
      }
      default:
        throw new TypeError("RecordBatch constructor expects an Object mapping names to child Data, or a [Schema, Data] pair.");
    }
  }
  get dictionaries() {
    return this._dictionaries || (this._dictionaries = jo(this.schema.fields, this.data.children));
  }
  /**
   * The number of columns in this RecordBatch.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this RecordBatch.
   */
  get numRows() {
    return this.data.length;
  }
  /**
   * The number of null rows in this RecordBatch.
   */
  get nullCount() {
    return this.data.nullCount;
  }
  /**
   * Check whether an row is null.
   * @param index The index at which to read the validity bitmap.
   */
  isValid(t) {
    return this.data.getValid(t);
  }
  /**
   * Get a row by position.
   * @param index The index of the row to read.
   */
  get(t) {
    return X.visit(this.data, t);
  }
  /**
    * Get a row value by position.
    * @param index The index of the row to read. A negative index will count back from the last row.
    */
  at(t) {
    return this.get(Cn(t, this.numRows));
  }
  /**
   * Set a row by position.
   * @param index The index of the row to write.
   * @param value The value to set.
   */
  set(t, e) {
    return lt.visit(this.data, t, e);
  }
  /**
   * Retrieve the index of the first occurrence of a row in an RecordBatch.
   * @param element The row to locate in the RecordBatch.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  indexOf(t, e) {
    return Oi.visit(this.data, t, e);
  }
  /**
   * Iterator for rows in this RecordBatch.
   */
  [Symbol.iterator]() {
    return kn.visit(new D([this.data]));
  }
  /**
   * Return a JavaScript Array of the RecordBatch rows.
   * @returns An Array of RecordBatch rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Combines two or more RecordBatch of the same schema.
   * @param others Additional RecordBatch to add to the end of this RecordBatch.
   */
  concat(...t) {
    return new nt(this.schema, [this, ...t]);
  }
  /**
   * Return a zero-copy sub-section of this RecordBatch.
   * @param start The beginning of the specified portion of the RecordBatch.
   * @param end The end of the specified portion of the RecordBatch. This is exclusive of the row at the index 'end'.
   */
  slice(t, e) {
    const [n] = new D([this.data]).slice(t, e).data;
    return new Ce(this.schema, n);
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(t) {
    var e;
    return this.getChildAt((e = this.schema.fields) === null || e === void 0 ? void 0 : e.findIndex((n) => n.name === t));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(t) {
    return t > -1 && t < this.schema.fields.length ? new D([this.data.children[t]]) : null;
  }
  /**
   * Sets a child Vector by name.
   * @param name The name of the child to overwrite.
   * @returns A new RecordBatch with the new child for the specified name.
   */
  setChild(t, e) {
    var n;
    return this.setChildAt((n = this.schema.fields) === null || n === void 0 ? void 0 : n.findIndex((s) => s.name === t), e);
  }
  setChildAt(t, e) {
    let n = this.schema, s = this.data;
    if (t > -1 && t < this.numCols) {
      e || (e = new D([_({ type: new Ut(), length: this.numRows })]));
      const r = n.fields.slice(), o = s.children.slice(), a = r[t].clone({ type: e.type });
      [r[t], o[t]] = [a, e.data[0]], n = new x(r, new Map(this.schema.metadata)), s = _({ type: new J(r), children: o });
    }
    return new Ce(n, s);
  }
  /**
   * Construct a new RecordBatch containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new RecordBatch of columns matching the specified names.
   */
  select(t) {
    const e = this.schema.select(t), n = new J(e.fields), s = [];
    for (const r of t) {
      const o = this.schema.fields.findIndex((a) => a.name === r);
      ~o && (s[o] = this.data.children[o]);
    }
    return new Ce(e, _({ type: n, length: this.numRows, children: s }));
  }
  /**
   * Construct a new RecordBatch containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new RecordBatch of columns matching at the specified indices.
   */
  selectAt(t) {
    const e = this.schema.selectAt(t), n = t.map((r) => this.data.children[r]).filter(Boolean), s = _({ type: new J(e.fields), length: this.numRows, children: n });
    return new Ce(e, s);
  }
};
zo = Symbol.toStringTag;
dt[zo] = ((i) => (i._nullCount = -1, i[Symbol.isConcatSpreadable] = !0, "RecordBatch"))(dt.prototype);
function ms(i, t, e = t.reduce((n, s) => Math.max(n, s.length), 0)) {
  var n;
  const s = [...i.fields], r = [...t], o = (e + 63 & -64) >> 3;
  for (const [a, c] of i.fields.entries()) {
    const u = t[a];
    (!u || u.length !== e) && (s[a] = c.clone({ nullable: !0 }), r[a] = (n = u?._changeLengthAndBackfillNullBitmap(e)) !== null && n !== void 0 ? n : _({
      type: c.type,
      length: e,
      nullCount: e,
      nullBitmap: new Uint8Array(o)
    }));
  }
  return [
    i.assign(s),
    _({ type: new J(s), length: e, children: r })
  ];
}
function jo(i, t, e = /* @__PURE__ */ new Map()) {
  var n, s;
  if (((n = i?.length) !== null && n !== void 0 ? n : 0) > 0 && i?.length === t?.length)
    for (let r = -1, o = i.length; ++r < o; ) {
      const { type: a } = i[r], c = t[r];
      for (const u of [c, ...((s = c?.dictionary) === null || s === void 0 ? void 0 : s.data) || []])
        jo(a.children, u?.children, e);
      if (f.isDictionary(a)) {
        const { id: u } = a;
        if (!e.has(u))
          c?.dictionary && e.set(u, c.dictionary);
        else if (e.get(u) !== c.dictionary)
          throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
      }
    }
  return e;
}
class ko extends dt {
  constructor(t) {
    const e = t.fields.map((s) => _({ type: s.type })), n = _({ type: new J(t.fields), nullCount: 0, children: e });
    super(t, n);
  }
}
let kt = class gt {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, e) {
    return this.bb_pos = t, this.bb = e, this;
  }
  static getRootAsMessage(t, e) {
    return (e || new gt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsMessage(t, e) {
    return t.setPosition(t.position() + V), (e || new gt()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  version() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : P.V1;
  }
  headerType() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readUint8(this.bb_pos + t) : U.NONE;
  }
  header(t) {
    const e = this.bb.__offset(this.bb_pos, 8);
    return e ? this.bb.__union(t, this.bb_pos + e) : null;
  }
  bodyLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  customMetadata(t, e) {
    const n = this.bb.__offset(this.bb_pos, 12);
    return n ? (e || new $()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startMessage(t) {
    t.startObject(5);
  }
  static addVersion(t, e) {
    t.addFieldInt16(0, e, P.V1);
  }
  static addHeaderType(t, e) {
    t.addFieldInt8(1, e, U.NONE);
  }
  static addHeader(t, e) {
    t.addFieldOffset(2, e, 0);
  }
  static addBodyLength(t, e) {
    t.addFieldInt64(3, e, BigInt("0"));
  }
  static addCustomMetadata(t, e) {
    t.addFieldOffset(4, e, 0);
  }
  static createCustomMetadataVector(t, e) {
    t.startVector(4, e.length, 4);
    for (let n = e.length - 1; n >= 0; n--)
      t.addOffset(e[n]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, e) {
    t.startVector(4, e, 4);
  }
  static endMessage(t) {
    return t.endObject();
  }
  static finishMessageBuffer(t, e) {
    t.finish(e);
  }
  static finishSizePrefixedMessageBuffer(t, e) {
    t.finish(e, void 0, !0);
  }
  static createMessage(t, e, n, s, r, o) {
    return gt.startMessage(t), gt.addVersion(t, e), gt.addHeaderType(t, n), gt.addHeader(t, s), gt.addBodyLength(t, r), gt.addCustomMetadata(t, o), gt.endMessage(t);
  }
};
class dl extends F {
  visit(t, e) {
    return t == null || e == null ? void 0 : super.visit(t, e);
  }
  visitNull(t, e) {
    return os.startNull(e), os.endNull(e);
  }
  visitInt(t, e) {
    return it.startInt(e), it.addBitWidth(e, t.bitWidth), it.addIsSigned(e, t.isSigned), it.endInt(e);
  }
  visitFloat(t, e) {
    return wt.startFloatingPoint(e), wt.addPrecision(e, t.precision), wt.endFloatingPoint(e);
  }
  visitBinary(t, e) {
    return es.startBinary(e), es.endBinary(e);
  }
  visitLargeBinary(t, e) {
    return ns.startLargeBinary(e), ns.endLargeBinary(e);
  }
  visitBool(t, e) {
    return is.startBool(e), is.endBool(e);
  }
  visitUtf8(t, e) {
    return as.startUtf8(e), as.endUtf8(e);
  }
  visitLargeUtf8(t, e) {
    return ss.startLargeUtf8(e), ss.endLargeUtf8(e);
  }
  visitDecimal(t, e) {
    return ne.startDecimal(e), ne.addScale(e, t.scale), ne.addPrecision(e, t.precision), ne.addBitWidth(e, t.bitWidth), ne.endDecimal(e);
  }
  visitDate(t, e) {
    return ri.startDate(e), ri.addUnit(e, t.unit), ri.endDate(e);
  }
  visitTime(t, e) {
    return ot.startTime(e), ot.addUnit(e, t.unit), ot.addBitWidth(e, t.bitWidth), ot.endTime(e);
  }
  visitTimestamp(t, e) {
    const n = t.timezone && e.createString(t.timezone) || void 0;
    return at.startTimestamp(e), at.addUnit(e, t.unit), n !== void 0 && at.addTimezone(e, n), at.endTimestamp(e);
  }
  visitInterval(t, e) {
    return It.startInterval(e), It.addUnit(e, t.unit), It.endInterval(e);
  }
  visitDuration(t, e) {
    return oi.startDuration(e), oi.addUnit(e, t.unit), oi.endDuration(e);
  }
  visitList(t, e) {
    return rs.startList(e), rs.endList(e);
  }
  visitStruct(t, e) {
    return Gt.startStruct_(e), Gt.endStruct_(e);
  }
  visitUnion(t, e) {
    Z.startTypeIdsVector(e, t.typeIds.length);
    const n = Z.createTypeIdsVector(e, t.typeIds);
    return Z.startUnion(e), Z.addMode(e, t.mode), Z.addTypeIds(e, n), Z.endUnion(e);
  }
  visitDictionary(t, e) {
    const n = this.visit(t.indices, e);
    return Mt.startDictionaryEncoding(e), Mt.addId(e, BigInt(t.id)), Mt.addIsOrdered(e, t.isOrdered), n !== void 0 && Mt.addIndexType(e, n), Mt.endDictionaryEncoding(e);
  }
  visitFixedSizeBinary(t, e) {
    return ai.startFixedSizeBinary(e), ai.addByteWidth(e, t.byteWidth), ai.endFixedSizeBinary(e);
  }
  visitFixedSizeList(t, e) {
    return ci.startFixedSizeList(e), ci.addListSize(e, t.listSize), ci.endFixedSizeList(e);
  }
  visitMap(t, e) {
    return li.startMap(e), li.addKeysSorted(e, t.keysSorted), li.endMap(e);
  }
}
const Qi = new dl();
function hl(i, t = /* @__PURE__ */ new Map()) {
  return new x(pl(i, t), hi(i.metadata), t);
}
function Po(i) {
  return new pt(i.count, $o(i.columns), Wo(i.columns));
}
function fl(i) {
  return new Vt(Po(i.data), i.id, i.isDelta);
}
function pl(i, t) {
  return (i.fields || []).filter(Boolean).map((e) => N.fromJSON(e, t));
}
function bs(i, t) {
  return (i.children || []).filter(Boolean).map((e) => N.fromJSON(e, t));
}
function $o(i) {
  return (i || []).reduce((t, e) => [
    ...t,
    new Fe(e.count, yl(e.VALIDITY)),
    ...$o(e.children)
  ], []);
}
function Wo(i, t = []) {
  for (let e = -1, n = (i || []).length; ++e < n; ) {
    const s = i[e];
    s.VALIDITY && t.push(new Lt(t.length, s.VALIDITY.length)), s.TYPE_ID && t.push(new Lt(t.length, s.TYPE_ID.length)), s.OFFSET && t.push(new Lt(t.length, s.OFFSET.length)), s.DATA && t.push(new Lt(t.length, s.DATA.length)), t = Wo(s.children, t);
  }
  return t;
}
function yl(i) {
  return (i || []).reduce((t, e) => t + +(e === 0), 0);
}
function gl(i, t) {
  let e, n, s, r, o, a;
  return !t || !(r = i.dictionary) ? (o = vs(i, bs(i, t)), s = new N(i.name, o, i.nullable, hi(i.metadata))) : t.has(e = r.id) ? (n = (n = r.indexType) ? _s(n) : new qt(), a = new Yt(t.get(e), n, e, r.isOrdered), s = new N(i.name, a, i.nullable, hi(i.metadata))) : (n = (n = r.indexType) ? _s(n) : new qt(), t.set(e, o = vs(i, bs(i, t))), a = new Yt(o, n, e, r.isOrdered), s = new N(i.name, a, i.nullable, hi(i.metadata))), s || null;
}
function hi(i = []) {
  return new Map(i.map(({ key: t, value: e }) => [t, e]));
}
function _s(i) {
  return new Q(i.isSigned, i.bitWidth);
}
function vs(i, t) {
  const e = i.type.name;
  switch (e) {
    case "NONE":
      return new Ut();
    case "null":
      return new Ut();
    case "binary":
      return new mi();
    case "largebinary":
      return new bi();
    case "utf8":
      return new Pe();
    case "largeutf8":
      return new _i();
    case "bool":
      return new $e();
    case "list":
      return new _e((t || [])[0]);
    case "struct":
      return new J(t || []);
    case "struct_":
      return new J(t || []);
  }
  switch (e) {
    case "int": {
      const n = i.type;
      return new Q(n.isSigned, n.bitWidth);
    }
    case "floatingpoint": {
      const n = i.type;
      return new be(Y[n.precision]);
    }
    case "decimal": {
      const n = i.type;
      return new vi(n.scale, n.precision, n.bitWidth);
    }
    case "date": {
      const n = i.type;
      return new wi(ct[n.unit]);
    }
    case "time": {
      const n = i.type;
      return new Ii(p[n.unit], n.bitWidth);
    }
    case "timestamp": {
      const n = i.type;
      return new We(p[n.unit], n.timezone);
    }
    case "interval": {
      const n = i.type;
      return new Si(Dt[n.unit]);
    }
    case "duration": {
      const n = i.type;
      return new Bi(p[n.unit]);
    }
    case "union": {
      const n = i.type, [s, ...r] = (n.mode + "").toLowerCase(), o = s.toUpperCase() + r.join("");
      return new Ye(q[o], n.typeIds || [], t || []);
    }
    case "fixedsizebinary": {
      const n = i.type;
      return new Di(n.byteWidth);
    }
    case "fixedsizelist": {
      const n = i.type;
      return new Je(n.listSize, (t || [])[0]);
    }
    case "map": {
      const n = i.type;
      return new He((t || [])[0], n.keysSorted);
    }
  }
  throw new Error(`Unrecognized type: "${e}"`);
}
var ml = Us, bl = ge;
class ht {
  /** @nocollapse */
  static fromJSON(t, e) {
    const n = new ht(0, P.V5, e);
    return n._createHeader = _l(t, e), n;
  }
  /** @nocollapse */
  static decode(t) {
    t = new bl(T(t));
    const e = kt.getRootAsMessage(t), n = e.bodyLength(), s = e.version(), r = e.headerType(), o = new ht(n, s, r);
    return o._createHeader = vl(e, r), o;
  }
  /** @nocollapse */
  static encode(t) {
    const e = new ml();
    let n = -1;
    return t.isSchema() ? n = x.encode(e, t.header()) : t.isRecordBatch() ? n = pt.encode(e, t.header()) : t.isDictionaryBatch() && (n = Vt.encode(e, t.header())), kt.startMessage(e), kt.addVersion(e, P.V5), kt.addHeader(e, n), kt.addHeaderType(e, t.headerType), kt.addBodyLength(e, BigInt(t.bodyLength)), kt.finishMessageBuffer(e, kt.endMessage(e)), e.asUint8Array();
  }
  /** @nocollapse */
  static from(t, e = 0) {
    if (t instanceof x)
      return new ht(0, P.V5, U.Schema, t);
    if (t instanceof pt)
      return new ht(e, P.V5, U.RecordBatch, t);
    if (t instanceof Vt)
      return new ht(e, P.V5, U.DictionaryBatch, t);
    throw new Error(`Unrecognized Message header: ${t}`);
  }
  get type() {
    return this.headerType;
  }
  get version() {
    return this._version;
  }
  get headerType() {
    return this._headerType;
  }
  get bodyLength() {
    return this._bodyLength;
  }
  header() {
    return this._createHeader();
  }
  isSchema() {
    return this.headerType === U.Schema;
  }
  isRecordBatch() {
    return this.headerType === U.RecordBatch;
  }
  isDictionaryBatch() {
    return this.headerType === U.DictionaryBatch;
  }
  constructor(t, e, n, s) {
    this._version = e, this._headerType = n, this.body = new Uint8Array(0), s && (this._createHeader = () => s), this._bodyLength = z(t);
  }
}
class pt {
  get nodes() {
    return this._nodes;
  }
  get length() {
    return this._length;
  }
  get buffers() {
    return this._buffers;
  }
  constructor(t, e, n) {
    this._nodes = e, this._buffers = n, this._length = z(t);
  }
}
class Vt {
  get id() {
    return this._id;
  }
  get data() {
    return this._data;
  }
  get isDelta() {
    return this._isDelta;
  }
  get length() {
    return this.data.length;
  }
  get nodes() {
    return this.data.nodes;
  }
  get buffers() {
    return this.data.buffers;
  }
  constructor(t, e, n = !1) {
    this._data = t, this._isDelta = n, this._id = z(e);
  }
}
class Lt {
  constructor(t, e) {
    this.offset = z(t), this.length = z(e);
  }
}
class Fe {
  constructor(t, e) {
    this.length = z(t), this.nullCount = z(e);
  }
}
function _l(i, t) {
  return (() => {
    switch (t) {
      case U.Schema:
        return x.fromJSON(i);
      case U.RecordBatch:
        return pt.fromJSON(i);
      case U.DictionaryBatch:
        return Vt.fromJSON(i);
    }
    throw new Error(`Unrecognized Message type: { name: ${U[t]}, type: ${t} }`);
  });
}
function vl(i, t) {
  return (() => {
    switch (t) {
      case U.Schema:
        return x.decode(i.header(new mt()), /* @__PURE__ */ new Map(), i.version());
      case U.RecordBatch:
        return pt.decode(i.header(new Ot()), i.version());
      case U.DictionaryBatch:
        return Vt.decode(i.header(new ee()), i.version());
    }
    throw new Error(`Unrecognized Message type: { name: ${U[t]}, type: ${t} }`);
  });
}
N.encode = Ll;
N.decode = Tl;
N.fromJSON = gl;
x.encode = Ml;
x.decode = wl;
x.fromJSON = hl;
pt.encode = Nl;
pt.decode = Il;
pt.fromJSON = Po;
Vt.encode = Ul;
Vt.decode = Sl;
Vt.fromJSON = fl;
Fe.encode = xl;
Fe.decode = Dl;
Lt.encode = Vl;
Lt.decode = Bl;
function wl(i, t = /* @__PURE__ */ new Map(), e = P.V5) {
  const n = Fl(i, t);
  return new x(n, fi(i), t, e);
}
function Il(i, t = P.V5) {
  if (i.compression() !== null)
    throw new Error("Record batch compression not implemented");
  return new pt(i.length(), Al(i), Ol(i, t));
}
function Sl(i, t = P.V5) {
  return new Vt(pt.decode(i.data(), t), i.id(), i.isDelta());
}
function Bl(i) {
  return new Lt(i.offset(), i.length());
}
function Dl(i) {
  return new Fe(i.length(), i.nullCount());
}
function Al(i) {
  const t = [];
  for (let e, n = -1, s = -1, r = i.nodesLength(); ++n < r; )
    (e = i.nodes(n)) && (t[++s] = Fe.decode(e));
  return t;
}
function Ol(i, t) {
  const e = [];
  for (let n, s = -1, r = -1, o = i.buffersLength(); ++s < o; )
    (n = i.buffers(s)) && (t < P.V4 && (n.bb_pos += 8 * (s + 1)), e[++r] = Lt.decode(n));
  return e;
}
function Fl(i, t) {
  const e = [];
  for (let n, s = -1, r = -1, o = i.fieldsLength(); ++s < o; )
    (n = i.fields(s)) && (e[++r] = N.decode(n, t));
  return e;
}
function ws(i, t) {
  const e = [];
  for (let n, s = -1, r = -1, o = i.childrenLength(); ++s < o; )
    (n = i.children(s)) && (e[++r] = N.decode(n, t));
  return e;
}
function Tl(i, t) {
  let e, n, s, r, o, a;
  return !t || !(a = i.dictionary()) ? (s = Ss(i, ws(i, t)), n = new N(i.name(), s, i.nullable(), fi(i))) : t.has(e = z(a.id())) ? (r = (r = a.indexType()) ? Is(r) : new qt(), o = new Yt(t.get(e), r, e, a.isOrdered()), n = new N(i.name(), o, i.nullable(), fi(i))) : (r = (r = a.indexType()) ? Is(r) : new qt(), t.set(e, s = Ss(i, ws(i, t))), o = new Yt(s, r, e, a.isOrdered()), n = new N(i.name(), o, i.nullable(), fi(i))), n || null;
}
function fi(i) {
  const t = /* @__PURE__ */ new Map();
  if (i)
    for (let e, n, s = -1, r = Math.trunc(i.customMetadataLength()); ++s < r; )
      (e = i.customMetadata(s)) && (n = e.key()) != null && t.set(n, e.value());
  return t;
}
function Is(i) {
  return new Q(i.isSigned(), i.bitWidth());
}
function Ss(i, t) {
  const e = i.typeType();
  switch (e) {
    case E.NONE:
      return new Ut();
    case E.Null:
      return new Ut();
    case E.Binary:
      return new mi();
    case E.LargeBinary:
      return new bi();
    case E.Utf8:
      return new Pe();
    case E.LargeUtf8:
      return new _i();
    case E.Bool:
      return new $e();
    case E.List:
      return new _e((t || [])[0]);
    case E.Struct_:
      return new J(t || []);
  }
  switch (e) {
    case E.Int: {
      const n = i.type(new it());
      return new Q(n.isSigned(), n.bitWidth());
    }
    case E.FloatingPoint: {
      const n = i.type(new wt());
      return new be(n.precision());
    }
    case E.Decimal: {
      const n = i.type(new ne());
      return new vi(n.scale(), n.precision(), n.bitWidth());
    }
    case E.Date: {
      const n = i.type(new ri());
      return new wi(n.unit());
    }
    case E.Time: {
      const n = i.type(new ot());
      return new Ii(n.unit(), n.bitWidth());
    }
    case E.Timestamp: {
      const n = i.type(new at());
      return new We(n.unit(), n.timezone());
    }
    case E.Interval: {
      const n = i.type(new It());
      return new Si(n.unit());
    }
    case E.Duration: {
      const n = i.type(new oi());
      return new Bi(n.unit());
    }
    case E.Union: {
      const n = i.type(new Z());
      return new Ye(n.mode(), n.typeIdsArray() || [], t || []);
    }
    case E.FixedSizeBinary: {
      const n = i.type(new ai());
      return new Di(n.byteWidth());
    }
    case E.FixedSizeList: {
      const n = i.type(new ci());
      return new Je(n.listSize(), (t || [])[0]);
    }
    case E.Map: {
      const n = i.type(new li());
      return new He((t || [])[0], n.keysSorted());
    }
  }
  throw new Error(`Unrecognized type: "${E[e]}" (${e})`);
}
function Ml(i, t) {
  const e = t.fields.map((r) => N.encode(i, r));
  mt.startFieldsVector(i, e.length);
  const n = mt.createFieldsVector(i, e), s = t.metadata && t.metadata.size > 0 ? mt.createCustomMetadataVector(i, [...t.metadata].map(([r, o]) => {
    const a = i.createString(`${r}`), c = i.createString(`${o}`);
    return $.startKeyValue(i), $.addKey(i, a), $.addValue(i, c), $.endKeyValue(i);
  })) : -1;
  return mt.startSchema(i), mt.addFields(i, n), mt.addEndianness(i, Rl ? me.Little : me.Big), s !== -1 && mt.addCustomMetadata(i, s), mt.endSchema(i);
}
function Ll(i, t) {
  let e = -1, n = -1, s = -1;
  const r = t.type;
  let o = t.typeId;
  f.isDictionary(r) ? (o = r.dictionary.typeId, s = Qi.visit(r, i), n = Qi.visit(r.dictionary, i)) : n = Qi.visit(r, i);
  const a = (r.children || []).map((d) => N.encode(i, d)), c = st.createChildrenVector(i, a), u = t.metadata && t.metadata.size > 0 ? st.createCustomMetadataVector(i, [...t.metadata].map(([d, h]) => {
    const k = i.createString(`${d}`), M = i.createString(`${h}`);
    return $.startKeyValue(i), $.addKey(i, k), $.addValue(i, M), $.endKeyValue(i);
  })) : -1;
  return t.name && (e = i.createString(t.name)), st.startField(i), st.addType(i, n), st.addTypeType(i, o), st.addChildren(i, c), st.addNullable(i, !!t.nullable), e !== -1 && st.addName(i, e), s !== -1 && st.addDictionary(i, s), u !== -1 && st.addCustomMetadata(i, u), st.endField(i);
}
function Nl(i, t) {
  const e = t.nodes || [], n = t.buffers || [];
  Ot.startNodesVector(i, e.length);
  for (const o of e.slice().reverse())
    Fe.encode(i, o);
  const s = i.endVector();
  Ot.startBuffersVector(i, n.length);
  for (const o of n.slice().reverse())
    Lt.encode(i, o);
  const r = i.endVector();
  return Ot.startRecordBatch(i), Ot.addLength(i, BigInt(t.length)), Ot.addNodes(i, s), Ot.addBuffers(i, r), Ot.endRecordBatch(i);
}
function Ul(i, t) {
  const e = pt.encode(i, t.data);
  return ee.startDictionaryBatch(i), ee.addId(i, BigInt(t.id)), ee.addIsDelta(i, t.isDelta), ee.addData(i, e), ee.endDictionaryBatch(i);
}
function xl(i, t) {
  return Rs.createFieldNode(i, BigInt(t.length), BigInt(t.nullCount));
}
function Vl(i, t) {
  return Vs.createBuffer(i, BigInt(t.offset), BigInt(t.length));
}
const Rl = (() => {
  const i = new ArrayBuffer(2);
  return new DataView(i).setInt16(
    0,
    256,
    !0
    /* littleEndian */
  ), new Int16Array(i)[0] === 256;
})(), Kn = (i) => `Expected ${U[i]} Message in stream, but was null or length 0.`, Gn = (i) => `Header pointer of flatbuffer-encoded ${U[i]} Message is null or length 0.`, Yo = (i, t) => `Expected to read ${i} metadata bytes, but only read ${t}.`, Jo = (i, t) => `Expected to read ${i} bytes for message body, but only read ${t}.`;
class Ho {
  constructor(t) {
    this.source = t instanceof Ti ? t : new Ti(t);
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    let t;
    return (t = this.readMetadataLength()).done || t.value === -1 && (t = this.readMetadataLength()).done || (t = this.readMetadata(t.value)).done ? j : t;
  }
  throw(t) {
    return this.source.throw(t);
  }
  return(t) {
    return this.source.return(t);
  }
  readMessage(t) {
    let e;
    if ((e = this.next()).done)
      return null;
    if (t != null && e.value.headerType !== t)
      throw new Error(Kn(t));
    return e.value;
  }
  readMessageBody(t) {
    if (t <= 0)
      return new Uint8Array(0);
    const e = T(this.source.read(t));
    if (e.byteLength < t)
      throw new Error(Jo(t, e.byteLength));
    return (
      /* 1. */
      e.byteOffset % 8 === 0 && /* 2. */
      e.byteOffset + e.byteLength <= e.buffer.byteLength ? e : e.slice()
    );
  }
  readSchema(t = !1) {
    const e = U.Schema, n = this.readMessage(e), s = n?.header();
    if (t && !s)
      throw new Error(Gn(e));
    return s;
  }
  readMetadataLength() {
    const t = this.source.read(Wi), e = t && new ge(t), n = e?.readInt32(0) || 0;
    return { done: n === 0, value: n };
  }
  readMetadata(t) {
    const e = this.source.read(t);
    if (!e)
      return j;
    if (e.byteLength < t)
      throw new Error(Yo(t, e.byteLength));
    return { done: !1, value: ht.decode(e) };
  }
}
class Cl {
  constructor(t, e) {
    this.source = t instanceof we ? t : Os(t) ? new Mi(t, e) : new we(t);
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next() {
    return A(this, void 0, void 0, function* () {
      let t;
      return (t = yield this.readMetadataLength()).done || t.value === -1 && (t = yield this.readMetadataLength()).done || (t = yield this.readMetadata(t.value)).done ? j : t;
    });
  }
  throw(t) {
    return A(this, void 0, void 0, function* () {
      return yield this.source.throw(t);
    });
  }
  return(t) {
    return A(this, void 0, void 0, function* () {
      return yield this.source.return(t);
    });
  }
  readMessage(t) {
    return A(this, void 0, void 0, function* () {
      let e;
      if ((e = yield this.next()).done)
        return null;
      if (t != null && e.value.headerType !== t)
        throw new Error(Kn(t));
      return e.value;
    });
  }
  readMessageBody(t) {
    return A(this, void 0, void 0, function* () {
      if (t <= 0)
        return new Uint8Array(0);
      const e = T(yield this.source.read(t));
      if (e.byteLength < t)
        throw new Error(Jo(t, e.byteLength));
      return (
        /* 1. */
        e.byteOffset % 8 === 0 && /* 2. */
        e.byteOffset + e.byteLength <= e.buffer.byteLength ? e : e.slice()
      );
    });
  }
  readSchema() {
    return A(this, arguments, void 0, function* (t = !1) {
      const e = U.Schema, n = yield this.readMessage(e), s = n?.header();
      if (t && !s)
        throw new Error(Gn(e));
      return s;
    });
  }
  readMetadataLength() {
    return A(this, void 0, void 0, function* () {
      const t = yield this.source.read(Wi), e = t && new ge(t), n = e?.readInt32(0) || 0;
      return { done: n === 0, value: n };
    });
  }
  readMetadata(t) {
    return A(this, void 0, void 0, function* () {
      const e = yield this.source.read(t);
      if (!e)
        return j;
      if (e.byteLength < t)
        throw new Error(Yo(t, e.byteLength));
      return { done: !1, value: ht.decode(e) };
    });
  }
}
class El extends Ho {
  constructor(t) {
    super(new Uint8Array(0)), this._schema = !1, this._body = [], this._batchIndex = 0, this._dictionaryIndex = 0, this._json = t instanceof ys ? t : new ys(t);
  }
  next() {
    const { _json: t } = this;
    if (!this._schema)
      return this._schema = !0, { done: !1, value: ht.fromJSON(t.schema, U.Schema) };
    if (this._dictionaryIndex < t.dictionaries.length) {
      const e = t.dictionaries[this._dictionaryIndex++];
      return this._body = e.data.columns, { done: !1, value: ht.fromJSON(e, U.DictionaryBatch) };
    }
    if (this._batchIndex < t.batches.length) {
      const e = t.batches[this._batchIndex++];
      return this._body = e.columns, { done: !1, value: ht.fromJSON(e, U.RecordBatch) };
    }
    return this._body = [], j;
  }
  readMessageBody(t) {
    return e(this._body);
    function e(n) {
      return (n || []).reduce((s, r) => [
        ...s,
        ...r.VALIDITY && [r.VALIDITY] || [],
        ...r.TYPE_ID && [r.TYPE_ID] || [],
        ...r.OFFSET && [r.OFFSET] || [],
        ...r.DATA && [r.DATA] || [],
        ...e(r.children)
      ], []);
    }
  }
  readMessage(t) {
    let e;
    if ((e = this.next()).done)
      return null;
    if (t != null && e.value.headerType !== t)
      throw new Error(Kn(t));
    return e.value;
  }
  readSchema() {
    const t = U.Schema, e = this.readMessage(t), n = e?.header();
    if (!e || !n)
      throw new Error(Gn(t));
    return n;
  }
}
const Wi = 4, hn = "ARROW1", Ni = new Uint8Array(hn.length);
for (let i = 0; i < hn.length; i += 1)
  Ni[i] = hn.codePointAt(i);
function Zn(i, t = 0) {
  for (let e = -1, n = Ni.length; ++e < n; )
    if (Ni[e] !== i[t + e])
      return !1;
  return !0;
}
const ti = Ni.length, Ko = ti + Wi, zl = ti * 2 + Wi;
class Nt extends fo {
  constructor(t) {
    super(), this._impl = t;
  }
  get closed() {
    return this._impl.closed;
  }
  get schema() {
    return this._impl.schema;
  }
  get autoDestroy() {
    return this._impl.autoDestroy;
  }
  get dictionaries() {
    return this._impl.dictionaries;
  }
  get numDictionaries() {
    return this._impl.numDictionaries;
  }
  get numRecordBatches() {
    return this._impl.numRecordBatches;
  }
  get footer() {
    return this._impl.isFile() ? this._impl.footer : null;
  }
  isSync() {
    return this._impl.isSync();
  }
  isAsync() {
    return this._impl.isAsync();
  }
  isFile() {
    return this._impl.isFile();
  }
  isStream() {
    return this._impl.isStream();
  }
  next() {
    return this._impl.next();
  }
  throw(t) {
    return this._impl.throw(t);
  }
  return(t) {
    return this._impl.return(t);
  }
  cancel() {
    return this._impl.cancel();
  }
  reset(t) {
    return this._impl.reset(t), this._DOMStream = void 0, this._nodeStream = void 0, this;
  }
  open(t) {
    const e = this._impl.open(t);
    return ze(e) ? e.then(() => this) : this;
  }
  readRecordBatch(t) {
    return this._impl.isFile() ? this._impl.readRecordBatch(t) : null;
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
  toDOMStream() {
    return rt.toDOMStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this });
  }
  toNodeStream() {
    return rt.toNodeStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this }, { objectMode: !0 });
  }
  /** @nocollapse */
  // @ts-ignore
  static throughNode(t) {
    throw new Error('"throughNode" not available in this environment');
  }
  /** @nocollapse */
  static throughDOM(t, e) {
    throw new Error('"throughDOM" not available in this environment');
  }
  /** @nocollapse */
  static from(t) {
    return t instanceof Nt ? t : tn(t) ? $l(t) : Os(t) ? Jl(t) : ze(t) ? A(this, void 0, void 0, function* () {
      return yield Nt.from(yield t);
    }) : Fs(t) || pn(t) || Ms(t) || fn(t) ? Yl(new we(t)) : Wl(new Ti(t));
  }
  /** @nocollapse */
  static readAll(t) {
    return t instanceof Nt ? t.isSync() ? Bs(t) : Ds(t) : tn(t) || ArrayBuffer.isView(t) || Ci(t) || As(t) ? Bs(t) : Ds(t);
  }
}
class Ui extends Nt {
  constructor(t) {
    super(t), this._impl = t;
  }
  readAll() {
    return [...this];
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return St(this, arguments, function* () {
      yield O(yield* si(de(this[Symbol.iterator]())));
    });
  }
}
class xi extends Nt {
  constructor(t) {
    super(t), this._impl = t;
  }
  readAll() {
    return A(this, void 0, void 0, function* () {
      var t, e, n, s;
      const r = new Array();
      try {
        for (var o = !0, a = de(this), c; c = yield a.next(), t = c.done, !t; o = !0) {
          s = c.value, o = !1;
          const u = s;
          r.push(u);
        }
      } catch (u) {
        e = { error: u };
      } finally {
        try {
          !o && !t && (n = a.return) && (yield n.call(a));
        } finally {
          if (e) throw e.error;
        }
      }
      return r;
    });
  }
  [Symbol.iterator]() {
    throw new Error("AsyncRecordBatchStreamReader is not Iterable");
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
}
class Go extends Ui {
  constructor(t) {
    super(t), this._impl = t;
  }
}
class jl extends xi {
  constructor(t) {
    super(t), this._impl = t;
  }
}
class Zo {
  get numDictionaries() {
    return this._dictionaryIndex;
  }
  get numRecordBatches() {
    return this._recordBatchIndex;
  }
  constructor(t = /* @__PURE__ */ new Map()) {
    this.closed = !1, this.autoDestroy = !0, this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.dictionaries = t;
  }
  isSync() {
    return !1;
  }
  isAsync() {
    return !1;
  }
  isFile() {
    return !1;
  }
  isStream() {
    return !1;
  }
  reset(t) {
    return this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.schema = t, this.dictionaries = /* @__PURE__ */ new Map(), this;
  }
  _loadRecordBatch(t, e) {
    const n = this._loadVectors(t, e, this.schema.fields), s = _({ type: new J(this.schema.fields), length: t.length, children: n });
    return new dt(this.schema, s);
  }
  _loadDictionaryBatch(t, e) {
    const { id: n, isDelta: s } = t, { dictionaries: r, schema: o } = this, a = r.get(n);
    if (s || !a) {
      const c = o.dictionaries.get(n), u = this._loadVectors(t.data, e, [c]);
      return (a && s ? a.concat(new D(u)) : new D(u)).memoize();
    }
    return a.memoize();
  }
  _loadVectors(t, e, n) {
    return new yo(e, t.nodes, t.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(n);
  }
}
class Vi extends Zo {
  constructor(t, e) {
    super(e), this._reader = tn(t) ? new El(this._handle = t) : new Ho(this._handle = t);
  }
  isSync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.iterator]() {
    return this;
  }
  cancel() {
    !this.closed && (this.closed = !0) && (this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
  }
  open(t) {
    return this.closed || (this.autoDestroy = Qo(this, t), this.schema || (this.schema = this._reader.readSchema()) || this.cancel()), this;
  }
  throw(t) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.throw(t) : j;
  }
  return(t) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.return(t) : j;
  }
  next() {
    if (this.closed)
      return j;
    let t;
    const { _reader: e } = this;
    for (; t = this._readNextMessageAndValidate(); )
      if (t.isSchema())
        this.reset(t.header());
      else if (t.isRecordBatch()) {
        this._recordBatchIndex++;
        const n = t.header(), s = e.readMessageBody(t.bodyLength);
        return { done: !1, value: this._loadRecordBatch(n, s) };
      } else if (t.isDictionaryBatch()) {
        this._dictionaryIndex++;
        const n = t.header(), s = e.readMessageBody(t.bodyLength), r = this._loadDictionaryBatch(n, s);
        this.dictionaries.set(n.id, r);
      }
    return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new ko(this.schema) }) : this.return();
  }
  _readNextMessageAndValidate(t) {
    return this._reader.readMessage(t);
  }
}
class Ri extends Zo {
  constructor(t, e) {
    super(e), this._reader = new Cl(this._handle = t);
  }
  isAsync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  cancel() {
    return A(this, void 0, void 0, function* () {
      !this.closed && (this.closed = !0) && (yield this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
    });
  }
  open(t) {
    return A(this, void 0, void 0, function* () {
      return this.closed || (this.autoDestroy = Qo(this, t), this.schema || (this.schema = yield this._reader.readSchema()) || (yield this.cancel())), this;
    });
  }
  throw(t) {
    return A(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.throw(t) : j;
    });
  }
  return(t) {
    return A(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.return(t) : j;
    });
  }
  next() {
    return A(this, void 0, void 0, function* () {
      if (this.closed)
        return j;
      let t;
      const { _reader: e } = this;
      for (; t = yield this._readNextMessageAndValidate(); )
        if (t.isSchema())
          yield this.reset(t.header());
        else if (t.isRecordBatch()) {
          this._recordBatchIndex++;
          const n = t.header(), s = yield e.readMessageBody(t.bodyLength);
          return { done: !1, value: this._loadRecordBatch(n, s) };
        } else if (t.isDictionaryBatch()) {
          this._dictionaryIndex++;
          const n = t.header(), s = yield e.readMessageBody(t.bodyLength), r = this._loadDictionaryBatch(n, s);
          this.dictionaries.set(n.id, r);
        }
      return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new ko(this.schema) }) : yield this.return();
    });
  }
  _readNextMessageAndValidate(t) {
    return A(this, void 0, void 0, function* () {
      return yield this._reader.readMessage(t);
    });
  }
}
class qo extends Vi {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(t, e) {
    super(t instanceof gs ? t : new gs(t), e);
  }
  isSync() {
    return !0;
  }
  isFile() {
    return !0;
  }
  open(t) {
    if (!this.closed && !this._footer) {
      this.schema = (this._footer = this._readFooter()).schema;
      for (const e of this._footer.dictionaryBatches())
        e && this._readDictionaryBatch(this._dictionaryIndex++);
    }
    return super.open(t);
  }
  readRecordBatch(t) {
    var e;
    if (this.closed)
      return null;
    this._footer || this.open();
    const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getRecordBatch(t);
    if (n && this._handle.seek(n.offset)) {
      const s = this._reader.readMessage(U.RecordBatch);
      if (s?.isRecordBatch()) {
        const r = s.header(), o = this._reader.readMessageBody(s.bodyLength);
        return this._loadRecordBatch(r, o);
      }
    }
    return null;
  }
  _readDictionaryBatch(t) {
    var e;
    const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getDictionaryBatch(t);
    if (n && this._handle.seek(n.offset)) {
      const s = this._reader.readMessage(U.DictionaryBatch);
      if (s?.isDictionaryBatch()) {
        const r = s.header(), o = this._reader.readMessageBody(s.bodyLength), a = this._loadDictionaryBatch(r, o);
        this.dictionaries.set(r.id, a);
      }
    }
  }
  _readFooter() {
    const { _handle: t } = this, e = t.size - Ko, n = t.readInt32(e), s = t.readAt(e - n, n);
    return Pn.decode(s);
  }
  _readNextMessageAndValidate(t) {
    var e;
    if (this._footer || this.open(), this._footer && this._recordBatchIndex < this.numRecordBatches) {
      const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getRecordBatch(this._recordBatchIndex);
      if (n && this._handle.seek(n.offset))
        return this._reader.readMessage(t);
    }
    return null;
  }
}
class kl extends Ri {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(t, ...e) {
    const n = typeof e[0] != "number" ? e.shift() : void 0, s = e[0] instanceof Map ? e.shift() : void 0;
    super(t instanceof Mi ? t : new Mi(t, n), s);
  }
  isFile() {
    return !0;
  }
  isAsync() {
    return !0;
  }
  open(t) {
    const e = Object.create(null, {
      open: { get: () => super.open }
    });
    return A(this, void 0, void 0, function* () {
      if (!this.closed && !this._footer) {
        this.schema = (this._footer = yield this._readFooter()).schema;
        for (const n of this._footer.dictionaryBatches())
          n && (yield this._readDictionaryBatch(this._dictionaryIndex++));
      }
      return yield e.open.call(this, t);
    });
  }
  readRecordBatch(t) {
    return A(this, void 0, void 0, function* () {
      var e;
      if (this.closed)
        return null;
      this._footer || (yield this.open());
      const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getRecordBatch(t);
      if (n && (yield this._handle.seek(n.offset))) {
        const s = yield this._reader.readMessage(U.RecordBatch);
        if (s?.isRecordBatch()) {
          const r = s.header(), o = yield this._reader.readMessageBody(s.bodyLength);
          return this._loadRecordBatch(r, o);
        }
      }
      return null;
    });
  }
  _readDictionaryBatch(t) {
    return A(this, void 0, void 0, function* () {
      var e;
      const n = (e = this._footer) === null || e === void 0 ? void 0 : e.getDictionaryBatch(t);
      if (n && (yield this._handle.seek(n.offset))) {
        const s = yield this._reader.readMessage(U.DictionaryBatch);
        if (s?.isDictionaryBatch()) {
          const r = s.header(), o = yield this._reader.readMessageBody(s.bodyLength), a = this._loadDictionaryBatch(r, o);
          this.dictionaries.set(r.id, a);
        }
      }
    });
  }
  _readFooter() {
    return A(this, void 0, void 0, function* () {
      const { _handle: t } = this;
      t._pending && (yield t._pending);
      const e = t.size - Ko, n = yield t.readInt32(e), s = yield t.readAt(e - n, n);
      return Pn.decode(s);
    });
  }
  _readNextMessageAndValidate(t) {
    return A(this, void 0, void 0, function* () {
      if (this._footer || (yield this.open()), this._footer && this._recordBatchIndex < this.numRecordBatches) {
        const e = this._footer.getRecordBatch(this._recordBatchIndex);
        if (e && (yield this._handle.seek(e.offset)))
          return yield this._reader.readMessage(t);
      }
      return null;
    });
  }
}
class Pl extends Vi {
  constructor(t, e) {
    super(t, e);
  }
  _loadVectors(t, e, n) {
    return new Tc(e, t.nodes, t.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(n);
  }
}
function Qo(i, t) {
  return t && typeof t.autoDestroy == "boolean" ? t.autoDestroy : i.autoDestroy;
}
function* Bs(i) {
  const t = Nt.from(i);
  try {
    if (!t.open({ autoDestroy: !1 }).closed)
      do
        yield t;
      while (!t.reset().open().closed);
  } finally {
    t.cancel();
  }
}
function Ds(i) {
  return St(this, arguments, function* () {
    const e = yield O(Nt.from(i));
    try {
      if (!(yield O(e.open({ autoDestroy: !1 }))).closed)
        do
          yield yield O(e);
        while (!(yield O(e.reset().open())).closed);
    } finally {
      yield O(e.cancel());
    }
  });
}
function $l(i) {
  return new Ui(new Pl(i));
}
function Wl(i) {
  const t = i.peek(ti + 7 & -8);
  return t && t.byteLength >= 4 ? Zn(t) ? new Go(new qo(i.read())) : new Ui(new Vi(i)) : new Ui(new Vi((function* () {
  })()));
}
function Yl(i) {
  return A(this, void 0, void 0, function* () {
    const t = yield i.peek(ti + 7 & -8);
    return t && t.byteLength >= 4 ? Zn(t) ? new Go(new qo(yield i.read())) : new xi(new Ri(i)) : new xi(new Ri((function() {
      return St(this, arguments, function* () {
      });
    })()));
  });
}
function Jl(i) {
  return A(this, void 0, void 0, function* () {
    const { size: t } = yield i.stat(), e = new Mi(i, t);
    return t >= zl && Zn(yield e.readAt(0, ti + 7 & -8)) ? new jl(new kl(e)) : new xi(new Ri(e));
  });
}
function Hl(i) {
  const t = Nt.from(i);
  return ze(t) ? t.then((e) => Hl(e)) : t.isAsync() ? t.readAll().then((e) => new nt(e)) : new nt(t.readAll());
}
export {
  Hl as a,
  lo as m,
  Ql as t
};
